(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["audio-player"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/audio-player/audio-player.ts — do not edit directly.
// src/snippets/audio-player/audio-player.ts
"use strict";
(() => {
  // src/snippets/audio-player/audio-player.ts
  var AudioPlayer = class extends HTMLElement {
    constructor() {
      super();
      this.audio = null;
      this.syncVideo = false;
      this.isAudioPlaying = false;
      this.videos = [];
      this.section = null;
      this.playBtn = null;
      this.iconPlay = null;
      this.iconPause = null;
      this.waveform = null;
      this.timeEl = null;
      this.durationEl = null;
      this.boundTimeUpdate = this.onTimeUpdate.bind(this);
      this.boundEnded = this.onEnded.bind(this);
      this.boundLoaded = this.onLoaded.bind(this);
      this.boundTogglePlay = () => {
        void this.togglePlay();
      };
    }
    connectedCallback() {
      this.syncVideo = this.getAttribute("data-sync-video") === "true";
      if (this.syncVideo) {
        this.section = this.closest("[data-section-id]") ?? this.closest("section");
        const allVideos = this.getSyncVideos();
        if (allVideos.length === 0) {
          console.warn(
            "[c-audio-player] sync_video enabled but no c-container-video found in section."
          );
          return;
        }
        this.audio = this.getActiveSyncVideo() ?? allVideos[0];
        this.videos = allVideos.filter((video) => video !== this.audio);
        allVideos.forEach((video) => {
          video.muted = true;
          video.playsInline = true;
          video.setAttribute("playsinline", "");
        });
        if (this.section) {
          this.section.querySelectorAll("c-container-video [data-mute-btn]").forEach((btn) => btn.setAttribute("hidden", ""));
        }
      } else {
        const src = this.getAttribute("data-src");
        if (!src) {
          console.warn("[c-audio-player] No data-src attribute found.");
          return;
        }
        this.audio = new Audio(src);
        this.audio.loop = this.getAttribute("data-loop") === "true";
        this.audio.preload = "metadata";
      }
      this.playBtn = this.querySelector("[data-play-btn]");
      this.iconPlay = this.querySelector("[data-icon-play]");
      this.iconPause = this.querySelector("[data-icon-pause]");
      this.waveform = this.querySelector("[data-waveform]");
      this.timeEl = this.querySelector("[data-time]");
      this.durationEl = this.querySelector("[data-duration]");
      this.playBtn?.addEventListener("click", this.boundTogglePlay);
      this.waveform?.addEventListener("click", (e) => this.seek(e));
      this.bindMediaEvents(this.audio);
    }
    disconnectedCallback() {
      if (this.syncVideo && this.audio) {
        ;
        this.audio.muted = true;
      } else {
        this.audio?.pause();
      }
      this.unbindMediaEvents(this.audio);
      this.playBtn?.removeEventListener("click", this.boundTogglePlay);
      this.audio = null;
      this.isAudioPlaying = false;
      this.videos = [];
      this.section = null;
    }
    async togglePlay() {
      if (!this.audio) return;
      if (this.syncVideo) {
        const video = this.getActiveSyncVideo();
        if (!video) return;
        this.setActiveMedia(video);
        if (!this.isAudioPlaying) {
          video.currentTime = 0;
          video.muted = false;
          video.playsInline = true;
          this.videosSync(0);
          const canPlay = await this.playMedia(video);
          if (!canPlay) {
            video.muted = true;
            this.isAudioPlaying = false;
            this.setPlaying(false);
            return;
          }
          this.isAudioPlaying = true;
          this.setPlaying(true);
        } else {
          video.muted = true;
          this.isAudioPlaying = false;
          this.setPlaying(false);
          if (this.waveform) {
            this.waveform.style.setProperty("--progress", "0%");
            this.waveform.setAttribute("aria-valuenow", "0");
          }
          if (this.timeEl) this.timeEl.textContent = "00:00";
        }
      } else {
        if (this.audio.paused) {
          const canPlay = await this.playMedia(this.audio);
          if (canPlay) this.setPlaying(true);
        } else {
          this.audio.pause();
          this.setPlaying(false);
        }
      }
    }
    setPlaying(playing) {
      if (playing) {
        this.iconPlay?.setAttribute("hidden", "");
        this.iconPause?.removeAttribute("hidden");
        this.setAttribute("playing", "");
        if (this.playBtn) this.playBtn.setAttribute("aria-label", "Pause");
      } else {
        this.iconPause?.setAttribute("hidden", "");
        this.iconPlay?.removeAttribute("hidden");
        this.removeAttribute("playing");
        if (this.playBtn) this.playBtn.setAttribute("aria-label", "Play");
      }
    }
    onLoaded() {
      if (this.durationEl && this.audio) {
        this.durationEl.textContent = this.formatTime(this.audio.duration);
      }
    }
    onTimeUpdate() {
      if (this.syncVideo && !this.isAudioPlaying) return;
      if (!this.audio?.duration) return;
      const progress = this.audio.currentTime / this.audio.duration;
      if (this.waveform) {
        this.waveform.style.setProperty("--progress", `${progress * 100}%`);
        this.waveform.setAttribute(
          "aria-valuenow",
          String(Math.round(progress * 100))
        );
      }
      if (this.timeEl) {
        this.timeEl.textContent = this.formatTime(this.audio.currentTime);
      }
    }
    onEnded() {
      this.setPlaying(false);
      this.videos.forEach((v) => v.pause());
      this.videosSync(0);
      if (this.waveform) {
        this.waveform.style.setProperty("--progress", "0%");
        this.waveform.setAttribute("aria-valuenow", "0");
      }
      if (this.timeEl) this.timeEl.textContent = "00:00";
    }
    bindMediaEvents(media) {
      media?.addEventListener("timeupdate", this.boundTimeUpdate);
      media?.addEventListener("ended", this.boundEnded);
      media?.addEventListener("loadedmetadata", this.boundLoaded);
    }
    unbindMediaEvents(media) {
      media?.removeEventListener("timeupdate", this.boundTimeUpdate);
      media?.removeEventListener("ended", this.boundEnded);
      media?.removeEventListener("loadedmetadata", this.boundLoaded);
    }
    setActiveMedia(video) {
      if (this.audio === video) return;
      this.unbindMediaEvents(this.audio);
      this.audio = video;
      this.bindMediaEvents(this.audio);
      this.videos = this.getSyncVideos().filter((item) => item !== video);
    }
    getSyncVideos() {
      if (!this.section) return [];
      return Array.from(
        this.section.querySelectorAll("c-container-video video")
      );
    }
    getActiveSyncVideo() {
      const videos = this.getSyncVideos();
      if (videos.length === 0) return null;
      return videos.find((video) => {
        const wrapper = video.parentElement;
        if (!wrapper) return false;
        return window.getComputedStyle(wrapper).display !== "none";
      }) ?? videos[0];
    }
    async playMedia(media) {
      try {
        if (media instanceof HTMLVideoElement) {
          media.playsInline = true;
          media.setAttribute("playsinline", "");
        }
        if (media.networkState === media.NETWORK_EMPTY) media.load();
        await media.play();
        return true;
      } catch (error) {
        console.warn("[c-audio-player] Media play prevented.", error);
        return false;
      }
    }
    seek(e) {
      if (!this.audio?.duration || !this.waveform) return;
      if (this.syncVideo && !this.isAudioPlaying) return;
      const rect = this.waveform.getBoundingClientRect();
      const ratio = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      this.audio.currentTime = ratio * this.audio.duration;
      this.waveform.style.setProperty("--progress", `${ratio * 100}%`);
      this.videosSync(ratio * this.audio.duration);
    }
    formatTime(secs) {
      const m = Math.floor(secs / 60).toString().padStart(2, "0");
      const s = Math.floor(secs % 60).toString().padStart(2, "0");
      return `${m}:${s}`;
    }
    videosSync(time) {
      this.videos.forEach((v) => {
        v.currentTime = time;
      });
    }
  };
  if (!window.customElements.get("c-audio-player")) {
    window.customElements.define("c-audio-player", AudioPlayer);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["booxi-countdown"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/booxi-countdown/booxi-countdown.ts — do not edit directly.
// src/snippets/booxi-countdown/booxi-countdown.ts
"use strict";
(() => {
  // src/snippets/booxi-countdown/booxi-countdown.ts
  var RELOAD_DELAY = 500;
  var SETTINGS_POLL_MS = 250;
  var SETTINGS_MAX_ATTEMPTS = 24;
  var reloadTimer = null;
  function scheduleReload() {
    if (reloadTimer !== null) return;
    reloadTimer = window.setTimeout(() => window.location.reload(), RELOAD_DELAY);
  }
  function holdMinutes() {
    const value = window.booxiApp?.settings?.timer_remove_product;
    return typeof value === "number" && value > 0 ? value : null;
  }
  function formatRemaining(ms) {
    const total = Math.ceil(ms / 1e3);
    const minutes = Math.floor(total / 60);
    const seconds = total % 60;
    return `${minutes}:${String(seconds).padStart(2, "0")}`;
  }
  var BooxiCountdown = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.ticker = null;
      this.waiter = null;
      this.expiring = false;
      this.lastText = null;
    }
    connectedCallback() {
      this.waitForSettings();
    }
    disconnectedCallback() {
      this.stop();
    }
    waitForSettings(attempt = 0) {
      if (holdMinutes() !== null) {
        this.start();
        return;
      }
      if (attempt >= SETTINGS_MAX_ATTEMPTS) return;
      this.waiter = window.setTimeout(
        () => this.waitForSettings(attempt + 1),
        SETTINGS_POLL_MS
      );
    }
    start() {
      this.tick();
      this.ticker = window.setInterval(() => this.tick(), 1e3);
    }
    stop() {
      if (this.ticker !== null) window.clearInterval(this.ticker);
      if (this.waiter !== null) window.clearTimeout(this.waiter);
      this.ticker = null;
      this.waiter = null;
    }
    /** Attributs relus à chaque tick, jamais mémorisés : l'éditeur les réécrit en place. */
    deadline() {
      const minutes = holdMinutes();
      const stamp = Number(this.dataset.timestamp);
      if (minutes === null || !Number.isFinite(stamp) || stamp <= 0) return null;
      return stamp + minutes * 6e4;
    }
    tick() {
      const deadline = this.deadline();
      if (deadline === null) return;
      const remaining = deadline - Date.now();
      if (remaining > 0) {
        const template = this.dataset.template || "__TIME__";
        this.render(template.replace("__TIME__", formatRemaining(remaining)));
        return;
      }
      this.render(this.dataset.expired || "");
      this.stop();
      this.expire();
    }
    render(text) {
      if (text !== this.lastText) {
        const slot = this.querySelector("[data-booxi-countdown-text]") ?? this;
        slot.textContent = text;
        this.lastText = text;
      }
      if (this.hidden) this.hidden = false;
    }
    /**
     * L'app Booxi retire elle-même la ligne à l'échéance, mais sans rafraîchir la
     * page : la ligne restait visible jusqu'au chargement suivant. On la retire
     * donc de notre côté — un échec signifie que l'app a gagné la course, la ligne
     * n'existe plus — puis on recharge, pour que totaux, franco de port et
     * emballages repartent d'un panier juste.
     */
    async expire() {
      if (this.expiring) return;
      this.expiring = true;
      const key = this.dataset.lineKey;
      if (key) {
        const root = window.Shopify?.routes?.root || "/";
        try {
          await fetch(`${root}cart/change.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: key, quantity: 0 })
          });
        } catch {
        }
      }
      scheduleReload();
    }
  };
  if (!window.customElements.get("c-booxi-countdown")) {
    window.customElements.define("c-booxi-countdown", BooxiCountdown);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["calendar-button"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/calendar-button/calendar-button.ts — do not edit directly.
// src/snippets/calendar-button/calendar-button.ts
"use strict";
(() => {
  // src/shared/calendar/calendar-button.ts
  var PRODID = "-//Diptyque//Calendar Event//FR";
  var UID_DOMAIN = "diptyqueparis.com";
  var FOLD_LIMIT = 75;
  var encoder = new TextEncoder();
  function escapeText(value) {
    return value.replace(/\\/g, "\\\\").replace(/[;,]/g, "\\$&").replace(/\r\n|\r|\n/g, "\\n");
  }
  function foldLine(line) {
    if (encoder.encode(line).length <= FOLD_LIMIT) return line;
    const parts = [];
    let chunk = "";
    let bytes = 0;
    let limit = FOLD_LIMIT;
    for (const char of line) {
      const size = encoder.encode(char).length;
      if (bytes + size > limit) {
        parts.push(chunk);
        chunk = "";
        bytes = 0;
        limit = FOLD_LIMIT - 1;
      }
      chunk += char;
      bytes += size;
    }
    parts.push(chunk);
    return parts.join("\r\n ");
  }
  function toUtcStamp(epochSeconds) {
    return new Date(epochSeconds * 1e3).toISOString().replace(/[-:]/g, "").replace(/\.\d+Z$/, "Z");
  }
  function slugify(value) {
    return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9]+/g, "-").replace(/^-+|-+$/g, "").toLowerCase();
  }
  var CalendarButton = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.handleClick = (event) => {
        const target = event.target;
        if (!target?.closest("button")) return;
        this.download();
      };
    }
    connectedCallback() {
      this.addEventListener("click", this.handleClick);
    }
    /** Attributes are read here, never cached: the editor rewrites them in place. */
    timestamp(raw) {
      if (!raw) return null;
      const value = Number(raw);
      return Number.isFinite(value) ? value : null;
    }
    download() {
      const start = this.timestamp(this.dataset.startTs);
      const end = this.timestamp(this.dataset.endTs);
      if (start === null || end === null) {
        console.error(
          "c-calendar-button: data-start-ts / data-end-ts must be epoch seconds"
        );
        return;
      }
      const title = this.dataset.title || "";
      const slug = slugify(title) || "evenement";
      const startStamp = toUtcStamp(start);
      const lines = [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        `PRODID:${PRODID}`,
        "CALSCALE:GREGORIAN",
        "METHOD:PUBLISH",
        "BEGIN:VEVENT",
        // Deterministic: re-downloading updates the event instead of duplicating it.
        `UID:${startStamp}-${slug}@${UID_DOMAIN}`,
        `DTSTAMP:${toUtcStamp(Date.now() / 1e3)}`,
        `DTSTART:${startStamp}`,
        `DTEND:${toUtcStamp(end)}`,
        `SUMMARY:${escapeText(title)}`,
        `DESCRIPTION:${escapeText(this.dataset.description || "")}`,
        `LOCATION:${escapeText(this.dataset.location || "")}`,
        "STATUS:CONFIRMED",
        "SEQUENCE:0",
        "BEGIN:VALARM",
        "TRIGGER:-PT15M",
        "ACTION:DISPLAY",
        "DESCRIPTION:Reminder",
        "END:VALARM",
        "END:VEVENT",
        "END:VCALENDAR"
      ];
      const blob = new Blob([lines.map(foldLine).join("\r\n")], {
        type: "text/calendar;charset=utf-8"
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${slug}.ics`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  };
  function defineCalendarButton() {
    if (!window.customElements.get("c-calendar-button")) {
      window.customElements.define("c-calendar-button", CalendarButton);
    }
  }

  // src/snippets/calendar-button/calendar-button.ts
  defineCalendarButton();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-item-quantity"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/cart-item-quantity/cart-item-quantity.ts — do not edit directly.
// src/snippets/cart-item-quantity/cart-item-quantity.ts
"use strict";
(() => {
  // src/shared/cart-limit-error/cart-limit-error.ts
  var ERROR_MESSAGE_SELECTOR = "[data-cart-limit-error-message]";
  var ERROR_TEXT_SELECTOR = "[data-cart-limit-error-text]";
  var OPEN_ENGRAVING_PANEL_SELECTOR = "c-engraving-panel.is-open";
  var SEARCH_DIALOG_SELECTOR = "dialog[data-search-dialog]";
  var QUANTITY_LIMIT_PATTERNS = [
    /can'?t add more/i,
    /maximum allowed quantity/i,
    /maximum quantity/i,
    /quantity.*exceeded/i,
    /only add \d+/i
  ];
  function getErrorMessageEl() {
    return document.querySelector(ERROR_MESSAGE_SELECTOR);
  }
  function getDefaultMessage() {
    return window.cartStrings?.addToCartLimitError ?? "The maximum allowed quantity for this product has been exceeded.";
  }
  function isCartQuantityLimitError(status, description) {
    if (status !== 422) return false;
    const normalized = description.trim();
    if (normalized.length === 0) return true;
    return QUANTITY_LIMIT_PATTERNS.some((pattern) => pattern.test(normalized));
  }
  function closeOpenEngravingPanels() {
    document.querySelectorAll(OPEN_ENGRAVING_PANEL_SELECTOR).forEach((panel) => {
      ;
      panel.close();
    });
  }
  function closeHeaderSearchIfOpen() {
    const openDialogs = document.querySelectorAll(
      `${SEARCH_DIALOG_SELECTOR}[open]`
    );
    if (openDialogs.length === 0) return;
    document.documentElement.classList.remove("is-overflow-hidden");
    openDialogs.forEach((dialog) => {
      dialog.close();
    });
  }
  function showCartLimitError(message) {
    closeHeaderSearchIfOpen();
    const errorMessage = getErrorMessageEl();
    if (!errorMessage) return;
    const textEl = errorMessage.querySelector(ERROR_TEXT_SELECTOR);
    if (textEl) {
      textEl.textContent = message ?? getDefaultMessage();
    }
    errorMessage.classList.remove("hidden");
    errorMessage.removeAttribute("hidden");
    errorMessage.setAttribute("aria-hidden", "false");
    closeOpenEngravingPanels();
    window.scrollTo(0, 0);
  }
  function hideCartLimitError() {
    const errorMessage = getErrorMessageEl();
    if (!errorMessage) return;
    const textEl = errorMessage.querySelector(ERROR_TEXT_SELECTOR);
    if (textEl) {
      textEl.textContent = "";
    }
    errorMessage.classList.add("hidden");
    errorMessage.setAttribute("hidden", "");
    errorMessage.setAttribute("aria-hidden", "true");
  }

  // src/shared/cart-a11y/cart-a11y.ts
  var CART_A11Y_PENDING_KEY = "cart-a11y-announce";
  function queueCartStatusForReload(message) {
    const trimmed = message.trim();
    if (!trimmed) return;
    try {
      sessionStorage.setItem(CART_A11Y_PENDING_KEY, trimmed);
    } catch {
    }
  }
  function fillCartStatusTemplate(template, values) {
    let result = template;
    if (values.title !== void 0) {
      result = result.replace(/__TITLE__/g, values.title);
    }
    if (values.quantity !== void 0) {
      result = result.replace(/__QUANTITY__/g, String(values.quantity));
    }
    return result;
  }

  // src/snippets/cart-item-quantity/cart-item-quantity.ts
  var CartItemQuantity = class extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="number"]');
      this.minusButton = this.querySelector('[data-action="minus"]');
      this.plusButton = this.querySelector('[data-action="plus"]');
      this.allSample = [
        ...document.querySelectorAll("[data-parent-id]")
      ];
      this.varaintId = this.dataset.variantId;
      this.urlChange = this.dataset.url;
      this.lineIndex = this.getAttribute("data-line");
      this.originalQuantity = parseInt(
        this.getAttribute("data-original-quantity") || this.input.value,
        10
      );
      this.maxQuantity = parseInt(this.input.getAttribute("max") || "0", 10);
      this.init();
    }
    init() {
      this.bindEvents();
      this.setOriginalQuantity();
      this.updateButtonStates();
    }
    bindEvents() {
      if (this.minusButton) {
        this.minusButton.addEventListener("click", this.handleMinus.bind(this));
      }
      if (this.plusButton) {
        this.plusButton.addEventListener("click", this.handlePlus.bind(this));
      }
      this.input.addEventListener("blur", this.handleBlur.bind(this));
      this.input.addEventListener("keypress", this.handleKeypress.bind(this));
      this.input.addEventListener("keydown", this.handleKeydown.bind(this));
      this.input.addEventListener("input", this.handleInput.bind(this));
    }
    syncErrorVisibility(quantity) {
      if (this.maxQuantity > 0 && quantity > this.maxQuantity) {
        showCartLimitError();
        return;
      }
      hideCartLimitError();
    }
    handleMinus() {
      const currentValue = parseInt(this.input.value, 10);
      if (currentValue > 1) {
        this.input.value = (currentValue - 1).toString();
        this.updateQuantity(currentValue - 1);
        this.updateButtonStates();
        this.syncErrorVisibility(currentValue - 1);
      }
    }
    handlePlus() {
      const currentValue = parseInt(this.input.value, 10);
      if (this.maxQuantity > 0 && currentValue >= this.maxQuantity) {
        showCartLimitError();
        return;
      }
      if (currentValue < this.maxQuantity || this.maxQuantity <= 0) {
        this.input.value = (currentValue + 1).toString();
        this.updateQuantity(currentValue + 1);
        this.updateButtonStates();
        this.syncErrorVisibility(currentValue + 1);
      }
    }
    handleBlur() {
      const cleanStr = this.input.value.replace(/[^0-9]/g, "");
      let newQuantity = parseInt(cleanStr, 10);
      if (Number.isNaN(newQuantity) || newQuantity < 1) {
        this.input.value = "1";
        newQuantity = 1;
      } else if (this.maxQuantity > 0 && newQuantity > this.maxQuantity) {
        this.input.value = this.maxQuantity.toString();
        newQuantity = this.maxQuantity;
        showCartLimitError();
      } else {
        hideCartLimitError();
      }
      if (newQuantity !== this.originalQuantity) {
        this.updateQuantity(newQuantity);
      }
      this.updateButtonStates();
    }
    handleKeypress(e) {
      e.preventDefault();
      if (e.key === "Enter") {
        this.input.blur();
      }
    }
    handleKeydown(e) {
      if ([8, 9, 27, 13, 37, 38, 39, 40].indexOf(e.keyCode) !== -1) {
        return;
      }
      if (e.keyCode >= 48 && e.keyCode <= 57) {
        return;
      }
      if (e.keyCode >= 96 && e.keyCode <= 105) {
        return;
      }
      e.preventDefault();
    }
    handleInput() {
      const cleanValue = this.input.value.replace(/[^0-9]/g, "");
      if (cleanValue !== this.input.value) {
        this.input.value = cleanValue;
      }
      const currentValue = parseInt(cleanValue, 10);
      this.input.classList.remove("error");
      if (this.maxQuantity > 0 && currentValue > this.maxQuantity) {
        this.input.value = this.maxQuantity.toString();
        this.input.classList.add("error");
        showCartLimitError();
      } else if (currentValue < 1) {
        this.input.classList.add("error");
      } else {
        hideCartLimitError();
      }
      this.updateButtonStates();
    }
    updateButtonStates() {
      const currentValue = parseInt(this.input.value, 10);
      if (this.minusButton) {
        this.minusButton.classList.toggle(
          "cart__item-quantity-button--disabled",
          currentValue <= 1
        );
      }
      if (this.plusButton) {
        this.plusButton.classList.toggle(
          "cart__item-quantity-button--disabled",
          this.maxQuantity > 0 && currentValue >= this.maxQuantity
        );
      }
    }
    updateQuantity(quantity) {
      const formData = new FormData();
      const sampleProduct = this.allSample.find(
        (sample) => sample.dataset.parentId == this.varaintId
      );
      if (sampleProduct != void 0) {
        formData.append(
          `updates[${sampleProduct.dataset.childId}]`,
          quantity.toString()
        );
      }
      formData.append(`updates[${this.varaintId}]`, quantity.toString());
      fetch((window.Shopify?.routes?.root || "/") + "cart/update.js", {
        method: "POST",
        body: formData
      }).then(async (response) => {
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          const rawMessage = errorData.description || errorData.message || `Erreur ${response.status}`;
          if (isCartQuantityLimitError(response.status, rawMessage)) {
            showCartLimitError();
          } else {
            showCartLimitError(rawMessage);
          }
          this.reset();
          return;
        }
        hideCartLimitError();
        this.queueQuantityUpdatedAnnouncement(quantity);
        window.location.reload();
      }).catch(() => {
        this.reset();
      });
    }
    /**
     * Persists a quantity-updated message for the next cart page load.
     */
    queueQuantityUpdatedAnnouncement(quantity) {
      const title = this.dataset.productTitle?.trim() || "Item";
      const template = this.dataset.quantityUpdatedTemplate || "__TITLE__ quantity updated to __QUANTITY__";
      queueCartStatusForReload(
        fillCartStatusTemplate(template, { title, quantity })
      );
    }
    setOriginalQuantity() {
      this.originalQuantity = parseInt(this.input.value, 10);
      this.setAttribute("data-original-quantity", this.input.value);
    }
    updateOriginalQuantity() {
      this.originalQuantity = parseInt(this.input.value, 10);
      this.setOriginalQuantity();
    }
    reset() {
      this.input.value = this.originalQuantity.toString();
      this.input.classList.remove("error");
      this.updateButtonStates();
    }
    get quantity() {
      return parseInt(this.input.value, 10);
    }
    set quantity(value) {
      this.input.value = value.toString();
      this.updateButtonStates();
    }
  };
  customElements.define("cart-item-quantity", CartItemQuantity);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-limit-error"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/cart-limit-error/cart-limit-error.ts — do not edit directly.
// src/snippets/cart-limit-error/cart-limit-error.ts
"use strict";
(() => {
  // src/shared/cart-limit-error/cart-limit-error.ts
  var ERROR_MESSAGE_SELECTOR = "[data-cart-limit-error-message]";
  var ERROR_TEXT_SELECTOR = "[data-cart-limit-error-text]";
  function getErrorMessageEl() {
    return document.querySelector(ERROR_MESSAGE_SELECTOR);
  }
  function hideCartLimitError() {
    const errorMessage = getErrorMessageEl();
    if (!errorMessage) return;
    const textEl = errorMessage.querySelector(ERROR_TEXT_SELECTOR);
    if (textEl) {
      textEl.textContent = "";
    }
    errorMessage.classList.add("hidden");
    errorMessage.setAttribute("hidden", "");
    errorMessage.setAttribute("aria-hidden", "true");
  }

  // src/snippets/cart-limit-error/cart-limit-error.ts
  var CartLimitError = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.errorMessage = null;
      this.errorMessageButton = null;
      this.handleErrorMessageClose = () => {
        hideCartLimitError();
      };
    }
    connectedCallback() {
      this.errorMessage = this.querySelector("[data-cart-limit-error-message]");
      this.errorMessageButton = this.errorMessage?.querySelector(
        ".cart-limit-error_message_button"
      ) ?? null;
      this.errorMessageButton?.addEventListener(
        "click",
        this.handleErrorMessageClose
      );
    }
    disconnectedCallback() {
      this.errorMessageButton?.removeEventListener(
        "click",
        this.handleErrorMessageClose
      );
    }
  };
  if (!window.customElements.get("c-cart-limit-error")) {
    window.customElements.define("c-cart-limit-error", CartLimitError);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-packaging"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/cart-packaging-jp-hk/cart-packaging-jp-hk.ts — do not edit directly.
// src/snippets/cart-packaging-jp-hk/cart-packaging-jp-hk.ts
"use strict";
(() => {
  // src/shared/utils/section-render.ts
  var SECTION_PREFIX = "shopify-section-";
  function getSectionId(el) {
    if (!el?.id?.startsWith(SECTION_PREFIX)) return null;
    return el.id.slice(SECTION_PREFIX.length);
  }
  function closestSectionId(el) {
    const wrapper = el?.closest(`[id^="${SECTION_PREFIX}"]`);
    return getSectionId(wrapper);
  }
  function buildUrl(base, params) {
    const url = new URL(base ?? window.location.pathname, window.location.origin);
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.set(key, value);
    }
    return url.toString();
  }
  function withQuery(params, query) {
    if (!query) return params;
    const extra = Object.fromEntries(
      Object.entries(query).map(([k, v]) => [k, String(v)])
    );
    return { ...extra, ...params };
  }
  async function fetchSections(ids, options = {}) {
    const url = buildUrl(
      options.url,
      withQuery({ sections: ids.join(",") }, options.query)
    );
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) throw new Error(`Sections fetch ${response.status}`);
    return response.json();
  }
  function swapInner(html, selector) {
    const selectors = Array.isArray(selector) ? selector : [selector];
    const doc = new DOMParser().parseFromString(html, "text/html");
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((element) => {
        const source = element.dataset.id ? doc.querySelector(`${sel}[data-id="${element.dataset.id}"]`) : doc.querySelector(sel);
        if (source) element.innerHTML = source.innerHTML;
      });
    });
  }
  function swapSection(id, html) {
    const live = document.getElementById(`${SECTION_PREFIX}${id}`);
    if (!live) return;
    const doc = new DOMParser().parseFromString(html, "text/html");
    const next = doc.getElementById(`${SECTION_PREFIX}${id}`) || doc.body.firstElementChild;
    if (next instanceof HTMLElement) {
      live.replaceWith(next);
    } else {
      live.hidden = true;
    }
  }
  async function renderSections(targets, options = {}) {
    if (targets.length === 0) return;
    const map = options.sections ?? await fetchSections(
      targets.map((t) => t.id),
      options
    );
    for (const target of targets) {
      const html = map[target.id];
      if (typeof html !== "string") continue;
      if (target.selector) {
        swapInner(html, target.selector);
      } else {
        swapSection(target.id, html);
      }
    }
  }

  // src/shared/cart-a11y/cart-a11y.ts
  var CART_LIVE_STATUS_ID = "cart-live-status";
  var FOCUS_ANNOUNCE_DELAY_MS = 300;
  function getOrCreateCartLiveRegion() {
    let region = document.getElementById(CART_LIVE_STATUS_ID);
    if (region instanceof HTMLElement) {
      return region;
    }
    region = document.createElement("div");
    region.id = CART_LIVE_STATUS_ID;
    region.className = "sr-only form-status";
    region.setAttribute("role", "status");
    region.setAttribute("aria-live", "polite");
    region.setAttribute("aria-atomic", "true");
    document.body.appendChild(region);
    return region;
  }
  function announceCartStatus(message, options = {}) {
    const trimmed = message.trim();
    if (!trimmed) return;
    const shouldFocus = options.focus !== false;
    const region = getOrCreateCartLiveRegion();
    if (shouldFocus) {
      region.setAttribute("aria-live", "off");
      region.setAttribute("tabindex", "-1");
      region.textContent = trimmed;
      region.focus({ preventScroll: true });
      window.setTimeout(() => {
        region.setAttribute("aria-live", "polite");
      }, FOCUS_ANNOUNCE_DELAY_MS);
      return;
    }
    region.textContent = "";
    requestAnimationFrame(() => {
      region.textContent = trimmed;
    });
  }
  function delayFocusAfterAnnounce(callback) {
    window.setTimeout(callback, FOCUS_ANNOUNCE_DELAY_MS);
  }
  function fillCartStatusTemplate(template, values) {
    let result = template;
    if (values.title !== void 0) {
      result = result.replace(/__TITLE__/g, values.title);
    }
    if (values.quantity !== void 0) {
      result = result.replace(/__QUANTITY__/g, String(values.quantity));
    }
    return result;
  }

  // src/shared/cart-packaging/cart-packaging-base.ts
  var CartPackagingBase = class extends HTMLElement {
    constructor() {
      super();
      // File des mutations panier. Un verrou booléen jetait les clics reçus pendant
      // une requête : choisir le coffret puis « + » dans la foulée perdait le sac,
      // `add.js` prenant 1,5 à 2 s. Chaque action met maintenant l'interface à jour
      // tout de suite et programme une synchro, exécutée après celles en cours. Une
      // synchro lit l'état de l'interface au moment où elle part : une seule en
      // attente par type suffit à rattraper plusieurs clics.
      this.queue = Promise.resolve();
      this.pendingSyncs = /* @__PURE__ */ new Set();
      this.queuedSyncs = 0;
      this.boxContainer = this.querySelector("[data-box-container]");
      this.boxCheckbox = this.querySelector("[data-box-toggle]");
      this.standardRadio = this.querySelector("[data-box-standard]");
      this.packagingMessageContainer = this.querySelector(
        "[data-box-message-container]"
      );
      this.messageFields = Array.from(
        this.querySelectorAll(
          "[data-packaging-message-input], [data-packaging-message-textarea], #packaging-message"
        )
      );
      this.quantityContainer = this.querySelector(
        "[data-packaging-message-quantity-container]"
      );
      this.packagingId = this.querySelector("[data-packaging-id]");
      this.minusButton = this.querySelector("[data-packaging-message-minus]");
      this.plusButton = this.querySelector("[data-packaging-message-plus]");
      this.quantityInput = this.querySelector("[data-packaging-message-quantity]");
      this.messageContent = this.querySelector("[data-packaging-message-content]");
      this.submitButton = this.querySelector("[data-packaging-message-submit]");
      this.noteContainer = this.querySelector(
        "[data-packaging-message-note-container]"
      );
      this.noteText = this.querySelector("[data-packaging-message-note-text]");
      this.noteButton = this.querySelector("[data-packaging-message-update-note]");
      this.maxQuantity = parseInt(this.quantityInput?.getAttribute("max") ?? "") || 0;
      this.currentQuantity = parseInt(this.quantityInput?.value ?? "") || 0;
      this.boxInCart = this.packagingMessageContainer?.getAttribute(
        "data-box-message-container"
      ) === "true";
      this.savedMessage = this.getMessageAttributes();
    }
    // Sections to refresh after a cart mutation; the cart Ajax API returns their
    // HTML in `data.sections`, so packaging changes refresh the cart + header in
    // one round trip.
    //
    // The ids requested must be exactly the ones swapped (same fix as
    // product-form): a hidden `name="sections"` input used to request
    // `cart-summary`, while the live section is `template--…__cart-summary` —
    // Shopify answered under the requested key and the summary never refreshed.
    // Resolved per request: the summary wrapper is replaced by each outer swap.
    //
    // The packaging block itself (cart-samples / [data-cart-packaging]) is
    // intentionally NOT re-rendered: re-rendering it would make any unsaved
    // section settings fall back to their schema defaults. Instead the message
    // "saved + Edit" UI is toggled client-side via applyMessageState().
    getSectionTargets() {
      const summaryId = closestSectionId(
        document.querySelector("[data-cart-summary]")
      );
      return [
        { id: "header", selector: [".header__action-link--cart"] },
        { id: "popup-add-to-cart", selector: ["[data-popup-atc-container]"] },
        {
          id: "main-cart",
          selector: [
            "[data-cart-items]",
            ".cart__items-list",
            ".engraving-panel-container-cart"
          ]
        },
        // Outer swap, as in product-form: the summary content is gated by
        // `cart.item_count`, which an inner swap cannot follow.
        ...summaryId ? [{ id: summaryId }] : []
      ];
    }
    cartUrl(path) {
      return `${window.Shopify?.routes?.root || "/"}${path}`;
    }
    schedule(kind, sync) {
      if (this.pendingSyncs.has(kind)) return;
      this.pendingSyncs.add(kind);
      this.queuedSyncs++;
      this.boxContainer?.setAttribute("aria-busy", "true");
      this.queue = this.queue.then(async () => {
        this.pendingSyncs.delete(kind);
        try {
          await sync();
        } catch (error) {
          console.error(`[CartPackaging] ${kind} sync failed:`, error);
        } finally {
          if (--this.queuedSyncs === 0) {
            this.boxContainer?.removeAttribute("aria-busy");
          }
        }
      });
    }
    connectedCallback() {
      this.onCheckboxChange = this.handleCheckboxChange.bind(this);
      this.boxCheckbox?.addEventListener("change", this.onCheckboxChange);
      this.standardRadio?.addEventListener("change", this.onCheckboxChange);
      this.onMinus = this.handleMinusClick.bind(this);
      this.onPlus = this.handlePlusClick.bind(this);
      this.minusButton?.addEventListener("click", this.onMinus);
      this.plusButton?.addEventListener("click", this.onPlus);
      this.onSubmit = this.handleSubmitNote.bind(this);
      this.onInput = this.handleTextareaInput.bind(this);
      this.onPaste = this.handleTextareaPaste.bind(this);
      this.submitButton?.addEventListener("click", this.onSubmit);
      this.messageFields.forEach((field) => {
        field.addEventListener("input", this.onInput);
        field.addEventListener("paste", this.onPaste);
      });
      this.onNoteButton = this.handleNoteButtonClick.bind(this);
      this.noteButton?.addEventListener("click", this.onNoteButton);
      this.updateQuantity(this.currentQuantity);
      this.updateRemainingCharacters();
      this.reconcileGiftMessage();
    }
    // Self-heal the invariant "a gift message only exists while the box is in the
    // cart". The box can also be removed via the cart line-item trash, which goes
    // through product-form and bypasses this component, leaving the gift message
    // cart attributes behind. Clear them here so they don't resurface when the box
    // is re-added. Runs on every (re)connect, including after a section re-render.
    reconcileGiftMessage() {
      if (this.boxCheckbox?.checked) return;
      if (!this.hasStoredGiftMessage()) return;
      this.schedule(
        "note",
        () => this.updateCartNote(this.getEmptyMessageAttributes())
      );
    }
    hasStoredGiftMessage() {
      if (this.messageFields.some((field) => field.value.trim())) return true;
      return !!this.noteContainer && !this.noteContainer.classList.contains("hide");
    }
    removeEvents() {
      this.boxCheckbox?.removeEventListener("change", this.onCheckboxChange);
      this.standardRadio?.removeEventListener("change", this.onCheckboxChange);
      this.minusButton?.removeEventListener("click", this.onMinus);
      this.plusButton?.removeEventListener("click", this.onPlus);
      this.submitButton?.removeEventListener("click", this.onSubmit);
      this.messageFields.forEach((field) => {
        field.removeEventListener("input", this.onInput);
        field.removeEventListener("paste", this.onPaste);
      });
      this.noteButton?.removeEventListener("click", this.onNoteButton);
    }
    //------- ADD TO CART AND REMOVE FROM CART - GIFT BOX --------
    handleCheckboxChange() {
      this.toggleMessageContainer(!!this.boxCheckbox?.checked);
      this.schedule("box", () => this.syncBox());
    }
    toggleMessageContainer(open) {
      if (!this.packagingMessageContainer) return;
      this.packagingMessageContainer.style.display = open ? "block" : "none";
      this.packagingMessageContainer.classList.toggle("show", open);
    }
    // Brings the cart in line with the selected radio, read when the sync runs:
    // the customer may have switched back while an earlier request was pending.
    async syncBox() {
      const wanted = !!this.boxCheckbox?.checked;
      if (wanted === this.boxInCart) return;
      if (wanted) {
        if (!await this.addBoxToCart()) {
          if (this.standardRadio) this.standardRadio.checked = true;
          this.toggleMessageContainer(false);
          return;
        }
      } else {
        await this.removeBoxFromCart();
      }
      this.boxInCart = wanted;
      this.packagingMessageContainer?.setAttribute(
        "data-box-message-container",
        String(wanted)
      );
      if (wanted && this.boxCheckbox?.checked) {
        this.announceMessageReveal();
        delayFocusAfterAnnounce(() => this.focusMessageField());
      }
    }
    /**
     * Announces that the gift message fields are now available.
     */
    announceMessageReveal() {
      const message = this.dataset.giftMessageAnnounce || "Gift message field is now available";
      announceCartStatus(message, { focus: false });
    }
    /**
     * Moves focus to the first gift message field after the panel opens.
     */
    focusMessageField() {
      const field = this.messageFields[0];
      if (field) {
        field.focus();
      }
    }
    async addBoxToCart() {
      const boxVariantId = this.getVariantId(this.boxCheckbox, "data-box-id");
      if (boxVariantId === null) {
        console.error("Box product ID not found");
        return false;
      }
      const data = await this.addToCart(boxVariantId, 1, null, {
        _product_gift_cart: "true"
      });
      return data !== null;
    }
    async removeBoxFromCart() {
      const boxVariantId = this.getVariantId(this.boxCheckbox, "data-box-id");
      if (boxVariantId === null) {
        console.error("Box product ID not found");
        return;
      }
      const bagVariantId = this.getBagVariantId();
      const cart = await this.fetchCart();
      const keys = cart.items.filter(
        (item) => item.id === boxVariantId || bagVariantId !== null && item.id === bagVariantId
      ).map((item) => item.key);
      if (keys.length === 0) {
        console.error("Item not found in cart");
        return;
      }
      await this.updateLines(
        Object.fromEntries(keys.map((key) => [key, 0])),
        this.getEmptyMessageAttributes()
      );
      this.resetGiftMessage();
      this.updateQuantity(0);
    }
    getVariantId(element, attribute) {
      const id = parseInt(element?.getAttribute(attribute) ?? "");
      return Number.isNaN(id) ? null : id;
    }
    getBagVariantId() {
      return this.getVariantId(this.packagingId, "data-packaging-id");
    }
    // Build a MessageAttributes object with every gift-message field blanked out,
    // so a cart update wipes the stored values.
    getEmptyMessageAttributes() {
      return this.messageFields.reduce((attributes, field) => {
        const attributeName = this.getCartAttributeName(field);
        if (attributeName) attributes[attributeName] = "";
        return attributes;
      }, {});
    }
    // Clear the gift message fields and reset the message UI back to its
    // editable "write a message" state.
    resetGiftMessage() {
      this.messageFields.forEach((field) => {
        field.value = "";
        this.hideError(field);
        this.updateRemainingCharacters(field);
      });
      this.applyMessageState(this.getEmptyMessageAttributes());
    }
    //------- END ADD TO CART AND REMOVE FROM CART - GIFT BOX --------
    // ------- UPDATE PACKAGING QUANTITY --------
    // The counter moves at once; the cart follows through one queued sync,
    // however many clicks arrive while a request is pending.
    handleMinusClick() {
      if (this.currentQuantity <= 0) return;
      this.updateQuantity(this.currentQuantity - 1);
      this.schedule("bag", () => this.syncBagQuantity());
    }
    handlePlusClick() {
      if (this.currentQuantity >= this.maxQuantity) return;
      this.updateQuantity(this.currentQuantity + 1);
      this.schedule("bag", () => this.syncBagQuantity());
    }
    async syncBagQuantity() {
      if (!this.boxCheckbox?.checked) return;
      const bagVariantId = this.getBagVariantId();
      if (bagVariantId === null) {
        console.error("Packaging product ID not found");
        return;
      }
      const quantity = this.currentQuantity;
      const cart = await this.fetchCart();
      const lines = cart.items.filter(
        (item) => item.id === bagVariantId
      );
      const inCart = lines.reduce((total, item) => total + item.quantity, 0);
      if (inCart === quantity) return;
      const clearsMessage = quantity === 0;
      const attributes = clearsMessage ? this.getEmptyMessageAttributes() : this.getMessageAttributes();
      const [first, ...others] = lines;
      const data = first ? (
        // The first line takes the whole quantity, extra lines are emptied.
        await this.updateLines(
          Object.fromEntries([
            [first.key, quantity],
            ...others.map((item) => [item.key, 0])
          ]),
          attributes
        )
      ) : await this.addToCart(bagVariantId, quantity, attributes, {
        _product_gift_cart: "true"
      });
      if (data === null) return;
      if (clearsMessage) this.resetGiftMessage();
      this.announcePackagingQuantityUpdated(quantity);
    }
    updateQuantity(newQuantity) {
      if (!this.quantityInput) return;
      this.currentQuantity = Math.max(0, Math.min(newQuantity, this.maxQuantity));
      this.quantityInput.value = String(this.currentQuantity);
      this.minusButton.style.opacity = this.currentQuantity <= 0 ? "0.5" : "1";
      this.minusButton.style.pointerEvents = this.currentQuantity <= 0 ? "none" : "auto";
      this.plusButton.style.opacity = this.currentQuantity >= this.maxQuantity ? "0.5" : "1";
      this.plusButton.style.pointerEvents = this.currentQuantity >= this.maxQuantity ? "none" : "auto";
    }
    /**
     * Announces packaging bag quantity changes via the persistent cart live region.
     */
    announcePackagingQuantityUpdated(quantity) {
      const title = this.dataset.productTitle?.trim() || "Item";
      const template = this.dataset.quantityUpdatedTemplate || "__TITLE__ quantity updated to __QUANTITY__";
      announceCartStatus(fillCartStatusTemplate(template, { title, quantity }));
    }
    //------- END UPDATE PACKAGING QUANTITY --------
    // ------- UPDATE NOTE --------
    handleSubmitNote() {
      if (this.messageFields.length === 0) return;
      if (this.submitButton) this.submitButton.disabled = true;
      this.schedule("note", async () => {
        try {
          await this.updateCartNote(this.getMessageAttributes());
        } finally {
          if (this.submitButton) this.submitButton.disabled = false;
        }
      });
    }
    async updateCartNote(attributes) {
      try {
        const targets = this.getSectionTargets();
        const data = await this.updateCartAttributes(attributes, targets);
        this.renderReturnedSections(data, targets);
        this.applyMessageState(attributes);
      } catch (error) {
        console.error("[CartPackaging] updateCartNote error:", error);
      }
    }
    // Toggle between the "write a message" editor and the "saved message + Edit"
    // view client-side, mirroring the server-side has_gift_message branch.
    applyMessageState(attributes) {
      const lines = this.messageFields.map(
        (field) => attributes[this.getCartAttributeName(field) ?? ""]?.trim()
      ).filter((value) => !!value);
      const hasMessage = lines.length > 0;
      this.messageContent?.classList.toggle("hide", hasMessage);
      this.quantityContainer?.classList.toggle("hide", hasMessage);
      if (this.noteText) {
        this.noteText.innerHTML = lines.map(
          (line) => line.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r?\n/g, "<br>")
        ).join("<br>");
      }
      this.noteContainer?.classList.toggle("hide", !hasMessage);
    }
    handleNoteButtonClick() {
      this.noteContainer?.classList.add("hide");
      this.quantityContainer?.classList.remove("hide");
      this.messageContent?.classList.remove("hide");
    }
    //------- END UPDATE NOTE --------
    // ------- ADD TO CART AND UPDATE CART --------
    async addToCart(productId, quantity, attributes = null, properties = null) {
      const targets = this.getSectionTargets();
      const writesMessage = !!attributes && this.messageDiffers(attributes);
      const formData = {
        id: productId,
        quantity
      };
      if (properties) {
        formData.properties = properties;
      }
      if (!writesMessage) {
        formData.sections = this.sectionsParam(targets);
      }
      try {
        const res = await fetch(this.cartUrl("cart/add.js"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(formData)
        });
        let data = await res.json();
        if (!res.ok) return this.handleRejectedMutation(data);
        if (writesMessage) {
          data = await this.updateCartAttributes(attributes, targets);
        }
        this.renderReturnedSections(data, targets);
        return data;
      } catch (error) {
        console.error("Error adding to cart:", error);
        throw error;
      }
    }
    // `updates` is keyed by line item key (never by variant id: a variant can
    // sit on several lines, and update.js would only touch the first).
    async updateLines(updates, attributes) {
      const targets = this.getSectionTargets();
      try {
        const res = await fetch(this.cartUrl("cart/update.js"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            updates,
            attributes,
            sections: this.sectionsParam(targets)
          })
        });
        const data = await res.json();
        if (!res.ok) return this.handleRejectedMutation(data);
        this.savedMessage = { ...this.savedMessage, ...attributes };
        this.renderReturnedSections(data, targets);
        return data;
      } catch (error) {
        console.error("Error updating cart:", error);
        throw error;
      }
    }
    async updateCartAttributes(attributes, targets) {
      const response = await fetch(this.cartUrl("cart/update.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes,
          sections: this.sectionsParam(targets)
        })
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`HTTP ${response.status}: ${JSON.stringify(errorData)}`);
      }
      this.savedMessage = { ...this.savedMessage, ...attributes };
      return response.json();
    }
    messageDiffers(attributes) {
      return Object.entries(attributes).some(
        ([name, value]) => (this.savedMessage[name] ?? "") !== value
      );
    }
    sectionsParam(targets) {
      return targets.map((target) => target.id).join(",");
    }
    // Inject the rendered section HTML returned by the cart Ajax API
    // (data.sections) into the matching DOM nodes.
    // Le panier renvoie déjà le HTML des sections dans sa réponse (bundled section
    // rendering) : on le passe tel quel à `renderSections`, donc aucun aller-retour
    // supplémentaire. Cette méthode réimplémentait `swapInner` à la main — troisième
    // copie de la même logique dans le thème, supprimée ici.
    renderReturnedSections(data, targets) {
      if (!data?.sections) return;
      void renderSections(targets, { sections: data.sections });
    }
    //------- END ADD TO CART AND UPDATE CART --------
    // ------- UTILS CART --------
    // Le panier peut refuser une mutation pourtant valide côté thème : une
    // validation serveur (plafond de sacs, stock, app panier) répond 4xx avec un
    // corps d'erreur. Le compteur avait déjà été incrémenté de façon optimiste,
    // il affichait donc une quantité que le panier ne portait pas. On le
    // resynchronise sur le panier réel plutôt que de laisser le mensonge.
    async handleRejectedMutation(data) {
      console.error("[CartPackaging] cart mutation rejected:", data);
      await this.syncQuantityFromCart();
      return null;
    }
    async syncQuantityFromCart() {
      const packagingProductId = this.packagingId?.getAttribute("data-packaging-id");
      if (!packagingProductId) return;
      const numericProductId = parseInt(packagingProductId);
      try {
        const cart = await this.fetchCart();
        const quantity = cart.items.filter((item) => item.id === numericProductId).reduce((total, item) => total + item.quantity, 0);
        this.updateQuantity(quantity);
      } catch (error) {
        console.error("[CartPackaging] cart resync failed:", error);
      }
    }
    async fetchCart() {
      const response = await fetch(this.cartUrl("cart.js"));
      if (!response.ok) {
        throw new Error(`Cart fetch failed: ${response.status}`);
      }
      return response.json();
    }
    getMessageAttributes() {
      return this.messageFields.reduce((attributes, field) => {
        const attributeName = this.getCartAttributeName(field);
        if (!attributeName) return attributes;
        attributes[attributeName] = field.value.trim();
        return attributes;
      }, {});
    }
    getCartAttributeName(field) {
      const match = field.name.match(/^attributes\[(.+)]$/);
      return match?.[1] ?? null;
    }
    handleTextareaInput(event) {
      if (!this.isMessageField(event.target)) return;
      const field = event.target;
      const max = Number(field.getAttribute("maxlength")) || 250;
      const before = this.normalizeFieldValue(
        (field.value || "").normalize("NFC")
      );
      const hadIllegal = this.illegalRx(false).test(before);
      field.value = before.replace(this.illegalRx(true), "").slice(0, max);
      if (hadIllegal) {
        this.showError(field);
      } else {
        this.hideError(field);
      }
      this.updateRemainingCharacters(field);
    }
    handleTextareaPaste(event) {
      if (!this.isMessageField(event.target)) return;
      const field = event.target;
      const clipboard = event.clipboardData || window.clipboardData;
      const raw = clipboard?.getData("text") || "";
      if (this.illegalRx(false).test(raw)) {
        event.preventDefault();
        this.showError(field);
        return;
      }
      this.hideError(field);
    }
    /**
     * Point de variation nº 2 — normalisation de la valeur saisie, avant
     * filtrage. Par défaut on ne touche à rien ; le marché standard s'en sert
     * pour supprimer les retours à la ligne, son champ étant mono-ligne.
     */
    normalizeFieldValue(value) {
      return value;
    }
    illegalRx(global = false) {
      const { modern, fallback } = this.allowedChars();
      try {
        return new RegExp(modern, global ? "gu" : "u");
      } catch (error) {
        console.error("[CartPackaging] illegalRx error:", error);
        return new RegExp(fallback, global ? "g" : "");
      }
    }
    updateRemainingCharacters(field) {
      const fields = field ? [field] : this.messageFields;
      fields.forEach((messageField) => {
        const remainingCharsElement = this.getMessageFieldContainer(
          messageField
        )?.querySelector("[data-packaging-remaining-characters]");
        if (!remainingCharsElement) return;
        const maxLength = Number(messageField.getAttribute("maxlength")) || 250;
        const currentLength = messageField.value.length;
        const remaining = maxLength - currentLength;
        remainingCharsElement.textContent = String(remaining);
      });
    }
    showError(field) {
      this.getMessageFieldContainer(field)?.querySelector("[data-packaging-error]")?.classList.add("error");
    }
    hideError(field) {
      this.getMessageFieldContainer(field)?.querySelector("[data-packaging-error]")?.classList.remove("error");
    }
    getMessageFieldContainer(field) {
      return field.closest(".cart__packaging-message-input");
    }
    isMessageField(target) {
      return target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement;
    }
    //------- END UTILS CART --------
  };

  // src/snippets/cart-packaging-jp-hk/cart-packaging-jp-hk.ts
  var CartPackagingJpHk = class extends CartPackagingBase {
    // Autorisés : latin (+ accents), Han, hiragana, katakana, chiffres,
    // espace (demi et pleine largeur), CR/LF, ponctuation de base et japonaise.
    allowedChars() {
      return {
        modern: "[^\\p{Script=Latin}\\p{Script=Han}\\p{Script=Hiragana}\\p{Script=Katakana}\\p{Nd} \u3000\\r\\n.,!?'\\-\u3001\u3002\u30FC\u30FB\u300C\u300D\uFF08\uFF09\uFF01\uFF1F\uFF0E\uFF0C\u301C\uFF1A]",
        fallback: "[^A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\xFF0-9 \\r\\n.,!?'\\-\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF\uFF00-\uFFEF]"
      };
    }
  };
  customElements.define("cart-packaging-jp-hk", CartPackagingJpHk);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-samples"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/cart-samples/cart-samples.ts — do not edit directly.
// src/snippets/cart-samples/cart-samples.ts
"use strict";
(() => {
  // src/shared/cart-limit-error/cart-limit-error.ts
  var ERROR_MESSAGE_SELECTOR = "[data-cart-limit-error-message]";
  var ERROR_TEXT_SELECTOR = "[data-cart-limit-error-text]";
  var OPEN_ENGRAVING_PANEL_SELECTOR = "c-engraving-panel.is-open";
  var SEARCH_DIALOG_SELECTOR = "dialog[data-search-dialog]";
  function getErrorMessageEl() {
    return document.querySelector(ERROR_MESSAGE_SELECTOR);
  }
  function getDefaultMessage() {
    return window.cartStrings?.addToCartLimitError ?? "The maximum allowed quantity for this product has been exceeded.";
  }
  function closeOpenEngravingPanels() {
    document.querySelectorAll(OPEN_ENGRAVING_PANEL_SELECTOR).forEach((panel) => {
      ;
      panel.close();
    });
  }
  function closeHeaderSearchIfOpen() {
    const openDialogs = document.querySelectorAll(
      `${SEARCH_DIALOG_SELECTOR}[open]`
    );
    if (openDialogs.length === 0) return;
    document.documentElement.classList.remove("is-overflow-hidden");
    openDialogs.forEach((dialog) => {
      dialog.close();
    });
  }
  function showCartLimitError(message) {
    closeHeaderSearchIfOpen();
    const errorMessage = getErrorMessageEl();
    if (!errorMessage) return;
    const textEl = errorMessage.querySelector(ERROR_TEXT_SELECTOR);
    if (textEl) {
      textEl.textContent = message ?? getDefaultMessage();
    }
    errorMessage.classList.remove("hidden");
    errorMessage.removeAttribute("hidden");
    errorMessage.setAttribute("aria-hidden", "false");
    closeOpenEngravingPanels();
    window.scrollTo(0, 0);
  }
  function hideCartLimitError() {
    const errorMessage = getErrorMessageEl();
    if (!errorMessage) return;
    const textEl = errorMessage.querySelector(ERROR_TEXT_SELECTOR);
    if (textEl) {
      textEl.textContent = "";
    }
    errorMessage.classList.add("hidden");
    errorMessage.setAttribute("hidden", "");
    errorMessage.setAttribute("aria-hidden", "true");
  }

  // src/shared/utils/section-render.ts
  var SECTION_PREFIX = "shopify-section-";
  function getSectionId(el) {
    if (!el?.id?.startsWith(SECTION_PREFIX)) return null;
    return el.id.slice(SECTION_PREFIX.length);
  }
  function closestSectionId(el) {
    const wrapper = el?.closest(`[id^="${SECTION_PREFIX}"]`);
    return getSectionId(wrapper);
  }
  function buildUrl(base, params) {
    const url = new URL(base ?? window.location.pathname, window.location.origin);
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.set(key, value);
    }
    return url.toString();
  }
  function withQuery(params, query) {
    if (!query) return params;
    const extra = Object.fromEntries(
      Object.entries(query).map(([k, v]) => [k, String(v)])
    );
    return { ...extra, ...params };
  }
  async function fetchSectionHTML(id, options = {}) {
    const url = buildUrl(
      options.url,
      withQuery({ section_id: id }, options.query)
    );
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) throw new Error(`Section fetch ${response.status}`);
    return response.text();
  }
  function swapInner(html, selector) {
    const selectors = Array.isArray(selector) ? selector : [selector];
    const doc = new DOMParser().parseFromString(html, "text/html");
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((element) => {
        const source = element.dataset.id ? doc.querySelector(`${sel}[data-id="${element.dataset.id}"]`) : doc.querySelector(sel);
        if (source) element.innerHTML = source.innerHTML;
      });
    });
  }
  function swapSection(id, html) {
    const live = document.getElementById(`${SECTION_PREFIX}${id}`);
    if (!live) return;
    const doc = new DOMParser().parseFromString(html, "text/html");
    const next = doc.getElementById(`${SECTION_PREFIX}${id}`) || doc.body.firstElementChild;
    if (next instanceof HTMLElement) {
      live.replaceWith(next);
    } else {
      live.hidden = true;
    }
  }
  async function renderSection(target, options = {}) {
    const html = await fetchSectionHTML(target.id, options);
    if (target.selector) {
      swapInner(html, target.selector);
    } else {
      swapSection(target.id, html);
    }
  }

  // src/shared/cart-a11y/cart-a11y.ts
  var CART_LIVE_STATUS_ID = "cart-live-status";
  var FOCUS_ANNOUNCE_DELAY_MS = 300;
  function getOrCreateCartLiveRegion() {
    let region = document.getElementById(CART_LIVE_STATUS_ID);
    if (region instanceof HTMLElement) {
      return region;
    }
    region = document.createElement("div");
    region.id = CART_LIVE_STATUS_ID;
    region.className = "sr-only form-status";
    region.setAttribute("role", "status");
    region.setAttribute("aria-live", "polite");
    region.setAttribute("aria-atomic", "true");
    document.body.appendChild(region);
    return region;
  }
  function announceCartStatus(message, options = {}) {
    const trimmed = message.trim();
    if (!trimmed) return;
    const shouldFocus = options.focus !== false;
    const region = getOrCreateCartLiveRegion();
    if (shouldFocus) {
      region.setAttribute("aria-live", "off");
      region.setAttribute("tabindex", "-1");
      region.textContent = trimmed;
      region.focus({ preventScroll: true });
      window.setTimeout(() => {
        region.setAttribute("aria-live", "polite");
      }, FOCUS_ANNOUNCE_DELAY_MS);
      return;
    }
    region.textContent = "";
    requestAnimationFrame(() => {
      region.textContent = trimmed;
    });
  }

  // src/snippets/cart-samples/cart-samples.ts
  var CartSamples = class extends HTMLElement {
    constructor() {
      super();
      this.SELECTORS = {
        samplesQty: "[data-samples-qty]",
        popup: "[data-samples-popup]",
        close: "[data-samples-close]",
        sampleItem: "[data-samples-product-item]",
        popupSampleItem: "[data-popup-sample-product-item]",
        addButton: "[data-samples-add]",
        count: "[data-samples-count]",
        cartItemsList: ".cart__items-list",
        cartError: "[data-cart-error]",
        activePopupProduct: ".cart__samples-popup-product.active",
        sectionRoot: "[data-cart-samples]"
      };
      this.CLASSES = {
        error: "cart__items-error label-s-regular",
        active: "active",
        disabled: "disabled"
      };
      this.lastFocusedElement = null;
      this.onOpenPopup = (event) => {
        this.openPopup(event);
      };
      this.onClosePopup = () => {
        this.closePopup();
      };
      this.onDocumentKeydown = (event) => {
        if (event.key === "Escape" && this.popup?.classList.contains(this.CLASSES.active)) {
          this.closePopup();
        }
      };
      this.onSampleItemKeydown = (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          this.openPopup(event);
        }
      };
      this.samplesQty = this.querySelector(
        this.SELECTORS.samplesQty
      )?.dataset.samplesQty;
      this.popup = this.querySelector(this.SELECTORS.popup);
      this.overlay = this.querySelector(this.SELECTORS.close);
      this.sampleItems = [...this.querySelectorAll(this.SELECTORS.sampleItem)];
      this.popupSampleItems = [
        ...this.querySelectorAll(this.SELECTORS.popupSampleItem)
      ];
      this.sampleAddButton = this.querySelector(this.SELECTORS.addButton);
      this.closeElements = [...this.querySelectorAll(this.SELECTORS.close)];
      this.samplesCount = this.querySelector(this.SELECTORS.count);
      this.hadSamplesInCart = this.querySelector(this.SELECTORS.activePopupProduct) !== null;
      this.sectionId = this.getSectionId();
      this.sectionsRender = [
        { id: this.sectionId, selector: [this.SELECTORS.sectionRoot] }
      ];
    }
    getSectionId() {
      return closestSectionId(this) || "cart-samples";
    }
    connectedCallback() {
      this.bindEvents();
      this.updateButtonState();
      this.setPopupHidden(true);
    }
    disconnectedCallback() {
      this.removeEvents();
    }
    bindEvents() {
      this.sampleItems.forEach((item) => {
        item.addEventListener("click", this.onOpenPopup);
        item.addEventListener("keydown", this.onSampleItemKeydown);
      });
      this.overlay?.addEventListener("click", this.onClosePopup);
      this.closeElements.forEach((element) => {
        element.addEventListener("click", this.onClosePopup);
      });
      this.popupSampleItems.forEach((item) => {
        item.addEventListener("click", this.toggleActiveSample.bind(this));
      });
      this.sampleAddButton?.addEventListener("click", this.addSamples.bind(this));
    }
    removeEvents() {
      this.sampleItems.forEach((item) => {
        item.removeEventListener("click", this.onOpenPopup);
        item.removeEventListener("keydown", this.onSampleItemKeydown);
      });
      this.overlay?.removeEventListener("click", this.onClosePopup);
      this.closeElements.forEach((element) => {
        element.removeEventListener("click", this.onClosePopup);
      });
      document.removeEventListener("keydown", this.onDocumentKeydown);
    }
    /**
     * Syncs aria-expanded on every samples opener.
     */
    syncOpenersExpanded(isOpen) {
      this.sampleItems.forEach((item) => {
        item.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });
    }
    /**
     * Hides the dialog from the accessibility tree when closed (it stays
     * off-screen via CSS, so AT would otherwise still see it).
     */
    setPopupHidden(hidden) {
      if (!(this.popup instanceof HTMLElement)) return;
      this.popup.setAttribute("aria-hidden", hidden ? "true" : "false");
      if (hidden) {
        this.popup.setAttribute("inert", "");
      } else {
        this.popup.removeAttribute("inert");
      }
    }
    openPopup(event) {
      if (!this.popup && !this.overlay) return;
      const trigger = event?.currentTarget;
      this.lastFocusedElement = trigger instanceof HTMLElement ? trigger : null;
      this.setPopupHidden(false);
      this.popup?.classList.add(this.CLASSES.active);
      this.overlay?.classList.add(this.CLASSES.active);
      this.syncOpenersExpanded(true);
      document.body.classList.add("is-overflow-hidden");
      document.addEventListener("keydown", this.onDocumentKeydown);
      const closeButton = this.popup?.querySelector(
        "button[data-samples-close]"
      );
      if (closeButton) {
        closeButton.focus();
      }
    }
    closePopup() {
      if (!this.popup && !this.overlay) return;
      this.popup?.classList.remove(this.CLASSES.active);
      this.setPopupHidden(true);
      this.syncOpenersExpanded(false);
      document.body.classList.remove("is-overflow-hidden");
      document.removeEventListener("keydown", this.onDocumentKeydown);
      const overlay = this.overlay;
      setTimeout(() => {
        overlay?.classList.remove(this.CLASSES.active);
      }, 300);
      if (this.lastFocusedElement && this.lastFocusedElement.isConnected) {
        this.lastFocusedElement.focus();
      }
      this.lastFocusedElement = null;
    }
    addSamples(event) {
      event.preventDefault();
      if (!this.sampleAddButton) return;
      this.sampleAddButton.disabled = true;
      this.replaceSamples();
    }
    async replaceSamples() {
      const max = Number(this.samplesQty ?? 2);
      const variantIds = this.getSelectedSampleVariantIds();
      if (variantIds.length > max) return;
      this.clearCartError();
      try {
        await this.clearExistingSamples();
        if (variantIds.length > 0) {
          await this.addItemsToCart(this.buildSamplesPayload(variantIds));
        }
        this.onSamplesAdded();
        this.announceSamplesUpdated();
      } catch (err) {
        console.error("[CartSamples] samples flow error:", err);
        showCartLimitError(
          err instanceof Error && err.message ? err.message : "Une erreur est survenue."
        );
      } finally {
        if (this.sampleAddButton) this.sampleAddButton.disabled = false;
        this.updateButtonState();
      }
    }
    clearCartError() {
      hideCartLimitError();
    }
    getSelectedSampleVariantIds() {
      return this.popupSampleItems.filter((item) => item.classList.contains(this.CLASSES.active)).map((item) => item.dataset.popupSampleProductItem).filter((id) => id !== void 0);
    }
    async clearExistingSamples() {
      const cart = await this.fetchCart();
      const sampleItems = cart.items.filter(
        (it) => this.isSampleLineItem(it)
      );
      if (!sampleItems.length) return;
      const updates = {};
      sampleItems.forEach((item) => {
        updates[item.key] = 0;
      });
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        credentials: "same-origin",
        body: JSON.stringify({ updates })
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          `Remove samples failed: ${response.status} - ${errorData.message || "Unknown error"}`
        );
      }
    }
    isSampleLineItem(it) {
      const p = it?.properties || {};
      return p._sample === "1" || p._sample === "true" || p.sample === "1" || p.sample === "true";
    }
    async fetchCart() {
      const res = await fetch("/cart.js", {
        method: "GET",
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      });
      if (!res.ok) throw new Error(`Cart GET ${res.status}`);
      return res.json();
    }
    async addItemsToCart(payload) {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        credentials: "same-origin",
        body: JSON.stringify(payload)
      });
      if (!res.ok) {
        let msg = `Add error ${res.status}`;
        try {
          const data = await res.json();
          if (data?.description || data?.message)
            msg = data.description || data.message;
        } catch (_) {
        }
        throw new Error(msg);
      }
      return res.json();
    }
    buildSamplesPayload(variantIds) {
      return {
        items: variantIds.map((id) => ({
          id,
          quantity: 1,
          properties: { _sample: "1", _product_gift_cart: "true" }
        }))
      };
    }
    onSamplesAdded() {
      this.closePopup();
      setTimeout(() => {
        this.renderSampleSection();
      }, 100);
    }
    /**
     * Announces sample selection changes via the persistent cart live region.
     */
    announceSamplesUpdated() {
      const message = this.dataset.samplesUpdatedAnnounce || "Free samples updated";
      announceCartStatus(message);
    }
    // Re-renders this section via the Ajax Section Rendering API (single section,
    // `?section_id=` endpoint) and swaps in the fresh samples markup. The inner
    // swap on [data-cart-samples] recreates <cart-samples>, so its
    // connectedCallback re-binds events on the new markup.
    // Falls back to a full reload on error.
    async renderSampleSection() {
      try {
        for (const section of this.sectionsRender) {
          await renderSection(section);
        }
      } catch (error) {
        console.error("[CartSamples] section render error:", error);
        window.location.reload();
      }
    }
    toggleActiveSample(event) {
      if (this.checkAvailableSamples(event)) return;
      const clickedItem = event.currentTarget;
      const isActive = clickedItem.classList.toggle(this.CLASSES.active);
      clickedItem.setAttribute("aria-pressed", isActive ? "true" : "false");
      this.updateButtonState();
    }
    updateButtonState() {
      const max = Number(this.samplesQty ?? 2);
      const activeSamplesCount = this.querySelectorAll(
        this.SELECTORS.activePopupProduct
      ).length;
      if (this.samplesCount) {
        this.samplesCount.innerHTML = `(${activeSamplesCount}/${max})`;
      }
      if (this.sampleAddButton) {
        this.sampleAddButton.disabled = activeSamplesCount > max || activeSamplesCount === 0 && !this.hadSamplesInCart;
      }
      if (activeSamplesCount >= max) {
        this.disablePopupSimples();
      } else {
        this.enablePopupSimples();
      }
    }
    enablePopupSimples() {
      this.popupSampleItems.forEach((item) => {
        if (item.classList.contains(this.CLASSES.disabled)) {
          item.classList.remove(this.CLASSES.disabled);
          item.removeAttribute("aria-disabled");
        }
      });
    }
    disablePopupSimples() {
      this.popupSampleItems.forEach((item) => {
        if (!item.classList.contains(this.CLASSES.active)) {
          item.classList.add(this.CLASSES.disabled);
          item.setAttribute("aria-disabled", "true");
        }
      });
    }
    checkAvailableSamples(event) {
      const clickedItem = event.currentTarget;
      if (clickedItem.classList.contains(this.CLASSES.active)) {
        return false;
      }
      const activeSamplesCount = this.querySelectorAll(
        this.SELECTORS.activePopupProduct
      ).length;
      const max = Number(this.samplesQty ?? 2);
      return activeSamplesCount >= max;
    }
  };
  customElements.define("cart-samples", CartSamples);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["category-card"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/category-card/category-card.ts — do not edit directly.
// src/snippets/category-card/category-card.ts
"use strict";
(() => {
  // src/snippets/category-card/category-card.ts
  var CategoryCard = class extends HTMLElement {
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  };
  if (!window.customElements.get("c-category-card")) {
    window.customElements.define("c-category-card", CategoryCard);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collections-list"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/collections-list/collections-list.ts — do not edit directly.
// src/snippets/collections-list/collections-list.ts
"use strict";
(() => {
  // src/snippets/collections-list/collections-list.ts
  var CCollectionsList = class extends HTMLElement {
    constructor() {
      super();
      this.titles = [];
      this.containers = [];
      this.emblaMap = /* @__PURE__ */ new Map();
    }
    connectedCallback() {
      this.titles = [
        ...this.querySelectorAll(".collections-list__collection-title")
      ];
      this.containers = [
        ...this.querySelectorAll(".collections-list__collection-container")
      ];
      const firstActive = this.querySelector(
        ".collections-list__collection-container.active"
      );
      if (firstActive) this.initEmbla(firstActive);
      this.titles.forEach((title, index) => {
        title.addEventListener("click", () => this.switchTab(index));
      });
    }
    initEmbla(container) {
      if (this.emblaMap.has(container)) return;
      if (typeof window.EmblaCarousel !== "function") return;
      const viewport = container.querySelector(".embla__viewport");
      if (!viewport) return;
      const embla = window.EmblaCarousel(
        viewport,
        {
          dragFree: false,
          active: true,
          align: "start",
          slidesToScroll: "auto",
          "(min-width: 1024px)": {
            active: false,
            dragFree: true,
            slidesToScroll: "auto"
          }
        },
        [EmblaCarouselAutoHeight()]
      );
      this.emblaMap.set(container, embla);
      const prev = container.querySelector(".embla__prev");
      const next = container.querySelector(".embla__next");
      const prevContainer = container.querySelector(
        ".container_embla__prev"
      );
      const nextContainer = container.querySelector(
        ".container_embla__next"
      );
      const bar = container.querySelector(".embla__progress__bar");
      if (prev) prev.addEventListener("click", () => embla.scrollPrev());
      if (next) next.addEventListener("click", () => embla.scrollNext());
      this.bindMouseFollow(prevContainer, prev);
      this.bindMouseFollow(nextContainer, next);
      if (bar) {
        const updateProgress = () => {
          const snapCount = embla.scrollSnapList().length;
          const selected = embla.selectedScrollSnap();
          bar.style.width = `${100 / snapCount}%`;
          bar.style.transform = `translate3d(${selected * 100}%,0px,0px)`;
          if (prev?.parentElement) {
            prev.parentElement.toggleAttribute(
              "data-disabled",
              !embla.canScrollPrev()
            );
          }
          if (next?.parentElement) {
            next.parentElement.toggleAttribute(
              "data-disabled",
              !embla.canScrollNext()
            );
          }
        };
        updateProgress();
        embla.on("scroll", updateProgress);
        embla.on("resize", updateProgress);
        embla.on("reinit", updateProgress);
      }
    }
    bindMouseFollow(container, button) {
      if (!container || !button) return;
      container.addEventListener(
        "mousemove",
        (e) => this.followMouse(e, button)
      );
      container.addEventListener("mouseleave", () => this.resetButton(button));
    }
    followMouse(e, button) {
      if (!button) return;
      const container = e.currentTarget;
      const rect = container.getBoundingClientRect();
      const offsetX = e.clientX - rect.left - rect.width / 2;
      const offsetY = e.clientY - rect.top - rect.height / 2;
      button.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
    }
    resetButton(button) {
      if (!button) return;
      button.style.transform = "";
    }
    switchTab(index) {
      this.titles.forEach((t) => {
        t.classList.remove("active");
        t.classList.add("color-black-300");
      });
      this.titles[index]?.classList.add("active");
      this.titles[index]?.classList.remove("color-black-300");
      this.containers.forEach((c) => c.classList.remove("active"));
      const target = this.containers[index];
      if (!target) return;
      target.classList.add("active");
      this.initEmbla(target);
      const api = this.emblaMap.get(target);
      if (api) api.reInit();
    }
  };
  if (!customElements.get("c-collections-list")) {
    customElements.define("c-collections-list", CCollectionsList);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["countdown"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/countdown/countdown.ts — do not edit directly.
// src/snippets/countdown/countdown.ts
"use strict";
(() => {
  // src/snippets/countdown/countdown.ts
  var Countdown = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.timer = null;
      this.showSeconds = true;
    }
    connectedCallback() {
      const rawDate = this.getAttribute("end-date");
      this.endDate = new Date(rawDate ?? "");
      this.showSeconds = this.getAttribute("show-seconds") !== "false";
      if (isNaN(this.endDate.getTime())) {
        console.error("Invalid end-date provided to c-countdown");
        return;
      }
      this.update();
      this.timer = setInterval(() => this.update(), 1e3);
    }
    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }
    update() {
      const now = (/* @__PURE__ */ new Date()).getTime();
      const distance = this.endDate.getTime() - now;
      if (distance < 0) {
        this.handleExpiry();
        return;
      }
      const days = Math.floor(distance / (1e3 * 60 * 60 * 24));
      const hours = Math.floor(
        distance % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60)
      );
      const minutes = Math.floor(distance % (1e3 * 60 * 60) / (1e3 * 60));
      const seconds = Math.floor(distance % (1e3 * 60) / 1e3);
      this.render(days, hours, minutes, seconds);
    }
    render(d, h, m, s) {
      const dayEl = this.querySelector("[data-days]");
      const hourEl = this.querySelector("[data-hours]");
      const minEl = this.querySelector("[data-minutes]");
      const secEl = this.querySelector("[data-seconds]");
      if (dayEl) dayEl.textContent = d.toString().padStart(2, "0");
      if (hourEl) hourEl.textContent = h.toString().padStart(2, "0");
      if (minEl) minEl.textContent = m.toString().padStart(2, "0");
      if (secEl && this.showSeconds)
        secEl.textContent = s.toString().padStart(2, "0");
    }
    handleExpiry() {
      if (this.timer) clearInterval(this.timer);
      const endMessage = this.getAttribute("end-message");
      if (endMessage) {
        this.innerHTML = `<div class="headline-m">${endMessage}</div>`;
      } else {
        this.render(0, 0, 0, 0);
      }
      this.dispatchEvent(new CustomEvent("countdown:expired"));
    }
  };
  if (!window.customElements.get("c-countdown")) {
    window.customElements.define("c-countdown", Countdown);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["description-main-products"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/description-main-products/description-main-products.ts — do not edit directly.
// src/snippets/description-main-products/description-main-products.ts
"use strict";
(() => {
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["editor-copy-btn"] && !Shopify.designMode) return;
  try {
    ;(function () {
    if (window.customElements.get('editor-copy-btn')) return

    const STYLES = `
    editor-copy-btn {
      display: block;
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 9999;
      pointer-events: none;
    }
    .ecb-btn {
      pointer-events: auto;
      background: #1a1a1a;
      color: #fff;
      border: none;
      padding: 5px 13px;
      border-radius: 4px;
      cursor: pointer;
      font: 11px/1.4 monospace;
      letter-spacing: 0.05em;
      opacity: 0.85;
      transition: opacity 0.15s, background 0.15s;
      box-shadow: 0 2px 8px rgba(0,0,0,0.28);
    }
    .ecb-btn:hover { opacity: 1; }
    .ecb-btn.is-copied { background: #1d7a45; opacity: 1; }
  `

    function injectStyles() {
      if (document.getElementById('ecb-styles')) return
      const s = document.createElement('style')
      s.id = 'ecb-styles'
      s.textContent = STYLES
      document.head.appendChild(s)
    }

    function decodeHTML(str) {
      return str
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
    }

    function parseScript(el) {
      try {
        return JSON.parse(el.textContent || '{}')
      } catch {
        return null
      }
    }

    function compileConfig(sectionEl) {
      // Section settings from <script data-config-section>
      const sectionScript = sectionEl.querySelector('script[data-config-section]')
      const sectionConfig = sectionScript ? parseScript(sectionScript) : {}

      // All block configs from <script data-config-block>
      const blocks = Array.from(sectionEl.querySelectorAll('script[data-config-block]'))
        .map(parseScript)
        .filter(Boolean)

      return JSON.stringify({ section: sectionConfig, blocks }, null, 2)
    }

    function copyText(text, btn) {
      const confirm = () => {
        btn.textContent = '✓ Copied!'
        btn.classList.add('is-copied')
        setTimeout(() => {
          btn.textContent = '{ } Copy config'
          btn.classList.remove('is-copied')
        }, 2000)
      }

      // execCommand fallback — Clipboard API is blocked inside Shopify editor iframe
      const ta = document.createElement('textarea')
      ta.value = text
      ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0'
      document.body.appendChild(ta)
      ta.focus()
      ta.select()
      try {
        document.execCommand('copy')
        confirm()
      } catch {
        // Last resort: open in new tab
        const w = window.open('', '_blank')
        if (w) {
          w.document.open()
          w.document.write('<pre>' + text.replace(/</g, '&lt;') + '</pre>')
          w.document.close()
        }
      } finally {
        document.body.removeChild(ta)
      }
    }

    window.customElements.define(
      'editor-copy-btn',
      class extends HTMLElement {
        connectedCallback() {
          // Only active in Shopify theme editor
          if (!window.Shopify?.designMode) {
            this.hidden = true
            return
          }

          injectStyles()

          // Make sure the host is positioned so the button can use position:absolute
          const parent = this.parentElement
          if (parent) {
            const pos = getComputedStyle(parent).position
            if (pos === 'static') parent.style.position = 'relative'
          }

          const btn = document.createElement('button')
          btn.className = 'ecb-btn'
          btn.type = 'button'
          btn.textContent = '{ } Copy config'
          btn.setAttribute('aria-label', 'Copy section config as JSON')

          btn.addEventListener('click', () => {
            // Walk up to find the .shopify-section boundary
            const sectionEl =
              this.closest('.shopify-section') || this.closest('[data-shopify-editor-section]') || this.parentElement

            if (!sectionEl) return
            copyText(compileConfig(sectionEl), btn)
          })

          this.appendChild(btn)
        }
      }
    )
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["filter-count"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/filter-count/filter-count.ts — do not edit directly.
// src/snippets/filter-count/filter-count.ts
"use strict";
(() => {
  // src/snippets/filter-count/filter-count.ts
  var TAG_CONTAINER = "[data-filter-tag]";
  var TAG_SELECTOR = ".tag_filter";
  var FilterCount = class extends HTMLElement {
    constructor() {
      super(...arguments);
      /**
       * Le conteneur de tags est re-rempli sous les pieds du composant : par le
       * `sectionsRender()` legacy, qui échange son innerHTML à chaque changement de
       * filtre, et par le `replaceChildren()` de Preact côté Algolia. Dans les deux
       * cas le CONTENEUR survit — seul son contenu change — donc l'observer tient.
       */
      this.observer = null;
    }
    connectedCallback() {
      this.update();
      const container = document.querySelector(TAG_CONTAINER);
      if (!container) return;
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(container, { childList: true, subtree: true });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }
    /**
     * Écritures conditionnelles : l'observer ne surveille pas ce nœud-ci, donc il
     * n'y a pas de boucle à craindre — mais un `textContent` réécrit à l'identique
     * à chaque frappe salit quand même l'inspecteur pour rien.
     *
     * Pas d'espace dans la chaîne : ce nœud est un item flex du bouton, que son
     * `column-gap` sépare déjà du libellé — en ajouter un doublait l'écart. En
     * mobile le libellé sort du flux et seul ce nœud-ci reste à l'écran, à côté de
     * l'icône, où le même gap fait le travail.
     */
    update() {
      const count = document.querySelectorAll(
        `${TAG_CONTAINER} ${TAG_SELECTOR}`
      ).length;
      const label = count > 0 ? `(${count})` : "";
      if (this.textContent !== label) this.textContent = label;
      if (this.hasAttribute("hidden") !== (count === 0)) {
        this.toggleAttribute("hidden", count === 0);
      }
    }
  };
  if (!customElements.get("filter-count")) {
    customElements.define("filter-count", FilterCount);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gallery-main-product"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/gallery-main-product/gallery-main-product.ts — do not edit directly.
// src/snippets/gallery-main-product/gallery-main-product.ts
"use strict";
(() => {
  // src/snippets/gallery-main-product/gallery-main-product.ts
  var TWEEN_FACTOR_BASE = 0.2;
  var ENGRAVING_INTRO_DELAY_MS = 3e3;
  var ENGRAVING_INTRO_DURATION_MS = 1400;
  var engravingIntroPlayed = false;
  var GalleryMainProduct = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.embla = null;
      this.sliderToScrollMobile = "auto";
      this.sliderToScrollDesktop = "auto";
      this.viewport = null;
      this.container = null;
      this.prevButton = null;
      this.nextButton = null;
      this.progressNode = null;
      this.prevContainer = null;
      this.nextContainer = null;
      this.firstSlideObserver = null;
      this.productDescription = null;
      this.galleryRoot = null;
      this.engravingTrigger = null;
      this.productTags = null;
      this.header = null;
      this.tweenFactor = 0;
      this.tweenNodes = [];
      this.resizeObserver = null;
      this.descriptionObserver = null;
      /** Dernière largeur observée : ne reInit que sur un vrai changement de largeur. */
      this.lastViewportWidth = 0;
      /** Dernière valeur écrite dans `--short-description-height` (px). */
      this.shortDescriptionHeight = 0;
      this.engravingIntroTimeout = 0;
      this.onPrevClick = () => this.embla?.scrollPrev();
      this.onNextClick = () => this.embla?.scrollNext();
      this.onPrevMouseMove = (e) => this.followMouse(e, this.prevButton);
      this.onNextMouseMove = (e) => this.followMouse(e, this.nextButton);
      this.onPrevMouseLeave = () => this.resetButton(this.prevButton);
      this.onNextMouseLeave = () => this.resetButton(this.nextButton);
    }
    connectedCallback() {
      const parentContainer = this.closest("c-gallery-container");
      this.viewport = this.querySelector(".embla__viewport");
      this.container = this.querySelector(".embla__container");
      this.prevButton = this.querySelector(".embla__prev");
      this.nextButton = this.querySelector(".embla__next");
      this.progressNode = this.querySelector(".embla__progress__bar");
      this.prevContainer = this.querySelector(".container_embla__prev");
      this.nextContainer = this.querySelector(".container_embla__next");
      this.sliderToScrollMobile = this.dataset.slidesToScrollMobile || "auto";
      this.sliderToScrollDesktop = this.dataset.slidesToScrollDesktop || "auto";
      if (parentContainer?.classList.contains("v-slider")) {
        this.initEmbla();
        this.bindProgress();
        this.bindMouseFollow();
      }
      this.productDescription = this.querySelector(".product-description--mobile");
      this.galleryRoot = this.closest(".gallery-main-product");
      this.engravingTrigger = this.galleryRoot?.querySelector(
        ".engraving-trigger__wrapper"
      ) ?? null;
      this.productTags = document.querySelector(".main-product__tags");
      this.header = document.querySelector("header");
      this.classList.remove("shimmer");
      this.playEngravingTriggerIntro();
      this.bindFirstSlideAnimation();
      if (this.embla) {
        this.setupParallax();
      }
      this.resizeObserver = new ResizeObserver(
        (entries) => this.updateSlideSize(entries[0])
      );
      this.resizeObserver.observe(this);
      this.updateShortDescriptionHeight();
      if (this.productDescription) {
        this.descriptionObserver = new ResizeObserver(
          () => this.updateShortDescriptionHeight()
        );
        this.descriptionObserver.observe(this.productDescription);
      }
      this.addEventListener("tuncat:resized", () => {
        if (!this.updateShortDescriptionHeight()) this.embla?.reInit();
      });
    }
    // Ne réinitialiser Embla que sur un vrai changement de LARGEUR. La hauteur est
    // pilotée par le plugin AutoHeight, qui ajuste `embla__viewport` ; observer
    // `this` et reInit à chaque changement de hauteur créait une boucle de
    // rétroaction (AutoHeight change la hauteur → ResizeObserver → reInit →
    // AutoHeight rechange la hauteur → …), d'où un churn permanent des styles
    // Embla en vue mobile. Un reInit ne sert que quand la largeur change (rotation,
    // franchissement de breakpoint) ; Embla gère seul les changements de hauteur.
    updateSlideSize(entry) {
      const width = Math.round(
        entry?.contentRect.width ?? this.getBoundingClientRect().width
      );
      if (width === 0 || width === this.lastViewportWidth) return;
      this.lastViewportWidth = width;
      this.embla?.reInit();
    }
    // Single source of truth for the mobile description height: the full live
    // height of `.product-description--mobile` (tuncat expansion included).
    // `.product-images` height and the engraving margin derive from it via
    // `--short-description-height`, so no separate `--tuncat-expanded-height`
    // term is needed there (avoids double-counting the tuncat expansion).
    /** @returns true si la variable a changé (et donc si AutoHeight a été resynchronisé). */
    updateShortDescriptionHeight() {
      const target = this.galleryRoot ?? this.viewport;
      if (!target || !this.productDescription) return false;
      const height = Math.round(this.productDescription.offsetHeight);
      if (height <= 0 || height === this.shortDescriptionHeight) return false;
      this.shortDescriptionHeight = height;
      target.style.setProperty("--short-description-height", `${height}px`);
      this.embla?.reInit();
      return true;
    }
    disconnectedCallback() {
      window.clearTimeout(this.engravingIntroTimeout);
      this.engravingIntroTimeout = 0;
      this.embla?.destroy();
      this.embla = null;
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      this.descriptionObserver?.disconnect();
      this.descriptionObserver = null;
      this.firstSlideObserver?.disconnect();
      this.firstSlideObserver = null;
      this.prevButton?.removeEventListener("click", this.onPrevClick);
      this.nextButton?.removeEventListener("click", this.onNextClick);
      this.prevContainer?.removeEventListener("mousemove", this.onPrevMouseMove);
      this.prevContainer?.removeEventListener("mouseleave", this.onPrevMouseLeave);
      this.nextContainer?.removeEventListener("mousemove", this.onNextMouseMove);
      this.nextContainer?.removeEventListener("mouseleave", this.onNextMouseLeave);
    }
    initEmbla() {
      if (!this.viewport || !this.container) return;
      this.embla = EmblaCarousel(
        this.viewport,
        {
          dragFree: false,
          active: true,
          slidesToScroll: this.sliderToScrollMobile,
          "(min-width: 1024px)": {
            active: false,
            dragFree: true,
            slidesToScroll: "auto"
          }
        },
        [EmblaCarouselAutoHeight()]
      );
      this.prevButton?.addEventListener("click", this.onPrevClick);
      this.nextButton?.addEventListener("click", this.onNextClick);
    }
    bindProgress() {
      if (!this.embla || !this.progressNode) return;
      const progressNode = this.progressNode;
      const applyProgress = () => {
        if (!this.embla) return;
        const snapCount = this.embla.scrollSnapList().length;
        const selected = this.embla.selectedScrollSnap();
        progressNode.style.width = `${100 / snapCount}%`;
        progressNode.style.transform = `translate3d(${selected * 100}%,0px,0px)`;
        this.prevButton?.parentElement?.toggleAttribute(
          "data-disabled",
          !this.embla.canScrollPrev()
        );
        this.nextButton?.parentElement?.toggleAttribute(
          "data-disabled",
          !this.embla.canScrollNext()
        );
        this.onScroll();
      };
      applyProgress();
      this.embla.on("reinit", () => applyProgress()).on("resize", () => applyProgress()).on("scroll", () => applyProgress()).on("slidefocus", () => applyProgress());
    }
    bindMouseFollow() {
      this.prevContainer?.addEventListener("mousemove", this.onPrevMouseMove);
      this.prevContainer?.addEventListener("mouseleave", this.onPrevMouseLeave);
      this.nextContainer?.addEventListener("mousemove", this.onNextMouseMove);
      this.nextContainer?.addEventListener("mouseleave", this.onNextMouseLeave);
    }
    followMouse(e, button) {
      if (!button) return;
      const container = e.currentTarget;
      const rect = container.getBoundingClientRect();
      const offsetX = e.clientX - rect.left - rect.width / 2;
      const offsetY = e.clientY - rect.top - rect.height / 2;
      button.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
    }
    resetButton(button) {
      if (!button) return;
      button.style.transform = "";
    }
    /**
     * Expands the engraving label once after 3s, in sync with reassurance autoplay.
     * On desktop (`.v-desktop`) the label stays open; on mobile it collapses after the intro.
     */
    playEngravingTriggerIntro() {
      if (engravingIntroPlayed || !this.engravingTrigger) return;
      if (this.engravingTrigger.offsetParent === null) return;
      this.engravingIntroTimeout = window.setTimeout(() => {
        if (engravingIntroPlayed || !this.engravingTrigger) return;
        if (this.engravingTrigger.offsetParent === null) return;
        engravingIntroPlayed = true;
        requestAnimationFrame(() => {
          this.engravingTrigger?.classList.add("is-animate-engraving-trigger");
          const stayOpen = this.galleryRoot?.classList.contains("v-desktop") === true;
          if (stayOpen) return;
          window.setTimeout(() => {
            this.engravingTrigger?.classList.remove(
              "is-animate-engraving-trigger"
            );
          }, ENGRAVING_INTRO_DURATION_MS);
        });
      }, ENGRAVING_INTRO_DELAY_MS);
    }
    bindFirstSlideAnimation() {
      const firstSlide = this.querySelector(
        ".embla__slide:first-child"
      );
      if (!firstSlide) return;
      this.firstSlideObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry.isIntersecting) return;
          this.firstSlideObserver?.disconnect();
          this.firstSlideObserver = null;
          const quickBuyContainer = firstSlide.querySelector(
            ".card-product-quick-buy__container"
          );
          quickBuyContainer?.classList.add("is-animate-quick-buy");
          window.setTimeout(() => {
            quickBuyContainer?.classList.remove("is-animate-quick-buy");
          }, ENGRAVING_INTRO_DURATION_MS);
        },
        { threshold: 0.8 }
      );
      this.firstSlideObserver.observe(firstSlide);
    }
    setupParallax() {
      const embla = this.embla;
      this.setTweenNodes();
      this.setTweenFactor();
      this.clearParallax();
      embla.on("reInit", () => {
        this.setTweenNodes();
        this.setTweenFactor();
        this.clearParallax();
      }).on(
        "scroll",
        (_api, eventName) => this.tweenParallax(eventName)
      ).on("slideFocus", () => this.tweenParallax()).on("settle", () => this.clearParallax()).on("pointerDown", () => this.tweenParallax());
    }
    /** Rend les nœuds de parallax non composités (voir `settle` ci-dessus). */
    clearParallax() {
      this.tweenNodes.forEach((node) => {
        if (node) node.style.transform = "";
      });
    }
    setTweenNodes() {
      this.tweenNodes = this.embla.slideNodes().map(
        (slide) => slide.querySelector(".embla__parallax__layer")
      );
    }
    setTweenFactor() {
      this.tweenFactor = TWEEN_FACTOR_BASE * this.embla.scrollSnapList().length;
    }
    tweenParallax(eventName) {
      if (window.innerWidth >= 1024) {
        this.clearParallax();
        return;
      }
      const embla = this.embla;
      const engine = embla.internalEngine();
      const scrollProgress = embla.scrollProgress();
      const slidesInView = embla.slidesInView();
      const isScrollEvent = eventName === "scroll";
      embla.scrollSnapList().forEach((scrollSnap, snapIndex) => {
        let diffToTarget = scrollSnap - scrollProgress;
        const slidesInSnap = engine.slideRegistry[snapIndex];
        slidesInSnap.forEach((slideIndex) => {
          if (isScrollEvent && !slidesInView.includes(slideIndex)) return;
          if (engine.options.loop) {
            engine.slideLooper.loopPoints.forEach(
              (loopItem) => {
                const target = loopItem.target();
                if (slideIndex === loopItem.index && target !== 0) {
                  const sign = Math.sign(target);
                  if (sign === -1)
                    diffToTarget = scrollSnap - (1 + scrollProgress);
                  if (sign === 1) diffToTarget = scrollSnap + (1 - scrollProgress);
                }
              }
            );
          }
          const translate = diffToTarget * (-1 * this.tweenFactor) * 100;
          const tweenNode = this.tweenNodes[slideIndex];
          if (tweenNode) tweenNode.style.transform = `translateX(${translate}%)`;
        });
      });
    }
    onScroll() {
      if (!this.embla) return;
      if (window.innerWidth >= 1024) return;
      const viewportRect = this.embla.containerNode().parentElement.getBoundingClientRect();
      if (viewportRect.width === 0) return;
      let editoRatio = 0;
      let nightRatio = 0;
      this.embla.slideNodes().forEach((slide) => {
        const slideRect = slide.getBoundingClientRect();
        if (slideRect.right <= viewportRect.left || slideRect.left >= viewportRect.right)
          return;
        const overlapLeft = Math.max(viewportRect.left, slideRect.left);
        const overlapRight = Math.min(viewportRect.right, slideRect.right);
        const ratio = (overlapRight - overlapLeft) / viewportRect.width;
        if (slide.classList.contains("v-edito-image-mobile"))
          editoRatio = Math.max(editoRatio, ratio);
        if (slide.classList.contains("v-black"))
          nightRatio = Math.max(nightRatio, ratio);
      });
      const threshold = window.innerWidth >= 1024 ? 0.5 : 0.2;
      const editoVisible = editoRatio > threshold;
      const darkVisible = editoVisible || nightRatio > threshold;
      const opacity = editoVisible ? "0" : "1";
      const transition = editoVisible ? "opacity 0.3s ease" : "opacity 0.1s ease";
      [this.productDescription, this.engravingTrigger, this.productTags].forEach(
        (el) => {
          if (!el) return;
          el.style.transition = transition;
          el.style.opacity = opacity;
        }
      );
      if (window.innerWidth < 1024) {
        this.header?.classList.toggle("is-edito-visible", darkVisible);
      }
    }
  };
  if (!window.customElements.get("c-gallery-main-product")) {
    window.customElements.define("c-gallery-main-product", GalleryMainProduct);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["info-card"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/info-card/info-card.ts — do not edit directly.
// src/snippets/info-card/info-card.ts
"use strict";
(() => {
  // src/snippets/info-card/info-card.ts
  var InfoCard = class extends HTMLElement {
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  };
  if (!window.customElements.get("c-info-card")) {
    window.customElements.define("c-info-card", InfoCard);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product-reassurance"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/main-product-reassurance/main-product-reassurance.ts — do not edit directly.
// src/snippets/main-product-reassurance/main-product-reassurance.ts
"use strict";
(() => {
  // src/snippets/main-product-reassurance/main-product-reassurance.ts
  var MainProductReassurance = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.viewportNode = null;
      this.dotsNode = null;
      this.prevButton = null;
      this.nextButton = null;
      this.prevContainer = null;
      this.nextContainer = null;
      this.activeSidebar = null;
      this.isAnimating = false;
      this.lastFocusedElement = null;
      this.onPrevClick = () => {
        this.emblaApi?.scrollPrev();
      };
      this.onNextClick = () => {
        this.emblaApi?.scrollNext();
      };
      this.onDocumentKeydown = (e) => {
        if (e.key === "Escape" && this.activeSidebar) this._closeSidebar();
      };
    }
    connectedCallback() {
      this.viewportNode = this.querySelector(".embla__viewport");
      this.dotsNode = this.querySelector(".embla__dots");
      if (!this.viewportNode) return;
      const slideCount = this.querySelectorAll(".embla__slide").length;
      const plugins = slideCount > 1 ? [EmblaCarouselAutoplay({ delay: 3e3, stopOnInteraction: false })] : [];
      this.emblaApi = EmblaCarousel(
        this.viewportNode,
        { loop: true, dragFree: false },
        plugins
      );
      this._buildDots();
      this.emblaApi.on("select", () => this._updateDots());
      this.prevButton = this.querySelector(".embla__prev");
      this.nextButton = this.querySelector(".embla__next");
      this.prevContainer = this.querySelector(".container_embla__prev");
      this.nextContainer = this.querySelector(".container_embla__next");
      this.prevButton?.addEventListener("click", this.onPrevClick);
      this.nextButton?.addEventListener("click", this.onNextClick);
      this.prevContainer?.addEventListener("click", this.onPrevClick);
      this.nextContainer?.addEventListener("click", this.onNextClick);
      this._bindSidebar();
    }
    _buildDots() {
      if (!this.dotsNode) return;
      const count = this.emblaApi.scrollSnapList().length;
      this.dotsNode.innerHTML = "";
      if (count <= 1) return;
      const labelTemplate = this.dataset.slideLabelTemplate ?? "Slide __INDEX__ of __COUNT__";
      for (let i = 0; i < count; i++) {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.classList.add("embla__dot");
        btn.setAttribute(
          "aria-label",
          labelTemplate.replace("__INDEX__", String(i + 1)).replace("__COUNT__", String(count))
        );
        btn.addEventListener("click", () => this.emblaApi.scrollTo(i));
        this.dotsNode.appendChild(btn);
      }
      this._updateDots();
    }
    _updateDots() {
      if (!this.dotsNode) return;
      const selected = this.emblaApi.selectedScrollSnap();
      this.dotsNode.querySelectorAll(".embla__dot").forEach((dot, i) => {
        const isActive = i === selected;
        dot.classList.toggle("is-active", isActive);
        if (isActive) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    }
    _bindSidebar() {
      this.addEventListener("click", (e) => {
        const trigger = e.target.closest(
          "[data-reinsurance-sidebar]"
        );
        if (trigger) {
          e.preventDefault();
          this._openSidebar(trigger.dataset.reinsuranceSidebar, trigger);
        }
        const close = e.target.closest(
          "[data-reinsurance-sidebar-close]"
        );
        if (close && this.activeSidebar) {
          e.preventDefault();
          this._closeSidebar();
        }
      });
      document.addEventListener("keydown", this.onDocumentKeydown);
    }
    /**
     * Updates aria-expanded on every reassurance trigger for the open panel.
     */
    _syncTriggerExpanded(sidebarId) {
      this.querySelectorAll("[data-reinsurance-sidebar]").forEach(
        (trigger) => {
          const isOpen = trigger.dataset.reinsuranceSidebar === sidebarId;
          trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
        }
      );
    }
    _openSidebar(sidebarId, trigger) {
      if (this.isAnimating) return;
      const sidebar = this.querySelector(
        `[data-reinsurance-sidebar-content="${sidebarId}"]`
      );
      if (!sidebar) return;
      this.isAnimating = true;
      this.activeSidebar = sidebarId;
      this.lastFocusedElement = trigger;
      this._syncTriggerExpanded(sidebarId);
      document.body.classList.add("is-overflow-hidden");
      sidebar.classList.add("active");
      sidebar.querySelector(".reinsurances-custom__sidebar-content")?.classList.add("active");
      const closeButton = sidebar.querySelector(
        "button[data-reinsurance-sidebar-close]"
      );
      if (closeButton) {
        closeButton.focus();
      }
      this.isAnimating = false;
    }
    _closeSidebar() {
      if (this.isAnimating || !this.activeSidebar) return;
      this.isAnimating = true;
      const sidebar = this.querySelector(
        `[data-reinsurance-sidebar-content="${this.activeSidebar}"]`
      );
      if (!sidebar) {
        this.isAnimating = false;
        return;
      }
      sidebar.querySelector(".reinsurances-custom__sidebar-content")?.classList.remove("active");
      document.body.classList.remove("is-overflow-hidden");
      sidebar.classList.remove("active");
      this.activeSidebar = null;
      this._syncTriggerExpanded(null);
      this.isAnimating = false;
      if (this.lastFocusedElement && this.lastFocusedElement.isConnected) {
        const focusTarget = this.lastFocusedElement.querySelector("button") ?? this.lastFocusedElement;
        focusTarget.focus();
      }
      this.lastFocusedElement = null;
    }
    disconnectedCallback() {
      document.removeEventListener("keydown", this.onDocumentKeydown);
      if (this.activeSidebar) this._closeSidebar();
      this.prevButton?.removeEventListener("click", this.onPrevClick);
      this.nextButton?.removeEventListener("click", this.onNextClick);
      this.prevContainer?.removeEventListener("click", this.onPrevClick);
      this.nextContainer?.removeEventListener("click", this.onNextClick);
      this.emblaApi?.destroy();
    }
  };
  if (!window.customElements.get("c-main-product-reassurance")) {
    window.customElements.define(
      "c-main-product-reassurance",
      MainProductReassurance
    );
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product-tuncat-description"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/main-product-tuncat-description/main-product-tuncat-description.ts — do not edit directly.
// src/snippets/main-product-tuncat-description/main-product-tuncat-description.ts
"use strict";
(() => {
  // src/snippets/main-product-tuncat-description/main-product-tuncat-description.ts
  var Tuncat = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.seeMoreBtn = null;
      this.seeLessBtn = null;
      this.viewport = null;
      this.engravingBtn = null;
      this.resizeObserver = null;
      this.baseHeight = 0;
      this.onSeeMore = () => this.setExpanded(true);
      this.onSeeLess = () => this.setExpanded(false);
    }
    connectedCallback() {
      this.seeMoreBtn = this.querySelector("[data-tuncat-see-more]");
      this.seeLessBtn = this.querySelector("[data-tuncat-see-less]");
      this.viewport = document.querySelector(".embla__viewport");
      this.engravingBtn = document.querySelector(".engraving-trigger__wrapper");
      this.seeMoreBtn?.addEventListener("click", this.onSeeMore);
      this.seeLessBtn?.addEventListener("click", this.onSeeLess);
      if (this.viewport) this.observeResize();
    }
    disconnectedCallback() {
      this.seeMoreBtn?.removeEventListener("click", this.onSeeMore);
      this.seeLessBtn?.removeEventListener("click", this.onSeeLess);
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
    }
    setExpanded(expanded) {
      this.classList.toggle("is-expanded", expanded);
      this.dispatchEvent(
        new CustomEvent("tuncat:toggled", {
          bubbles: true,
          detail: { expanded }
        })
      );
    }
    observeResize() {
      this.resizeObserver = new ResizeObserver((entries) => {
        const height = entries[0].contentRect.height;
        if (this.baseHeight === 0) {
          this.baseHeight = height;
          return;
        }
        const extra = Math.max(0, height - this.baseHeight);
        this.engravingBtn?.style.setProperty(
          "--tuncat-expanded-height",
          `${extra}px`
        );
        this.viewport?.style.setProperty("--tuncat-expanded-height", `${extra}px`);
        this.viewport?.dispatchEvent(
          new CustomEvent("tuncat:resized", { bubbles: true })
        );
      });
      this.resizeObserver.observe(this);
    }
  };
  if (!window.customElements.get("c-tuncat")) {
    window.customElements.define("c-tuncat", Tuncat);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["media-card"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/media-card/media-card.ts — do not edit directly.
// src/snippets/media-card/media-card.ts
"use strict";
(() => {
  // src/snippets/media-card/media-card.ts
  var MediaCard = class extends HTMLElement {
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  };
  if (!window.customElements.get("c-media-card")) {
    window.customElements.define("c-media-card", MediaCard);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["plp-night-toggle"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/plp-night-toggle/plp-night-toggle.ts — do not edit directly.
// src/snippets/plp-night-toggle/plp-night-toggle.ts
"use strict";
(() => {
  // src/snippets/plp-night-toggle/plp-night-toggle.ts
  var STORAGE_KEY = "dptq_plp_night";
  var URL_PARAM = "night";
  var ON = "on";
  var GRID_SELECTOR = ".collection-grid, .collection-grid--next";
  function decodeKey(rawKey) {
    try {
      return decodeURIComponent(rawKey.replace(/\+/g, " "));
    } catch {
      return rawKey;
    }
  }
  function withNightParam(search, night) {
    const pairs = search.replace(/^\?/, "").split("&").filter((pair) => pair && decodeKey(pair.split("=")[0]) !== URL_PARAM);
    if (night) pairs.push(`${URL_PARAM}=${ON}`);
    return pairs.length ? `?${pairs.join("&")}` : "";
  }
  var NIGHT_FIGURE_CLASS = "card-product__night";
  var NIGHT_READY_CLASS = "card-product__night--ready";
  var STRIP_ATTRIBUTE = "plpNightStrip";
  var FADE_ATTRIBUTE = "plpNightFade";
  var FADE_FALLBACK_MS = 1200;
  function fadeWindowMs() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue("--plp-night-duration").trim();
    const parsed = parseFloat(raw);
    if (!Number.isFinite(parsed)) return FADE_FALLBACK_MS;
    return (raw.endsWith("ms") ? parsed : parsed * 1e3) + 100;
  }
  function needsNightFigure(figure) {
    const container = figure.parentElement;
    if (!figure.dataset.nightSrc || !container) return false;
    if (container.querySelector(`.${NIGHT_FIGURE_CLASS}`)) return false;
    if ("nightFailed" in container.dataset) return false;
    return true;
  }
  function mountNightFigure(figure) {
    if (!needsNightFigure(figure)) return;
    const nightSrc = figure.dataset.nightSrc;
    const container = figure.parentElement;
    if (!nightSrc || !container) return;
    const image = new Image();
    image.alt = "";
    image.loading = "eager";
    image.decoding = "async";
    image.fetchPriority = "low";
    image.width = 600;
    image.height = 800;
    const nightFigure = document.createElement("figure");
    nightFigure.className = NIGHT_FIGURE_CLASS;
    nightFigure.setAttribute("aria-hidden", "true");
    if (FADE_ATTRIBUTE in document.documentElement.dataset) {
      nightFigure.dataset[FADE_ATTRIBUTE] = "";
    }
    nightFigure.appendChild(image);
    container.appendChild(nightFigure);
    image.src = nightSrc;
    image.decode().then(() => nightFigure.classList.add(NIGHT_READY_CLASS)).catch(() => {
      if (image.naturalWidth > 0) {
        nightFigure.classList.add(NIGHT_READY_CLASS);
        return;
      }
      container.dataset.nightFailed = "";
      nightFigure.remove();
    });
  }
  var NIGHT_VIEWPORT_MARGIN = "800px";
  var watchedFigures = /* @__PURE__ */ new WeakSet();
  var viewportObserver = null;
  function nearViewportObserver() {
    if (viewportObserver) return viewportObserver;
    if (typeof IntersectionObserver !== "function") return null;
    viewportObserver = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          viewportObserver?.unobserve(entry.target);
          mountNightFigure(entry.target);
        }
      },
      { rootMargin: NIGHT_VIEWPORT_MARGIN }
    );
    return viewportObserver;
  }
  function stopMountingOnScroll() {
    viewportObserver?.disconnect();
    viewportObserver = null;
    watchedFigures = /* @__PURE__ */ new WeakSet();
  }
  function mountNightFigures() {
    const io = nearViewportObserver();
    document.querySelectorAll(GRID_SELECTOR).forEach(
      (grid) => grid.querySelectorAll("figure[data-night-src]").forEach((figure) => {
        if (!needsNightFigure(figure)) return;
        if (!io) {
          mountNightFigure(figure);
          return;
        }
        if (watchedFigures.has(figure)) return;
        watchedFigures.add(figure);
        io.observe(figure);
      })
    );
  }
  var PlpNightToggle = class extends HTMLElement {
    constructor() {
      super(...arguments);
      /**
       * Les cartes sont re-rendues sous les pieds du composant : par Preact à chaque
       * recherche Algolia, et par le `sectionsRender()` legacy à chaque changement
       * de filtre. Les nouvelles arrivent sans leur figure nuit, donc il faut la
       * remonter. L'observateur n'existe QUE pendant le mode nuit — en journée il
       * n'y a rien à monter.
       *
       * `childList` + `subtree` seulement, jamais `attributes`. Et `mountNightFigure`
       * sort tout de suite quand la figure existe déjà : sans cette garde, chaque
       * injection redéclencherait l'observateur, qui réinjecterait, en boucle.
       */
      this.observer = null;
      this.handleClick = (event) => {
        const target = event.target;
        const button = target?.closest("[data-plp-night-value]");
        if (!button || !this.contains(button)) return;
        this.apply(button.dataset.plpNightValue === "night");
      };
      /*
       * Pas de View Transitions ici, contrairement au sélecteur de densité.
       *
       * Là-bas c'était le seul recours : `grid-template-columns` n'est pas
       * interpolable entre 4 et 6 pistes. Ici tout ce qui doit bouger — fond de page
       * et opacité des visuels — l'est nativement, et sur 1,2 s. Envelopper la
       * bascule dans une View Transition superposerait un fondu de capture d'écran
       * de quelques centaines de millisecondes à ces transitions-là, qui se
       * battraient l'une contre l'autre.
       */
      this.fadeTimer = 0;
      this.mountFrame = 0;
    }
    connectedCallback() {
      this.addEventListener("click", this.handleClick);
      this.sync();
    }
    disconnectedCallback() {
      this.removeEventListener("click", this.handleClick);
      this.stopObserving();
    }
    apply(night) {
      const root = document.documentElement;
      if (night) root.dataset[STRIP_ATTRIBUTE] = ON;
      else delete root.dataset[STRIP_ATTRIBUTE];
      void document.body.offsetHeight;
      window.requestAnimationFrame(() => {
        this.openFadeWindow();
        if (night) root.dataset.plpNight = ON;
        else delete root.dataset.plpNight;
        this.sync();
      });
      try {
        if (night) sessionStorage.setItem(STORAGE_KEY, ON);
        else sessionStorage.removeItem(STORAGE_KEY);
      } catch {
      }
      const { pathname, search, hash } = window.location;
      history.replaceState(
        history.state,
        "",
        `${pathname}${withNightParam(search, night)}${hash}`
      );
    }
    /** Aligne visuels, `aria-pressed` et observateur sur l'état de `<html>`. */
    sync() {
      const root = document.documentElement;
      const night = root.dataset.plpNight === ON;
      if (night) root.dataset[STRIP_ATTRIBUTE] = ON;
      else delete root.dataset[STRIP_ATTRIBUTE];
      if (night) {
        mountNightFigures();
        this.startObserving();
      } else {
        this.stopObserving();
      }
      this.querySelectorAll("[data-plp-night-value]").forEach(
        (button) => {
          const isNightButton = button.dataset.plpNightValue === "night";
          button.setAttribute("aria-pressed", String(isNightButton === night));
        }
      );
    }
    /**
     * Autorise les transitions le temps d'une bascule, puis les retire.
     *
     * Le retrait est ce qui rend instantanées toutes les bascules d'attribut qui
     * ne viennent PAS d'un clic — le script de boot à l'arrivée sur `?night=on`,
     * et les figures montées sur les cartes ajoutées ensuite.
     */
    openFadeWindow() {
      document.documentElement.dataset[FADE_ATTRIBUTE] = "";
      window.clearTimeout(this.fadeTimer);
      this.fadeTimer = window.setTimeout(() => {
        delete document.documentElement.dataset[FADE_ATTRIBUTE];
      }, fadeWindowMs());
    }
    startObserving() {
      if (this.observer) return;
      this.observer = new MutationObserver(() => this.scheduleMount());
      this.observer.observe(document.body, { childList: true, subtree: true });
    }
    /**
     * Regroupe les remontages en une seule passe par frame.
     *
     * L'observateur écoute `document.body` en `subtree` : il voit donc TOUTE
     * mutation de la page tant que la nuit est active — header, tiroir panier,
     * re-rendu Algolia. Chaque notification relançait un `querySelectorAll` sur
     * l'intégralité de la grille. Et un montage en produit lui-même autant que de
     * cartes ajoutées : « Voir plus » sur 48 cartes, c'était 48 notifications donc
     * 48 balayages complets, pour un seul et même travail.
     */
    scheduleMount() {
      if (this.mountFrame) return;
      this.mountFrame = requestAnimationFrame(() => {
        this.mountFrame = 0;
        mountNightFigures();
      });
    }
    stopObserving() {
      this.observer?.disconnect();
      this.observer = null;
      window.cancelAnimationFrame(this.mountFrame);
      this.mountFrame = 0;
      stopMountingOnScroll();
    }
  };
  if (!customElements.get("plp-night-toggle")) {
    customElements.define("plp-night-toggle", PlpNightToggle);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["plp-view-toggle"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/plp-view-toggle/plp-view-toggle.ts — do not edit directly.
// src/snippets/plp-view-toggle/plp-view-toggle.ts
"use strict";
(() => {
  // src/snippets/plp-view-toggle/plp-view-toggle.ts
  var STORAGE_KEY = "dptq_plp_grid";
  var URL_PARAM = "grid";
  var COMPACT = "compact";
  function decodeKey(rawKey) {
    try {
      return decodeURIComponent(rawKey.replace(/\+/g, " "));
    } catch {
      return rawKey;
    }
  }
  function withGridParam(search, compact) {
    const pairs = search.replace(/^\?/, "").split("&").filter((pair) => pair && decodeKey(pair.split("=")[0]) !== URL_PARAM);
    if (compact) pairs.push(`${URL_PARAM}=${COMPACT}`);
    return pairs.length ? `?${pairs.join("&")}` : "";
  }
  var PlpViewToggle = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.handleClick = (event) => {
        const target = event.target;
        const button = target?.closest("[data-plp-grid-value]");
        if (!button || !this.contains(button)) return;
        this.transition(button.dataset.plpGridValue === COMPACT);
      };
    }
    connectedCallback() {
      this.addEventListener("click", this.handleClick);
      this.syncPressed();
    }
    disconnectedCallback() {
      this.removeEventListener("click", this.handleClick);
    }
    /**
     * Adoucit le changement de densité quand le navigateur sait le faire.
     *
     * Aucune transition CSS n'est possible sur `grid-template-columns` entre 4 et
     * 6 pistes : le nombre de pistes change, les valeurs ne sont pas interpolables.
     * View Transitions photographie l'ancien et le nouvel état et les fond l'un
     * dans l'autre — c'est le seul mécanisme qui couvre un reflow de cette nature.
     *
     * Purement décoratif : sans l'API, ou si l'utilisateur a demandé moins
     * d'animations, la bascule est instantanée et strictement équivalente.
     */
    transition(compact) {
      const start = document.startViewTransition;
      if (typeof start !== "function" || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        this.apply(compact);
        return;
      }
      start.call(document, () => this.apply(compact));
    }
    apply(compact) {
      const root = document.documentElement;
      if (compact) root.dataset.plpGrid = COMPACT;
      else delete root.dataset.plpGrid;
      this.syncPressed();
      try {
        if (compact) sessionStorage.setItem(STORAGE_KEY, COMPACT);
        else sessionStorage.removeItem(STORAGE_KEY);
      } catch {
      }
      const { pathname, search, hash } = window.location;
      history.replaceState(
        history.state,
        "",
        `${pathname}${withGridParam(search, compact)}${hash}`
      );
    }
    /**
     * `aria-pressed` est la seule source de vérité pour les technologies
     * d'assistance ; l'apparence, elle, est dérivée en CSS de `<html>`, donc elle
     * n'attend pas le chargement de ce bundle.
     */
    syncPressed() {
      const compact = document.documentElement.dataset.plpGrid === COMPACT;
      this.querySelectorAll("[data-plp-grid-value]").forEach(
        (button) => {
          const isCompactButton = button.dataset.plpGridValue === COMPACT;
          button.setAttribute("aria-pressed", String(isCompactButton === compact));
        }
      );
    }
  };
  if (!customElements.get("plp-view-toggle")) {
    customElements.define("plp-view-toggle", PlpViewToggle);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-v2"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/product-card-v2/product-card-v2.ts — do not edit directly.
  // src/snippets/product-card-v2/product-card-v2.ts
  'use strict'
  ;(() => {
    var ProductCardV2 = class extends HTMLElement {
      connectedCallback() {}
      disconnectedCallback() {}
    }
    window.customElements.get('c-product-card-v2') || window.customElements.define('c-product-card-v2', ProductCardV2)
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/product-form/product-form.ts — do not edit directly.
// src/snippets/product-form/product-form.ts
"use strict";
(() => {
  // src/shared/utils/section-render.ts
  var SECTION_PREFIX = "shopify-section-";
  function getSectionId(el) {
    if (!el?.id?.startsWith(SECTION_PREFIX)) return null;
    return el.id.slice(SECTION_PREFIX.length);
  }
  function closestSectionId(el) {
    const wrapper = el?.closest(`[id^="${SECTION_PREFIX}"]`);
    return getSectionId(wrapper);
  }
  function collectSectionIds(elements) {
    const ids = /* @__PURE__ */ new Set();
    for (const el of elements) {
      const id = closestSectionId(el);
      if (id) ids.add(id);
    }
    return [...ids];
  }
  function buildUrl(base, params) {
    const url = new URL(base ?? window.location.pathname, window.location.origin);
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.set(key, value);
    }
    return url.toString();
  }
  function withQuery(params, query) {
    if (!query) return params;
    const extra = Object.fromEntries(
      Object.entries(query).map(([k, v]) => [k, String(v)])
    );
    return { ...extra, ...params };
  }
  async function fetchSections(ids, options = {}) {
    const url = buildUrl(
      options.url,
      withQuery({ sections: ids.join(",") }, options.query)
    );
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) throw new Error(`Sections fetch ${response.status}`);
    return response.json();
  }
  async function fetchSectionHTML(id, options = {}) {
    const url = buildUrl(
      options.url,
      withQuery({ section_id: id }, options.query)
    );
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) throw new Error(`Section fetch ${response.status}`);
    return response.text();
  }
  function swapInner(html, selector) {
    const selectors = Array.isArray(selector) ? selector : [selector];
    const doc = new DOMParser().parseFromString(html, "text/html");
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((element) => {
        const source = element.dataset.id ? doc.querySelector(`${sel}[data-id="${element.dataset.id}"]`) : doc.querySelector(sel);
        if (source) element.innerHTML = source.innerHTML;
      });
    });
  }
  function swapSection(id, html) {
    const live = document.getElementById(`${SECTION_PREFIX}${id}`);
    if (!live) return;
    const doc = new DOMParser().parseFromString(html, "text/html");
    const next = doc.getElementById(`${SECTION_PREFIX}${id}`) || doc.body.firstElementChild;
    if (next instanceof HTMLElement) {
      live.replaceWith(next);
    } else {
      live.hidden = true;
    }
  }
  async function renderSections(targets, options = {}) {
    if (targets.length === 0) return;
    const map = options.sections ?? await fetchSections(
      targets.map((t) => t.id),
      options
    );
    for (const target of targets) {
      const html = map[target.id];
      if (typeof html !== "string") continue;
      if (target.selector) {
        swapInner(html, target.selector);
      } else {
        swapSection(target.id, html);
      }
    }
  }
  async function renderSection(target, options = {}) {
    const html = await fetchSectionHTML(target.id, options);
    if (target.selector) {
      swapInner(html, target.selector);
    } else {
      swapSection(target.id, html);
    }
  }

  // src/shared/cart-limit-error/cart-limit-error.ts
  var ERROR_MESSAGE_SELECTOR = "[data-cart-limit-error-message]";
  var ERROR_TEXT_SELECTOR = "[data-cart-limit-error-text]";
  var OPEN_ENGRAVING_PANEL_SELECTOR = "c-engraving-panel.is-open";
  var SEARCH_DIALOG_SELECTOR = "dialog[data-search-dialog]";
  var QUANTITY_LIMIT_PATTERNS = [
    /can'?t add more/i,
    /maximum allowed quantity/i,
    /maximum quantity/i,
    /quantity.*exceeded/i,
    /only add \d+/i
  ];
  function getErrorMessageEl() {
    return document.querySelector(ERROR_MESSAGE_SELECTOR);
  }
  function getDefaultMessage() {
    return window.cartStrings?.addToCartLimitError ?? "The maximum allowed quantity for this product has been exceeded.";
  }
  function isCartQuantityLimitError(status, description) {
    if (status !== 422) return false;
    const normalized = description.trim();
    if (normalized.length === 0) return true;
    return QUANTITY_LIMIT_PATTERNS.some((pattern) => pattern.test(normalized));
  }
  function closeOpenEngravingPanels() {
    document.querySelectorAll(OPEN_ENGRAVING_PANEL_SELECTOR).forEach((panel) => {
      ;
      panel.close();
    });
  }
  function closeHeaderSearchIfOpen() {
    const openDialogs = document.querySelectorAll(
      `${SEARCH_DIALOG_SELECTOR}[open]`
    );
    if (openDialogs.length === 0) return;
    document.documentElement.classList.remove("is-overflow-hidden");
    openDialogs.forEach((dialog) => {
      dialog.close();
    });
  }
  function showCartLimitError(message) {
    closeHeaderSearchIfOpen();
    const errorMessage = getErrorMessageEl();
    if (!errorMessage) return;
    const textEl = errorMessage.querySelector(ERROR_TEXT_SELECTOR);
    if (textEl) {
      textEl.textContent = message ?? getDefaultMessage();
    }
    errorMessage.classList.remove("hidden");
    errorMessage.removeAttribute("hidden");
    errorMessage.setAttribute("aria-hidden", "false");
    closeOpenEngravingPanels();
    window.scrollTo(0, 0);
  }
  function hideCartLimitError() {
    const errorMessage = getErrorMessageEl();
    if (!errorMessage) return;
    const textEl = errorMessage.querySelector(ERROR_TEXT_SELECTOR);
    if (textEl) {
      textEl.textContent = "";
    }
    errorMessage.classList.add("hidden");
    errorMessage.setAttribute("hidden", "");
    errorMessage.setAttribute("aria-hidden", "true");
  }

  // src/shared/cart-a11y/cart-a11y.ts
  var CART_LIVE_STATUS_ID = "cart-live-status";
  var FOCUS_ANNOUNCE_DELAY_MS = 300;
  function getOrCreateCartLiveRegion() {
    let region = document.getElementById(CART_LIVE_STATUS_ID);
    if (region instanceof HTMLElement) {
      return region;
    }
    region = document.createElement("div");
    region.id = CART_LIVE_STATUS_ID;
    region.className = "sr-only form-status";
    region.setAttribute("role", "status");
    region.setAttribute("aria-live", "polite");
    region.setAttribute("aria-atomic", "true");
    document.body.appendChild(region);
    return region;
  }
  function announceCartStatus(message, options = {}) {
    const trimmed = message.trim();
    if (!trimmed) return;
    const shouldFocus = options.focus !== false;
    const region = getOrCreateCartLiveRegion();
    if (shouldFocus) {
      region.setAttribute("aria-live", "off");
      region.setAttribute("tabindex", "-1");
      region.textContent = trimmed;
      region.focus({ preventScroll: true });
      window.setTimeout(() => {
        region.setAttribute("aria-live", "polite");
      }, FOCUS_ANNOUNCE_DELAY_MS);
      return;
    }
    region.textContent = "";
    requestAnimationFrame(() => {
      region.textContent = trimmed;
    });
  }
  function fillCartStatusTemplate(template, values) {
    let result = template;
    if (values.title !== void 0) {
      result = result.replace(/__TITLE__/g, values.title);
    }
    if (values.quantity !== void 0) {
      result = result.replace(/__QUANTITY__/g, String(values.quantity));
    }
    return result;
  }

  // src/shared/insights/algolia-insights.ts
  var ENDPOINT = "https://insights.algolia.io/1/events";
  var AGENT = "diptyque-theme";
  var TOKEN_KEY = "algolia_user_token";
  var PIXEL_CONFIG_KEY = "algolia_config";
  var PIXEL_CLICK_KEY = "algolia_analytics_clicked_objects";
  var PIXEL_CLICK_MAX = 50;
  var MAX_OBJECT_IDS = 20;
  var THEME_EMITS_ADD_TO_CART = true;
  var OBJECT_ID_SELECTOR = "[data-algolia-object-id]";
  var CLICK_HOOKS = "[data-algolia-click], [data-algolia-convert]";
  function readConfig() {
    const data = document.body?.dataset;
    if (!data?.algoliaAppId || !data.algoliaApiKey || !data.algoliaIndex) {
      return null;
    }
    return {
      appId: data.algoliaAppId,
      apiKey: data.algoliaApiKey,
      index: data.algoliaIndex
    };
  }
  function readStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  }
  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch {
    }
  }
  function randomUserToken() {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    return `anonymous-${Array.from(
      bytes,
      (byte) => byte.toString(36).padStart(2, "0")
    ).join("")}`;
  }
  var cachedUserToken = null;
  function userToken() {
    if (cachedUserToken) return cachedUserToken;
    const stored = readStorage(TOKEN_KEY);
    cachedUserToken = stored || randomUserToken();
    if (!stored) writeStorage(TOKEN_KEY, cachedUserToken);
    return cachedUserToken;
  }
  function authenticatedUserToken() {
    return document.body?.dataset.algoliaAuthenticatedUserToken || void 0;
  }
  function normalizeObjectIDs(values) {
    const ids = /* @__PURE__ */ new Set();
    for (const value of values) {
      const id = String(value ?? "").trim();
      if (id) ids.add(id);
    }
    return Array.from(ids).slice(0, MAX_OBJECT_IDS);
  }
  function send(config, event) {
    const params = new URLSearchParams({
      "X-Algolia-Application-Id": config.appId,
      "X-Algolia-API-Key": config.apiKey,
      "X-Algolia-Agent": AGENT
    });
    const url = `${ENDPOINT}?${params}`;
    const body = JSON.stringify({ events: [event] });
    if (navigator.sendBeacon?.(url, body)) return;
    void fetch(url, { method: "POST", body, keepalive: true }).catch(() => {
    });
  }
  function track(config, objectIDs, event) {
    if (objectIDs.length === 0) return;
    send(config, {
      ...event,
      index: config.index,
      objectIDs,
      userToken: userToken(),
      authenticatedUserToken: authenticatedUserToken()
    });
  }
  function writePixelConfig(config) {
    writeStorage(
      PIXEL_CONFIG_KEY,
      JSON.stringify({
        app_id: config.appId,
        search_api_key: config.apiKey,
        index_name: config.index,
        user_token: userToken()
      })
    );
  }
  function recordClickForPixel(config, objectIDs, productId) {
    const stored = readStorage(PIXEL_CLICK_KEY);
    let records = [];
    try {
      const parsed = stored ? JSON.parse(stored) : [];
      if (Array.isArray(parsed)) records = parsed;
    } catch {
      records = [];
    }
    records.push({ index: config.index, objectIDs, productId });
    writeStorage(PIXEL_CLICK_KEY, JSON.stringify(records.slice(-PIXEL_CLICK_MAX)));
  }
  function readObjectId(element) {
    const above = element?.closest(OBJECT_ID_SELECTOR);
    if (above?.dataset.algoliaObjectId) return above.dataset.algoliaObjectId;
    const inside = element?.querySelector(OBJECT_ID_SELECTOR);
    return inside?.dataset.algoliaObjectId ?? "";
  }
  function readProductId(element) {
    const above = element?.closest("[data-algolia-product-id]");
    if (above?.dataset.algoliaProductId) return above.dataset.algoliaProductId;
    const inside = element?.querySelector(
      "[data-algolia-product-id]"
    );
    return inside?.dataset.algoliaProductId ?? "";
  }
  function onDocumentClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const hook = target.closest(CLICK_HOOKS);
    if (!hook) return;
    const config = readConfig();
    if (!config) return;
    const objectIDs = normalizeObjectIDs([readObjectId(hook)]);
    if (objectIDs.length === 0) return;
    writePixelConfig(config);
    recordClickForPixel(config, objectIDs, readProductId(hook));
    if (hook.matches("[data-algolia-convert]")) return;
    track(config, objectIDs, { eventType: "click", eventName: "Product Clicked" });
  }
  function onCartAddSuccess(event) {
    if (!THEME_EMITS_ADD_TO_CART) return;
    const target = event.target;
    if (!(target instanceof Element)) return;
    const config = readConfig();
    if (!config) return;
    const objectIDs = normalizeObjectIDs([readObjectId(target)]);
    if (objectIDs.length === 0) return;
    writePixelConfig(config);
    track(config, objectIDs, {
      eventType: "conversion",
      eventSubtype: "addToCart",
      eventName: "Add To Cart"
    });
  }
  function initAlgoliaInsights() {
    if (typeof window === "undefined" || window.algoliaInsightsReady) return;
    window.algoliaInsightsReady = true;
    document.addEventListener("click", onDocumentClick, true);
    document.addEventListener("cart:add-success", onCartAddSuccess);
  }

  // src/snippets/product-form/product-form.ts
  var TECHNICAL_ERROR_PATTERN = /parameter/i;
  var STOCK_LIMIT_PATTERN = /due to availability/i;
  var DEFAULT_CART_ERROR = "There was an error while updating your cart. Please try again.";
  var CartRequestError = class extends Error {
    constructor(status, technical, lineKeys, message) {
      super(message);
      this.status = status;
      this.technical = technical;
      this.lineKeys = lineKeys;
    }
  };
  function namedLineKeys(formData) {
    return [...formData.keys()].flatMap(
      (name) => /^updates\[(.+)\]$/.exec(name)?.[1] ?? []
    );
  }
  var CProductForm = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.SELECTORS = {
        form: "form",
        submitButton: 'button[type="submit"]',
        updatesInput: 'input[name^="updates["]',
        // Champ `updates[…]` que les boutons `+` / `−` ne touchent pas : la ligne
        // cadeau, dont la quantité est fixée à 1 par le Liquid.
        qtyFixedInput: "[data-qty-fixed]",
        qtyButton: "[data-qty-btn]",
        notifyMeButton: "[data-notify-me-button]",
        notifyWidget: '.gw-float-widget[type="button"]',
        loaderId: "full-page-loader",
        cartRecommendRoot: "[data-cart-recommend-root]",
        // Section `cart-samples` : ancre stable du wrapper + les deux blocs internes.
        samplesSection: "[data-samples-section]",
        samplesRoot: "[data-cart-samples]",
        packagingRoot: "[data-cart-packaging]",
        // Targets re-render via l'Ajax Section Rendering API.
        giftLine: "[data-gift-line]",
        headerCartLink: ".header__action-link--cart",
        popupAtcContainer: "[data-popup-atc-container]",
        cartItems: "[data-cart-items]",
        // Cartes du panier, ancrées à leur clé de ligne — voir `restoreCartOrder`.
        cartLine: "[data-cart-items] [data-line-key]",
        engravingPanelCart: ".engraving-panel-container-cart",
        cartSummary: "[data-cart-summary]",
        // Wrapper `#shopify-section-…` de la section cart-summary : présent même
        // quand le panier est vide (le contenu interne, lui, est conditionné par
        // `cart.item_count`), donc plus fiable que `[data-cart-summary]` pour
        // retrouver l'id de section.
        cartSummarySection: ".section-cart-summary"
      };
      // Initialisés ici et non dans le constructeur : `readDom()` les remplit au
      // premier usage, quand les enfants et les attributs existent enfin.
      this.form = null;
      this.countCartItems = null;
      this.formId = null;
      this.btnSubmit = null;
      this.btnSubmitAlreadyInfos = null;
      this.type = null;
      this.isCart = null;
      this.itemKey = null;
      this.action = "add";
      this.errorMessages = {};
      this.quantitySnapshot = null;
      this.samplesSectionId = null;
      this.sectionsRenderSamples = [];
      this.sectionsRender = [];
      this.hasConnected = false;
      this.submitForm = async () => {
        if (!this.form) return;
        this.clearCartError();
        const hiddenElements = Array.from(
          this.form.querySelectorAll("input, select, textarea")
        ).filter(
          (el) => el.offsetParent === null && el.type !== "hidden"
        );
        hiddenElements.forEach((el) => {
          el.disabled = true;
        });
        const formData = new FormData(this.form);
        hiddenElements.forEach((el) => {
          el.disabled = false;
        });
        const config = this.fetchConfig("javascript");
        const targets = this.withGiftLineTarget(
          this.isCart ? this.getCartPageTargets() : this.sectionsRender
        );
        const sectionsParam = targets.map((target) => target.id).join(",");
        formData.set("sections", sectionsParam);
        if (this.action === "change" && this.itemKey) {
          const properties = {};
          for (const [key, value] of formData.entries()) {
            if (key.includes("properties")) {
              const propKey = key.match(/\[(.*?)\]/g)?.pop()?.replace(/[[\]]/g, "");
              if (propKey) properties[propKey] = value;
            }
          }
          config.body = JSON.stringify({
            id: this.itemKey,
            properties,
            sections: sectionsParam
          });
        } else {
          config.body = formData;
          delete config.headers["Content-Type"];
        }
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        try {
          const endpoints = {
            add: "cart/add.js",
            change: "cart/change.js",
            update: "cart/update.js",
            remove: "cart/update.js",
            // Monter d'un cran est un simple ajout, que la Cart Transform fusionne
            // avec les lignes en place. Descendre n'a pas d'endpoint — voir
            // `setVirtualSetQuantity` juste en dessous.
            add_virtual_set: "cart/add.js"
          };
          const endpoint = endpoints[this.action] ?? endpoints["add"];
          if (this.action === "set_virtual_set") {
            await this.setVirtualSetQuantity(formData, sectionsParam, targets);
            return;
          }
          const response = await fetch(
            (window.Shopify?.routes?.root || "/") + endpoint,
            config
          );
          if (!response.ok) {
            throw await this.readCartError(
              response,
              this.action === "change" && this.itemKey ? [this.itemKey] : namedLineKeys(formData)
            );
          }
          const data = await response.json();
          hideCartLimitError();
          this.quantitySnapshot = null;
          const statusAnnouncement = this.buildCartMutationAnnouncement();
          await renderSections(targets, { sections: data.sections });
          if (statusAnnouncement) {
            announceCartStatus(statusAnnouncement);
          }
          this.dispatchEvent(
            new CustomEvent("cart:add-success", {
              bubbles: true,
              detail: { data, action: this.action }
            })
          );
          if (this.isCart) {
            this.renderSampleSection();
            await this.rerenderCartRecommendSections();
          }
        } catch (error) {
          const removal = this.isLineRemoval();
          const removalAnnouncement = removal ? this.buildCartMutationAnnouncement() : null;
          this.restoreQuantitySnapshot();
          console.error(error.message);
          if (this.isCart) await this.resyncCartPage(targets);
          if (!(error instanceof CartRequestError)) return;
          if (removal && this.isCart && !this.isLineShown(this.itemKey)) {
            if (removalAnnouncement) announceCartStatus(removalAnnouncement);
            return;
          }
          this.showCartError(error);
        }
      };
    }
    /**
     * Resolves the element's children and attributes, on demand.
     *
     * This used to run in the constructor, which is the one place it cannot: a
     * custom element constructor executes at `createElement` / at the opening tag,
     * **before any child or attribute exists**. The component only ever worked
     * because its definition happened to arrive *after* the subtree was complete,
     * so the upgrade replayed the constructor on a finished element — an accident
     * of load order, not a guarantee. The day an entry point imported this module
     * eagerly, the definition landed first and every field below came out null:
     * no submit listener, and quick-buy fell back to a native POST that navigated
     * to /cart instead of adding over AJAX.
     *
     * `connectedCallback` is no better on its own — for server-rendered HTML it
     * fires on the opening tag, also before the children. So the reads happen
     * here, called from the delegated handlers at interaction time, when the
     * subtree is complete whichever way it was built.
     *
     * Idempotent and cheap; re-resolving picks up a subtree the theme editor or a
     * section re-render swapped underneath us.
     */
    readDom() {
      this.form = this.querySelector(this.SELECTORS.form);
      this.countCartItems = this.dataset.countCartItems || null;
      this.formId = this.form?.id || null;
      this.btnSubmit = this.querySelector(this.SELECTORS.submitButton);
      this.btnSubmitAlreadyInfos = document.querySelector(
        `button[form="${this.formId}"]`
      );
      this.type = this.dataset.type || null;
      this.isCart = this.dataset.isCart || (document.body.classList.contains("body--cart") ? "true" : null);
      this.itemKey = this.dataset.itemKey || null;
      this.action = this.dataset.action || "add";
      this.errorMessages = {
        error_product_gift_cart: this.dataset.errorProductGiftCart || ""
      };
      this.samplesSectionId = this.getSamplesSectionId();
      this.sectionsRenderSamples = this.samplesSectionId ? [
        {
          id: this.samplesSectionId,
          selector: [
            this.SELECTORS.samplesRoot,
            this.SELECTORS.packagingRoot
          ]
        }
      ] : [];
      this.sectionsRender = [
        { id: "header", selector: [this.SELECTORS.headerCartLink] },
        { id: "popup-add-to-cart", selector: [this.SELECTORS.popupAtcContainer] }
      ];
    }
    getSamplesSectionId() {
      const sectionChild = document.querySelector(this.SELECTORS.samplesSection);
      return closestSectionId(sectionChild);
    }
    getCartSummarySectionId() {
      return closestSectionId(
        document.querySelector(this.SELECTORS.cartSummarySection)
      ) ?? closestSectionId(document.querySelector(this.SELECTORS.cartSummary));
    }
    // Page panier éclatée en plusieurs sections empilées. Les ids sont résolus au
    // moment du submit (et non dans le constructeur) : le wrapper cart-summary
    // peut être absent ou remplacé entre deux mutations du panier, et l'id réel
    // dépend de templates/cart.json (l'éditeur de thème peut le suffixer).
    getCartPageTargets() {
      const cartSummarySectionId = this.getCartSummarySectionId();
      return [
        { id: "header", selector: [this.SELECTORS.headerCartLink] },
        { id: "popup-add-to-cart", selector: [this.SELECTORS.popupAtcContainer] },
        {
          id: "main-cart",
          selector: [this.SELECTORS.cartItems, this.SELECTORS.engravingPanelCart]
        },
        // Outer swap (pas de `selector`) : le contenu de cart-summary est gated
        // par `cart.item_count`, un inner swap ne saurait pas passer de vide à
        // non-vide (et inversement).
        ...cartSummarySectionId ? [{ id: cartSummarySectionId }] : []
      ];
    }
    /**
     * Ajoute la ligne cadeau de CE formulaire aux cibles de re-rendu.
     *
     * Un produit ouvre droit à un cadeau, et le Liquid tranche au rendu — mais
     * après un ajout, seuls le header et le popup reviennent : le formulaire
     * resté à l'écran garderait ses inputs cadeau et en servirait un second au
     * clic suivant. On redemande donc au serveur la section qui le porte, et on
     * n'en réinjecte que le conteneur `[data-gift-line]` : re-rendre la section
     * entière écraserait la variante choisie et la quantité saisie.
     *
     * La section est résolue depuis le DOM plutôt que codée en dur, parce que le
     * formulaire vit dans une douzaine de sections différentes (PDP, cross-sell,
     * barre collante, cartes produit…). Une carte rendue côté client — l'îlot
     * Algolia — n'a pas de section porteuse : `closestSectionId` répond `null` et
     * rien n'est ajouté, l'îlot ayant sa propre lecture du panier.
     */
    withGiftLineTarget(targets) {
      if (!this.form?.querySelector(this.SELECTORS.giftLine)) return targets;
      const id = closestSectionId(this);
      if (!id) return targets;
      const existing = targets.find((target) => target.id === id);
      if (!existing) {
        return [...targets, { id, selector: [this.SELECTORS.giftLine] }];
      }
      if (!existing.selector) return targets;
      const selectors = Array.isArray(existing.selector) ? existing.selector : [existing.selector];
      if (selectors.includes(this.SELECTORS.giftLine)) return targets;
      return targets.map(
        (target) => target === existing ? { ...target, selector: [...selectors, this.SELECTORS.giftLine] } : target
      );
    }
    /**
     * Every listener is delegated on the host, not on `this.form`.
     *
     * `submit`, `change`, `click` and `focusin` all bubble, so binding on the
     * element itself works whether the children were parsed from HTML (they do
     * not exist yet at this point) or built by Preact. Binding on `this.form`
     * required the form to already exist, which is precisely what could not be
     * relied on — see `readDom()`.
     */
    connectedCallback() {
      if (this.hasConnected) return;
      this.hasConnected = true;
      setTimeout(() => {
        this.readDom();
        this.initNotifyMe();
        this.checkNotifyMeHash();
      }, 0);
      this.addEventListener("submit", async (e) => {
        this.readDom();
        if (!this.form) return;
        e.preventDefault();
        if (this.btnSubmit) this.btnSubmit.setAttribute("disabled", "true");
        if (this.btnSubmitAlreadyInfos)
          this.btnSubmitAlreadyInfos.setAttribute("disabled", "true");
        const loader = document.getElementById(this.SELECTORS.loaderId);
        if (loader) loader.setAttribute("aria-hidden", "false");
        await this.submitForm();
        if (loader) loader.setAttribute("aria-hidden", "true");
        if (this.btnSubmit) this.btnSubmit.removeAttribute("disabled");
        if (this.btnSubmitAlreadyInfos)
          this.btnSubmitAlreadyInfos.removeAttribute("disabled");
      });
      this.addEventListener("focusin", (e) => {
        this.readDom();
        if (this.action !== "update") return;
        const target = e.target;
        if (target.name?.startsWith("updates[")) this.captureQuantitySnapshot();
      });
      this.addEventListener("change", (e) => {
        const target = e.target;
        if (target.name?.includes("updates[")) {
          this.readDom();
          this.form?.requestSubmit();
        }
      });
      this.addEventListener("click", (e) => {
        const button = e.target.closest(
          this.SELECTORS.qtyButton
        );
        if (!button) return;
        this.readDom();
        if (!this.form) return;
        e.preventDefault();
        const step = parseInt(button.getAttribute("data-qty-step") || "0", 10);
        const inputs = Array.from(
          this.form.querySelectorAll(
            this.SELECTORS.updatesInput
          )
        );
        const stepped = inputs.filter(
          (el) => !el.matches(this.SELECTORS.qtyFixedInput)
        );
        const fixed = inputs.filter(
          (el) => el.matches(this.SELECTORS.qtyFixedInput)
        );
        let blockedByLimit = false;
        this.captureQuantitySnapshot();
        stepped.forEach((el) => {
          const currentVal = parseInt(el.value || "0", 10);
          const maxAttr = el.getAttribute("max");
          const maxQuantity = maxAttr ? parseInt(maxAttr, 10) : Number.NaN;
          const nextVal = currentVal + step;
          if (step > 0 && Number.isFinite(maxQuantity) && nextVal > maxQuantity) {
            blockedByLimit = true;
            return;
          }
          el.value = Math.max(0, nextVal).toString();
        });
        if (blockedByLimit) {
          this.quantitySnapshot = null;
          showCartLimitError();
          return;
        }
        const parentRemains = stepped.some(
          (el) => parseInt(el.value || "0", 10) > 0
        );
        fixed.forEach((el) => {
          el.value = parentRemains ? "1" : "0";
        });
        this.form.requestSubmit();
      });
    }
    /**
     * If the product is unavailable, the form renders an `<a data-notify-me-button>` link
     * instead of a submit button. This method polls for the third-party notify-me widget
     * and proxies clicks from our button to that widget.
     */
    initNotifyMe() {
      const notifyMeBtn = this.querySelector(this.SELECTORS.notifyMeButton);
      if (!notifyMeBtn) return;
      const href = notifyMeBtn.getAttribute("href") || "";
      if (href && !href.includes("#notify-me")) {
        notifyMeBtn.setAttribute("href", `${href}#notify-me`);
      }
      const bindNotifyWidget = (retries = 20, interval = 300) => {
        const widget = document.querySelector(
          this.SELECTORS.notifyWidget
        );
        if (widget) {
          widget.style.display = "none";
          notifyMeBtn.addEventListener("click", (event) => {
            event.preventDefault();
            widget.click();
          });
        } else if (retries > 0) {
          setTimeout(() => bindNotifyWidget(retries - 1, interval), interval);
        }
      };
      bindNotifyWidget();
    }
    /**
     * When landing on a product page with `#notify-me` in the URL (e.g. from a
     * collection card), auto-open the third-party notify-me widget.
     */
    checkNotifyMeHash() {
      if (window.location.hash !== "#notify-me") return;
      const autoOpenNotifyWidget = (retries = 20, interval = 300) => {
        const widget = document.querySelector(
          this.SELECTORS.notifyWidget
        );
        if (widget) {
          widget.click();
          history.replaceState(
            null,
            "",
            window.location.pathname + window.location.search
          );
        } else if (retries > 0) {
          setTimeout(() => autoOpenNotifyWidget(retries - 1, interval), interval);
        }
      };
      autoOpenNotifyWidget();
    }
    // Re-render la section `cart-samples` via l'Ajax Section Rendering API
    // (`?section_id=`) puis swap les blocs samples + packaging. Reload complet en
    // cas d'erreur.
    async renderSampleSection() {
      try {
        for (const section of this.sectionsRenderSamples) {
          await renderSection(section);
        }
      } catch (error) {
        console.error("[CartSamples] section render error:", error);
        window.location.reload();
      }
    }
    /**
     * Puts the cart page back in line with the cart after a failed mutation.
     *
     * The page can show a cart that has moved on — a line removed from another
     * tab, a page Safari brought back from its back/forward cache. Its inputs
     * then name line keys the cart no longer has, and `cart/update.js` refuses
     * the whole payload with a 422. Left on screen, those inputs were sent again
     * by every retry, which failed the same way. Same targets as a successful
     * mutation, fetched instead of read from the response.
     *
     * The recommendations are left alone: an Algolia round-trip and a carousel
     * back at its start, for no gain. A failed fetch keeps the page as it is —
     * no reload, unlike `renderSampleSection`: offline, that would trade the
     * cart for the browser's error page.
     */
    async resyncCartPage(targets) {
      try {
        await renderSections(targets);
        for (const section of this.sectionsRenderSamples) {
          await renderSection(section);
        }
      } catch (error) {
        console.error("[Cart] resync error:", error);
      }
    }
    /** Whether this submit takes its line out of the cart: the ✕, or `−` to 0. */
    isLineRemoval() {
      if (this.action === "remove") return true;
      return this.action === "update" && this.readAnnouncedQuantity() === 0;
    }
    /** Whether the cart page shows the line of this key. True without a key. */
    isLineShown(key) {
      if (!key) return true;
      return Boolean(
        document.querySelector(
          `${this.SELECTORS.cartItems} [data-line-key="${CSS.escape(key)}"]`
        )
      );
    }
    /**
     * Whether the refused request named a line the cart no longer has: the page
     * was behind the cart, and Shopify refused the whole payload for it — in the
     * shop's language, so the key tells, not the wording. Every line but the
     * samples shows its key, gift lines included, and no form of this element
     * names a sample. Read once the page is back in line with the cart: a failed
     * resync leaves every line shown.
     */
    isStale(error) {
      if (!this.isCart) return false;
      return error.lineKeys.some((key) => !this.isLineShown(key));
    }
    /**
     * Pose le nombre de coffrets voulu : on vide la ligne, puis on la repose.
     *
     * Aucun endpoint de l'Ajax Cart API ne sait retrancher sur une ligne
     * fusionnée. Elle rapporte toujours `quantity: 1`, donc tout ce qu'on lui
     * écrit est consommé comme facteur : depuis n coffrets on n'atteint que n×k
     * ou n+m, et `n−1` est hors du domaine. Vérifié levier par levier en
     * boutique, y compris les clés de `item_components`, que Liquid rend mais que
     * `updates` refuse en 422.
     *
     * Le formulaire porte les deux moitiés côte à côte — le `updates[…] = 0` qui
     * vide la ligne, et les `items[…]` qui la reposent à la cible. On les sépare
     * ici parce qu'elles ne partent pas au même endpoint.
     *
     * L'ordre n'est pas négociable : reposer avant de vider ferait fusionner le
     * nouvel envoi avec l'ancien, et doublerait le coffret. La contrepartie est
     * assumée — si le second appel échoue, le coffret est déjà sorti du panier —
     * et n'a pas d'alternative tant que la Cart Transform fixe la quantité à 1.
     *
     * Seule la réponse du réajout porte les sections : c'est l'état final. Rendre
     * celles de la suppression ferait clignoter un panier sans le coffret.
     */
    async setVirtualSetQuantity(formData, sectionsParam, targets) {
      const removals = new FormData();
      const additions = new FormData();
      for (const [key, value] of formData.entries()) {
        if (key.startsWith("updates[")) {
          removals.append(key, value);
        } else if (key.startsWith("items[")) {
          additions.append(key, value);
        }
      }
      if (![...additions.keys()].length) {
        throw new Error("[VirtualSet] aucun items[\u2026] \xE0 reposer");
      }
      additions.set("sections", sectionsParam);
      const order = this.readCartOrder();
      const root = window.Shopify?.routes?.root || "/";
      const headers = { "X-Requested-With": "XMLHttpRequest" };
      if ([...removals.keys()].length) {
        const removed = await fetch(`${root}cart/update.js`, {
          method: "POST",
          headers,
          body: removals
        });
        if (!removed.ok) {
          throw await this.readCartError(removed, namedLineKeys(removals));
        }
      }
      const added = await fetch(`${root}cart/add.js`, {
        method: "POST",
        headers,
        body: additions
      });
      if (!added.ok) throw await this.readCartError(added);
      const data = await added.json();
      hideCartLimitError();
      this.quantitySnapshot = null;
      const statusAnnouncement = this.buildCartMutationAnnouncement();
      await renderSections(targets, { sections: data.sections });
      this.restoreCartOrder(order);
      if (statusAnnouncement) {
        announceCartStatus(statusAnnouncement);
      }
      this.dispatchEvent(
        new CustomEvent("cart:add-success", {
          bubbles: true,
          detail: { data, action: this.action }
        })
      );
      if (this.isCart) {
        this.renderSampleSection();
        await this.rerenderCartRecommendSections();
      }
    }
    /** Les clés de ligne des cartes du panier, dans l'ordre où elles s'affichent. */
    readCartOrder() {
      return [
        ...document.querySelectorAll(this.SELECTORS.cartLine)
      ].flatMap((card) => card.dataset.lineKey ? [card.dataset.lineKey] : []);
    }
    /**
     * Remet les cartes du panier dans l'ordre relevé avant l'opération.
     *
     * Second filet, et non doublon de l'épinglage que fait `main-cart` : celui-ci
     * fixe la position de la FAMILLE — les coffrets en tête, l'emballage cadeau
     * en queue — mais laisse les coffrets entre eux dans l'ordre de `cart.items`.
     * Or descendre la quantité de l'un impose de vider sa ligne pour la reposer,
     * ce qui l'envoie en fin de tableau : avec deux coffrets au panier, agir sur
     * le premier le ferait passer derrière le second.
     *
     * Rejouer l'ordre relevé au clic répare ce cas-là, que l'épinglage ne couvre
     * pas. Réordonner et non figer : personne n'est assigné à un rang, et les
     * cartes absentes du relevé — une ligne apparue entre-temps — restent après,
     * dans leur ordre courant.
     *
     * Ne survit pas à un rechargement, où l'ordre de `cart.items` reprend la
     * main. Le stabiliser demanderait de mémoriser l'ordre côté serveur.
     *
     * La clé de ligne survit au vidage-réajout : vérifié en boutique, elle est
     * identique avant et après, ce qui est ce qui rend l'appariement possible.
     */
    restoreCartOrder(order) {
      if (order.length < 2) return;
      const cards = [
        ...document.querySelectorAll(this.SELECTORS.cartLine)
      ];
      const parent = cards[0]?.parentElement;
      if (!parent) return;
      const byKey = new Map(
        cards.filter((card) => card.parentElement === parent && card.dataset.lineKey).map((card) => [card.dataset.lineKey, card])
      );
      for (const key of order) {
        const card = byKey.get(key);
        if (card) {
          parent.appendChild(card);
          byKey.delete(key);
        }
      }
      for (const card of byKey.values()) parent.appendChild(card);
    }
    /**
     * Reads a failed Cart API answer. Shown by `submitForm`, once the cart page
     * is back in line with the cart: by then the error may have nothing left to
     * report. `lineKeys`: the cart lines the request named.
     */
    async readCartError(response, lineKeys = []) {
      const errorData = await response.json().catch(() => ({}));
      const text = errorData.description || errorData.message;
      return new CartRequestError(
        response.status,
        !text || TECHNICAL_ERROR_PATTERN.test(text),
        lineKeys,
        text || `Erreur ${response.status}`
      );
    }
    /** The banner of a failed Cart API answer — never Shopify's technical wording. */
    showCartError(error) {
      const rawMessage = error.message;
      if (isCartQuantityLimitError(error.status, rawMessage) || STOCK_LIMIT_PATTERN.test(rawMessage)) {
        showCartLimitError();
        return;
      }
      const fallback = error.technical || this.isStale(error) ? this.dataset.errorMessage || DEFAULT_CART_ERROR : rawMessage;
      showCartLimitError(this.errorMessages[rawMessage] || fallback);
    }
    captureQuantitySnapshot() {
      if (!this.form || this.action !== "update") return;
      this.quantitySnapshot = /* @__PURE__ */ new Map();
      this.form.querySelectorAll(this.SELECTORS.updatesInput).forEach((input) => {
        this.quantitySnapshot.set(input.name, input.value);
      });
    }
    restoreQuantitySnapshot() {
      if (!this.form || !this.quantitySnapshot) return;
      this.form.querySelectorAll(this.SELECTORS.updatesInput).forEach((input) => {
        const saved = this.quantitySnapshot.get(input.name);
        if (saved !== void 0) input.value = saved;
      });
      this.quantitySnapshot = null;
    }
    clearCartError() {
      hideCartLimitError();
    }
    /**
     * Builds a screen-reader message for a successful cart mutation, or null when
     * another surface (ATC popup) already announces the result.
     */
    buildCartMutationAnnouncement() {
      const title = this.dataset.productTitle?.trim() || "Item";
      if (this.action === "remove") {
        const template = this.dataset.itemRemovedTemplate || "__TITLE__ removed from bag";
        return fillCartStatusTemplate(template, { title });
      }
      if (this.action === "update" || this.action === "set_virtual_set" || this.action === "add_virtual_set" && this.isCart) {
        const quantity = this.readAnnouncedQuantity();
        if (quantity === 0) {
          const removedTemplate = this.dataset.itemRemovedTemplate || "__TITLE__ removed from bag";
          return fillCartStatusTemplate(removedTemplate, { title });
        }
        if (quantity !== null) {
          const template = this.dataset.quantityUpdatedTemplate || "__TITLE__ quantity updated to __QUANTITY__";
          return fillCartStatusTemplate(template, { title, quantity });
        }
      }
      if ((this.action === "add" || this.action === "add_virtual_set") && this.isCart) {
        const template = this.dataset.itemAddedTemplate || "__TITLE__ was added to bag";
        return fillCartStatusTemplate(template, { title });
      }
      return null;
    }
    /**
     * Resolves the quantity to announce after a cart stepper mutation.
     */
    readAnnouncedQuantity() {
      if (!this.form) return null;
      if (this.action === "set_virtual_set") {
        const quantityInput = this.form.querySelector(
          'input[name^="items["][name$="[quantity]"]'
        );
        if (!quantityInput) return null;
        const value2 = parseInt(quantityInput.value, 10);
        return Number.isFinite(value2) ? value2 : null;
      }
      if (this.action === "add_virtual_set") {
        const lineRoot = this.closest("[data-line-key]");
        const displayInput = lineRoot?.querySelector(
          `${this.SELECTORS.updatesInput}:not(${this.SELECTORS.qtyFixedInput})`
        );
        if (!displayInput) return null;
        const current = parseInt(displayInput.value, 10);
        if (!Number.isFinite(current)) return null;
        return current + 1;
      }
      const updatesInput = this.form.querySelector(
        `${this.SELECTORS.updatesInput}:not(${this.SELECTORS.qtyFixedInput})`
      );
      if (!updatesInput) return null;
      const value = parseInt(updatesInput.value, 10);
      return Number.isFinite(value) ? value : null;
    }
    fetchConfig(type = "json") {
      return {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/${type}`
        }
      };
    }
    // Outer swap des sections de recommandations : on collecte les ids des
    // wrappers `#shopify-section-…` autour de chaque `[data-cart-recommend-root]`
    // puis on remplace chaque wrapper par sa version fraîche.
    async rerenderCartRecommendSections() {
      const roots = document.querySelectorAll(this.SELECTORS.cartRecommendRoot);
      const sectionIds = collectSectionIds(roots);
      if (sectionIds.length === 0) return;
      await renderSections(sectionIds.map((id) => ({ id })));
    }
    disconnectedCallback() {
    }
  };
  if (!customElements.get("c-product-form")) {
    customElements.define("c-product-form", CProductForm);
    window.addEventListener("pageshow", (event) => {
      if (event.persisted && document.body.classList.contains("body--cart")) {
        window.location.reload();
      }
    });
    const [navigation] = performance.getEntriesByType(
      "navigation"
    );
    if (navigation?.type === "back_forward" && !(navigation.transferSize > 0) && document.body.classList.contains("body--cart")) {
      window.location.reload();
    }
  }
  initAlgoliaInsights();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-images"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/product-images/product-images.ts — do not edit directly.
// src/snippets/product-images/product-images.ts
"use strict";
(() => {
  // src/shared/card-product/align-product-card-zones.ts
  var CARD_SELECTOR = ".card-product:not(.set-to-compose)";
  var ZONE_CONFIGS = [
    { selector: ".card-product__meta", cssVar: "--card-meta-min-height" },
    { selector: ".card-product__price", cssVar: "--card-price-min-height" }
  ];
  function groupIndicesByRow(tops) {
    const rows = [];
    for (const [index, top] of tops.entries()) {
      const row = rows.find((group) => {
        const first = group[0];
        return first !== void 0 && Math.abs((tops[first] ?? 0) - top) <= 1;
      });
      if (row) {
        row.push(index);
      } else {
        rows.push([index]);
      }
    }
    return rows;
  }
  function alignProductCardZones(root) {
    const cards = Array.from(root.querySelectorAll(CARD_SELECTOR));
    if (cards.length === 0) return;
    const zones = ZONE_CONFIGS.map(
      ({ selector }) => cards.map((card) => card.querySelector(selector))
    );
    for (const [zoneIndex, elements] of zones.entries()) {
      const cssVar = ZONE_CONFIGS[zoneIndex]?.cssVar;
      if (cssVar === void 0) continue;
      for (const el of elements) {
        el?.style.setProperty(cssVar, "0px");
      }
    }
    const tops = cards.map((card) => card.offsetTop);
    const heights = zones.map(
      (elements) => elements.map((el) => el?.scrollHeight ?? 0)
    );
    const rows = groupIndicesByRow(tops);
    for (const [zoneIndex, elements] of zones.entries()) {
      const cssVar = ZONE_CONFIGS[zoneIndex]?.cssVar;
      const zoneHeights = heights[zoneIndex];
      if (cssVar === void 0 || zoneHeights === void 0) continue;
      for (const row of rows) {
        let maxHeight = 0;
        for (const index of row) {
          maxHeight = Math.max(maxHeight, zoneHeights[index] ?? 0);
        }
        const value = `${String(maxHeight)}px`;
        for (const index of row) {
          elements[index]?.style.setProperty(cssVar, value);
        }
      }
    }
  }

  // src/shared/card-product/predecode-hover-visuals.ts
  var HOVER_IMAGE_SELECTOR = ".card-product_image.is-hover-active figure:nth-child(even) img";
  var NEAR_VIEWPORT_MARGIN = "400px";
  var seen = /* @__PURE__ */ new WeakSet();
  var observer = null;
  function whenIdle(task) {
    if (typeof requestIdleCallback === "function") {
      requestIdleCallback(task, { timeout: 2e3 });
      return;
    }
    window.setTimeout(task, 200);
  }
  function decodeWhenLoaded(image) {
    const decode = () => whenIdle(() => void image.decode().catch(() => {
    }));
    if (image.complete && image.naturalWidth > 0) {
      decode();
      return;
    }
    image.addEventListener("load", decode, { once: true });
  }
  function nearViewportObserver() {
    if (observer) return observer;
    if (typeof IntersectionObserver !== "function") return null;
    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          observer?.unobserve(entry.target);
          decodeWhenLoaded(entry.target);
        }
      },
      { rootMargin: NEAR_VIEWPORT_MARGIN }
    );
    return observer;
  }
  function predecodeHoverVisuals(root) {
    const images = root.querySelectorAll(HOVER_IMAGE_SELECTOR);
    if (images.length === 0) return;
    const io = nearViewportObserver();
    for (const image of images) {
      if (seen.has(image)) continue;
      seen.add(image);
      if (!io) {
        decodeWhenLoaded(image);
        continue;
      }
      io.observe(image);
    }
  }

  // src/shared/gallery_list/gallery_list.ts
  var GalleryListBase = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.embla = null;
      this.sliderToScrollMobile = "auto";
      this.sliderToScrollDesktop = "auto";
      this.parentContainer = null;
      this.viewport = null;
      this.container = null;
      this.prevButton = null;
      this.nextButton = null;
      this.progressNode = null;
      this.prevContainer = null;
      this.nextContainer = null;
      this.firstSlideObserver = null;
      this.zoneAlignObserver = null;
      this.isAligningZones = false;
      /** Dernière largeur alignée, pour ignorer les resizes en hauteur. */
      this.lastAlignedWidth = 0;
      this.onPrevClick = () => this.embla?.scrollPrev();
      this.onNextClick = () => this.embla?.scrollNext();
      this.onPrevMouseMove = (e) => this.followMouse(e, this.prevButton);
      this.onNextMouseMove = (e) => this.followMouse(e, this.nextButton);
      this.onPrevMouseLeave = () => this.resetButton(this.prevButton);
      this.onNextMouseLeave = () => this.resetButton(this.nextButton);
      /**
       * Re-equalizes card text zones; skips while a sync is already in flight.
       *
       * Ne touche PAS au `ResizeObserver` : le déconnecter ici puis le ré-`observe()`
       * en sortie relançait l'alignement à chaque frame, sans fin — `observe()` remet
       * `lastReportedSize` à zéro, donc la notification suivante était garantie. Voir
       * la garde en largeur de `bindZoneAlignment`.
       */
      this.alignZones = () => {
        if (!this.container || this.isAligningZones) return;
        this.isAligningZones = true;
        try {
          alignProductCardZones(this.container);
          predecodeHoverVisuals(this.container);
        } finally {
          this.isAligningZones = false;
        }
      };
    }
    followMouse(e, button) {
      if (!button) return;
      const container = e.currentTarget;
      const rect = container.getBoundingClientRect();
      const offsetX = e.clientX - rect.left - rect.width / 2;
      const offsetY = e.clientY - rect.top - rect.height / 2;
      button.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
    }
    resetButton(button) {
      if (!button) return;
      button.style.transform = "";
    }
    // Hook for subclasses to react to scroll events
    onScroll() {
    }
    connectedCallback() {
      this.parentContainer = this.closest("c-gallery-container");
      this.viewport = this.querySelector(".embla__viewport");
      this.container = this.querySelector(".embla__container");
      this.prevButton = this.querySelector(".embla__prev");
      this.nextButton = this.querySelector(".embla__next");
      this.progressNode = this.querySelector(".embla__progress__bar");
      this.prevContainer = this.querySelector(".container_embla__prev");
      this.nextContainer = this.querySelector(".container_embla__next");
      this.sliderToScrollMobile = this.dataset.slidesToScrollMobile || "auto";
      this.sliderToScrollDesktop = this.dataset.slidesToScrollDesktop || "auto";
      if (this.parentContainer?.classList.contains("v-slider")) {
        this.initEmbla();
        this.bindProgress();
        this.bindMouseFollow();
      }
      this.classList.remove("shimmer");
      this.bindFirstSlideAnimation();
      this.bindZoneAlignment();
    }
    /**
     * Keeps meta / price aligned across cards in a row.
     * Runs on connect, Embla reinit/resize, and container width changes. Does not
     * call embla.reInit() to avoid AutoHeight loops.
     *
     * Garde en LARGEUR : l'alignement ne dépend que de la largeur disponible et ne
     * produit que des changements de HAUTEUR. Réagir à la hauteur revenait à
     * réagir à son propre effet. Le chargement des polices, que l'observation
     * rattrapait par accident, est accroché explicitement plus bas.
     */
    bindZoneAlignment() {
      const container = this.container;
      if (!container) return;
      this.alignZones();
      this.zoneAlignObserver = new ResizeObserver((entries) => {
        const width = Math.round(entries[0]?.contentRect.width ?? 0);
        if (width === 0 || width === this.lastAlignedWidth) return;
        this.lastAlignedWidth = width;
        this.alignZones();
      });
      this.lastAlignedWidth = Math.round(container.getBoundingClientRect().width);
      this.zoneAlignObserver.observe(container);
      void document.fonts.ready.then(() => this.alignZones());
      this.embla?.on("reinit", () => this.alignZones()).on("resize", () => this.alignZones());
    }
    bindFirstSlideAnimation() {
      const firstSlide = this.querySelector(
        ".embla__slide:first-child"
      );
      if (!firstSlide) return;
      this.firstSlideObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry.isIntersecting) return;
          this.firstSlideObserver?.disconnect();
          this.firstSlideObserver = null;
          const quickBuyContainer = firstSlide.querySelector(
            ".card-product-quick-buy__container"
          );
          if (!quickBuyContainer) return;
          quickBuyContainer.classList.add("is-animate-quick-buy");
          setTimeout(
            () => quickBuyContainer.classList.remove("is-animate-quick-buy"),
            1400
          );
        },
        { threshold: 0.8 }
      );
      this.firstSlideObserver.observe(firstSlide);
    }
    bindMouseFollow() {
      this.prevContainer?.addEventListener("mousemove", this.onPrevMouseMove);
      this.prevContainer?.addEventListener("mouseleave", this.onPrevMouseLeave);
      this.nextContainer?.addEventListener("mousemove", this.onNextMouseMove);
      this.nextContainer?.addEventListener("mouseleave", this.onNextMouseLeave);
    }
    initEmbla() {
      if (!this.viewport || !this.container) return;
      this.embla = EmblaCarousel(
        this.viewport,
        {
          dragFree: false,
          active: true,
          slidesToScroll: this.sliderToScrollMobile,
          "(min-width: 1024px)": {
            active: false,
            dragFree: true,
            slidesToScroll: this.sliderToScrollDesktop
          }
        },
        [EmblaCarouselAutoHeight()]
      );
      this.prevButton?.addEventListener("click", this.onPrevClick);
      this.nextButton?.addEventListener("click", this.onNextClick);
    }
    bindProgress() {
      if (!this.embla || !this.progressNode) return;
      const progressNode = this.progressNode;
      const applyProgress = () => {
        if (!this.embla) return;
        const snapCount = this.embla.scrollSnapList().length;
        const selected = this.embla.selectedScrollSnap();
        progressNode.style.width = `${100 / snapCount}%`;
        progressNode.style.transform = `translate3d(${selected * 100}%,0px,0px)`;
        this.prevButton?.parentElement?.toggleAttribute(
          "data-disabled",
          !this.embla.canScrollPrev()
        );
        this.nextButton?.parentElement?.toggleAttribute(
          "data-disabled",
          !this.embla.canScrollNext()
        );
        this.onScroll();
      };
      applyProgress();
      this.embla.on("reinit", () => applyProgress()).on("resize", () => applyProgress()).on("scroll", () => applyProgress()).on("slidefocus", () => applyProgress());
    }
    disconnectedCallback() {
      this.zoneAlignObserver?.disconnect();
      this.zoneAlignObserver = null;
      this.lastAlignedWidth = 0;
      this.embla?.destroy();
      this.embla = null;
      this.firstSlideObserver?.disconnect();
      this.firstSlideObserver = null;
      this.prevButton?.removeEventListener("click", this.onPrevClick);
      this.nextButton?.removeEventListener("click", this.onNextClick);
      this.prevContainer?.removeEventListener("mousemove", this.onPrevMouseMove);
      this.prevContainer?.removeEventListener("mouseleave", this.onPrevMouseLeave);
      this.nextContainer?.removeEventListener("mousemove", this.onNextMouseMove);
      this.nextContainer?.removeEventListener("mouseleave", this.onNextMouseLeave);
    }
  };

  // src/snippets/product-images/product-images.ts
  var GalleryList = class extends GalleryListBase {
  };
  if (!window.customElements.get("c-gallery-list")) {
    window.customElements.define("c-gallery-list", GalleryList);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-buy"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/quick-buy/quick-buy.ts — do not edit directly.
// src/snippets/quick-buy/quick-buy.ts
"use strict";
(() => {
  // src/shared/utils/section-render.ts
  var SECTION_PREFIX = "shopify-section-";
  function getSectionId(el) {
    if (!el?.id?.startsWith(SECTION_PREFIX)) return null;
    return el.id.slice(SECTION_PREFIX.length);
  }
  function closestSectionId(el) {
    const wrapper = el?.closest(`[id^="${SECTION_PREFIX}"]`);
    return getSectionId(wrapper);
  }
  function collectSectionIds(elements) {
    const ids = /* @__PURE__ */ new Set();
    for (const el of elements) {
      const id = closestSectionId(el);
      if (id) ids.add(id);
    }
    return [...ids];
  }
  function buildUrl(base, params) {
    const url = new URL(base ?? window.location.pathname, window.location.origin);
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.set(key, value);
    }
    return url.toString();
  }
  function withQuery(params, query) {
    if (!query) return params;
    const extra = Object.fromEntries(
      Object.entries(query).map(([k, v]) => [k, String(v)])
    );
    return { ...extra, ...params };
  }
  async function fetchSections(ids, options = {}) {
    const url = buildUrl(
      options.url,
      withQuery({ sections: ids.join(",") }, options.query)
    );
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) throw new Error(`Sections fetch ${response.status}`);
    return response.json();
  }
  async function fetchSectionHTML(id, options = {}) {
    const url = buildUrl(
      options.url,
      withQuery({ section_id: id }, options.query)
    );
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) throw new Error(`Section fetch ${response.status}`);
    return response.text();
  }
  function swapInner(html, selector) {
    const selectors = Array.isArray(selector) ? selector : [selector];
    const doc = new DOMParser().parseFromString(html, "text/html");
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((element) => {
        const source = element.dataset.id ? doc.querySelector(`${sel}[data-id="${element.dataset.id}"]`) : doc.querySelector(sel);
        if (source) element.innerHTML = source.innerHTML;
      });
    });
  }
  function swapSection(id, html) {
    const live = document.getElementById(`${SECTION_PREFIX}${id}`);
    if (!live) return;
    const doc = new DOMParser().parseFromString(html, "text/html");
    const next = doc.getElementById(`${SECTION_PREFIX}${id}`) || doc.body.firstElementChild;
    if (next instanceof HTMLElement) {
      live.replaceWith(next);
    } else {
      live.hidden = true;
    }
  }
  async function renderSections(targets, options = {}) {
    if (targets.length === 0) return;
    const map = options.sections ?? await fetchSections(
      targets.map((t) => t.id),
      options
    );
    for (const target of targets) {
      const html = map[target.id];
      if (typeof html !== "string") continue;
      if (target.selector) {
        swapInner(html, target.selector);
      } else {
        swapSection(target.id, html);
      }
    }
  }
  async function renderSection(target, options = {}) {
    const html = await fetchSectionHTML(target.id, options);
    if (target.selector) {
      swapInner(html, target.selector);
    } else {
      swapSection(target.id, html);
    }
  }

  // src/shared/cart-limit-error/cart-limit-error.ts
  var ERROR_MESSAGE_SELECTOR = "[data-cart-limit-error-message]";
  var ERROR_TEXT_SELECTOR = "[data-cart-limit-error-text]";
  var OPEN_ENGRAVING_PANEL_SELECTOR = "c-engraving-panel.is-open";
  var SEARCH_DIALOG_SELECTOR = "dialog[data-search-dialog]";
  var QUANTITY_LIMIT_PATTERNS = [
    /can'?t add more/i,
    /maximum allowed quantity/i,
    /maximum quantity/i,
    /quantity.*exceeded/i,
    /only add \d+/i
  ];
  function getErrorMessageEl() {
    return document.querySelector(ERROR_MESSAGE_SELECTOR);
  }
  function getDefaultMessage() {
    return window.cartStrings?.addToCartLimitError ?? "The maximum allowed quantity for this product has been exceeded.";
  }
  function isCartQuantityLimitError(status, description) {
    if (status !== 422) return false;
    const normalized = description.trim();
    if (normalized.length === 0) return true;
    return QUANTITY_LIMIT_PATTERNS.some((pattern) => pattern.test(normalized));
  }
  function closeOpenEngravingPanels() {
    document.querySelectorAll(OPEN_ENGRAVING_PANEL_SELECTOR).forEach((panel) => {
      ;
      panel.close();
    });
  }
  function closeHeaderSearchIfOpen() {
    const openDialogs = document.querySelectorAll(
      `${SEARCH_DIALOG_SELECTOR}[open]`
    );
    if (openDialogs.length === 0) return;
    document.documentElement.classList.remove("is-overflow-hidden");
    openDialogs.forEach((dialog) => {
      dialog.close();
    });
  }
  function showCartLimitError(message) {
    closeHeaderSearchIfOpen();
    const errorMessage = getErrorMessageEl();
    if (!errorMessage) return;
    const textEl = errorMessage.querySelector(ERROR_TEXT_SELECTOR);
    if (textEl) {
      textEl.textContent = message ?? getDefaultMessage();
    }
    errorMessage.classList.remove("hidden");
    errorMessage.removeAttribute("hidden");
    errorMessage.setAttribute("aria-hidden", "false");
    closeOpenEngravingPanels();
    window.scrollTo(0, 0);
  }
  function hideCartLimitError() {
    const errorMessage = getErrorMessageEl();
    if (!errorMessage) return;
    const textEl = errorMessage.querySelector(ERROR_TEXT_SELECTOR);
    if (textEl) {
      textEl.textContent = "";
    }
    errorMessage.classList.add("hidden");
    errorMessage.setAttribute("hidden", "");
    errorMessage.setAttribute("aria-hidden", "true");
  }

  // src/shared/cart-a11y/cart-a11y.ts
  var CART_LIVE_STATUS_ID = "cart-live-status";
  var FOCUS_ANNOUNCE_DELAY_MS = 300;
  function getOrCreateCartLiveRegion() {
    let region = document.getElementById(CART_LIVE_STATUS_ID);
    if (region instanceof HTMLElement) {
      return region;
    }
    region = document.createElement("div");
    region.id = CART_LIVE_STATUS_ID;
    region.className = "sr-only form-status";
    region.setAttribute("role", "status");
    region.setAttribute("aria-live", "polite");
    region.setAttribute("aria-atomic", "true");
    document.body.appendChild(region);
    return region;
  }
  function announceCartStatus(message, options = {}) {
    const trimmed = message.trim();
    if (!trimmed) return;
    const shouldFocus = options.focus !== false;
    const region = getOrCreateCartLiveRegion();
    if (shouldFocus) {
      region.setAttribute("aria-live", "off");
      region.setAttribute("tabindex", "-1");
      region.textContent = trimmed;
      region.focus({ preventScroll: true });
      window.setTimeout(() => {
        region.setAttribute("aria-live", "polite");
      }, FOCUS_ANNOUNCE_DELAY_MS);
      return;
    }
    region.textContent = "";
    requestAnimationFrame(() => {
      region.textContent = trimmed;
    });
  }
  function fillCartStatusTemplate(template, values) {
    let result = template;
    if (values.title !== void 0) {
      result = result.replace(/__TITLE__/g, values.title);
    }
    if (values.quantity !== void 0) {
      result = result.replace(/__QUANTITY__/g, String(values.quantity));
    }
    return result;
  }

  // src/shared/insights/algolia-insights.ts
  var ENDPOINT = "https://insights.algolia.io/1/events";
  var AGENT = "diptyque-theme";
  var TOKEN_KEY = "algolia_user_token";
  var PIXEL_CONFIG_KEY = "algolia_config";
  var PIXEL_CLICK_KEY = "algolia_analytics_clicked_objects";
  var PIXEL_CLICK_MAX = 50;
  var MAX_OBJECT_IDS = 20;
  var THEME_EMITS_ADD_TO_CART = true;
  var OBJECT_ID_SELECTOR = "[data-algolia-object-id]";
  var CLICK_HOOKS = "[data-algolia-click], [data-algolia-convert]";
  function readConfig() {
    const data = document.body?.dataset;
    if (!data?.algoliaAppId || !data.algoliaApiKey || !data.algoliaIndex) {
      return null;
    }
    return {
      appId: data.algoliaAppId,
      apiKey: data.algoliaApiKey,
      index: data.algoliaIndex
    };
  }
  function readStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  }
  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch {
    }
  }
  function randomUserToken() {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    return `anonymous-${Array.from(
      bytes,
      (byte) => byte.toString(36).padStart(2, "0")
    ).join("")}`;
  }
  var cachedUserToken = null;
  function userToken() {
    if (cachedUserToken) return cachedUserToken;
    const stored = readStorage(TOKEN_KEY);
    cachedUserToken = stored || randomUserToken();
    if (!stored) writeStorage(TOKEN_KEY, cachedUserToken);
    return cachedUserToken;
  }
  function authenticatedUserToken() {
    return document.body?.dataset.algoliaAuthenticatedUserToken || void 0;
  }
  function normalizeObjectIDs(values) {
    const ids = /* @__PURE__ */ new Set();
    for (const value of values) {
      const id = String(value ?? "").trim();
      if (id) ids.add(id);
    }
    return Array.from(ids).slice(0, MAX_OBJECT_IDS);
  }
  function send(config, event) {
    const params = new URLSearchParams({
      "X-Algolia-Application-Id": config.appId,
      "X-Algolia-API-Key": config.apiKey,
      "X-Algolia-Agent": AGENT
    });
    const url = `${ENDPOINT}?${params}`;
    const body = JSON.stringify({ events: [event] });
    if (navigator.sendBeacon?.(url, body)) return;
    void fetch(url, { method: "POST", body, keepalive: true }).catch(() => {
    });
  }
  function track(config, objectIDs, event) {
    if (objectIDs.length === 0) return;
    send(config, {
      ...event,
      index: config.index,
      objectIDs,
      userToken: userToken(),
      authenticatedUserToken: authenticatedUserToken()
    });
  }
  function writePixelConfig(config) {
    writeStorage(
      PIXEL_CONFIG_KEY,
      JSON.stringify({
        app_id: config.appId,
        search_api_key: config.apiKey,
        index_name: config.index,
        user_token: userToken()
      })
    );
  }
  function recordClickForPixel(config, objectIDs, productId) {
    const stored = readStorage(PIXEL_CLICK_KEY);
    let records = [];
    try {
      const parsed = stored ? JSON.parse(stored) : [];
      if (Array.isArray(parsed)) records = parsed;
    } catch {
      records = [];
    }
    records.push({ index: config.index, objectIDs, productId });
    writeStorage(PIXEL_CLICK_KEY, JSON.stringify(records.slice(-PIXEL_CLICK_MAX)));
  }
  function readObjectId(element) {
    const above = element?.closest(OBJECT_ID_SELECTOR);
    if (above?.dataset.algoliaObjectId) return above.dataset.algoliaObjectId;
    const inside = element?.querySelector(OBJECT_ID_SELECTOR);
    return inside?.dataset.algoliaObjectId ?? "";
  }
  function readProductId(element) {
    const above = element?.closest("[data-algolia-product-id]");
    if (above?.dataset.algoliaProductId) return above.dataset.algoliaProductId;
    const inside = element?.querySelector(
      "[data-algolia-product-id]"
    );
    return inside?.dataset.algoliaProductId ?? "";
  }
  function onDocumentClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const hook = target.closest(CLICK_HOOKS);
    if (!hook) return;
    const config = readConfig();
    if (!config) return;
    const objectIDs = normalizeObjectIDs([readObjectId(hook)]);
    if (objectIDs.length === 0) return;
    writePixelConfig(config);
    recordClickForPixel(config, objectIDs, readProductId(hook));
    if (hook.matches("[data-algolia-convert]")) return;
    track(config, objectIDs, { eventType: "click", eventName: "Product Clicked" });
  }
  function onCartAddSuccess(event) {
    if (!THEME_EMITS_ADD_TO_CART) return;
    const target = event.target;
    if (!(target instanceof Element)) return;
    const config = readConfig();
    if (!config) return;
    const objectIDs = normalizeObjectIDs([readObjectId(target)]);
    if (objectIDs.length === 0) return;
    writePixelConfig(config);
    track(config, objectIDs, {
      eventType: "conversion",
      eventSubtype: "addToCart",
      eventName: "Add To Cart"
    });
  }
  function initAlgoliaInsights() {
    if (typeof window === "undefined" || window.algoliaInsightsReady) return;
    window.algoliaInsightsReady = true;
    document.addEventListener("click", onDocumentClick, true);
    document.addEventListener("cart:add-success", onCartAddSuccess);
  }

  // src/snippets/product-form/product-form.ts
  var TECHNICAL_ERROR_PATTERN = /parameter/i;
  var STOCK_LIMIT_PATTERN = /due to availability/i;
  var DEFAULT_CART_ERROR = "There was an error while updating your cart. Please try again.";
  var CartRequestError = class extends Error {
    constructor(status, technical, lineKeys, message) {
      super(message);
      this.status = status;
      this.technical = technical;
      this.lineKeys = lineKeys;
    }
  };
  function namedLineKeys(formData) {
    return [...formData.keys()].flatMap(
      (name) => /^updates\[(.+)\]$/.exec(name)?.[1] ?? []
    );
  }
  var CProductForm = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.SELECTORS = {
        form: "form",
        submitButton: 'button[type="submit"]',
        updatesInput: 'input[name^="updates["]',
        // Champ `updates[…]` que les boutons `+` / `−` ne touchent pas : la ligne
        // cadeau, dont la quantité est fixée à 1 par le Liquid.
        qtyFixedInput: "[data-qty-fixed]",
        qtyButton: "[data-qty-btn]",
        notifyMeButton: "[data-notify-me-button]",
        notifyWidget: '.gw-float-widget[type="button"]',
        loaderId: "full-page-loader",
        cartRecommendRoot: "[data-cart-recommend-root]",
        // Section `cart-samples` : ancre stable du wrapper + les deux blocs internes.
        samplesSection: "[data-samples-section]",
        samplesRoot: "[data-cart-samples]",
        packagingRoot: "[data-cart-packaging]",
        // Targets re-render via l'Ajax Section Rendering API.
        giftLine: "[data-gift-line]",
        headerCartLink: ".header__action-link--cart",
        popupAtcContainer: "[data-popup-atc-container]",
        cartItems: "[data-cart-items]",
        // Cartes du panier, ancrées à leur clé de ligne — voir `restoreCartOrder`.
        cartLine: "[data-cart-items] [data-line-key]",
        engravingPanelCart: ".engraving-panel-container-cart",
        cartSummary: "[data-cart-summary]",
        // Wrapper `#shopify-section-…` de la section cart-summary : présent même
        // quand le panier est vide (le contenu interne, lui, est conditionné par
        // `cart.item_count`), donc plus fiable que `[data-cart-summary]` pour
        // retrouver l'id de section.
        cartSummarySection: ".section-cart-summary"
      };
      // Initialisés ici et non dans le constructeur : `readDom()` les remplit au
      // premier usage, quand les enfants et les attributs existent enfin.
      this.form = null;
      this.countCartItems = null;
      this.formId = null;
      this.btnSubmit = null;
      this.btnSubmitAlreadyInfos = null;
      this.type = null;
      this.isCart = null;
      this.itemKey = null;
      this.action = "add";
      this.errorMessages = {};
      this.quantitySnapshot = null;
      this.samplesSectionId = null;
      this.sectionsRenderSamples = [];
      this.sectionsRender = [];
      this.hasConnected = false;
      this.submitForm = async () => {
        if (!this.form) return;
        this.clearCartError();
        const hiddenElements = Array.from(
          this.form.querySelectorAll("input, select, textarea")
        ).filter(
          (el) => el.offsetParent === null && el.type !== "hidden"
        );
        hiddenElements.forEach((el) => {
          el.disabled = true;
        });
        const formData = new FormData(this.form);
        hiddenElements.forEach((el) => {
          el.disabled = false;
        });
        const config = this.fetchConfig("javascript");
        const targets = this.withGiftLineTarget(
          this.isCart ? this.getCartPageTargets() : this.sectionsRender
        );
        const sectionsParam = targets.map((target) => target.id).join(",");
        formData.set("sections", sectionsParam);
        if (this.action === "change" && this.itemKey) {
          const properties = {};
          for (const [key, value] of formData.entries()) {
            if (key.includes("properties")) {
              const propKey = key.match(/\[(.*?)\]/g)?.pop()?.replace(/[[\]]/g, "");
              if (propKey) properties[propKey] = value;
            }
          }
          config.body = JSON.stringify({
            id: this.itemKey,
            properties,
            sections: sectionsParam
          });
        } else {
          config.body = formData;
          delete config.headers["Content-Type"];
        }
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        try {
          const endpoints = {
            add: "cart/add.js",
            change: "cart/change.js",
            update: "cart/update.js",
            remove: "cart/update.js",
            // Monter d'un cran est un simple ajout, que la Cart Transform fusionne
            // avec les lignes en place. Descendre n'a pas d'endpoint — voir
            // `setVirtualSetQuantity` juste en dessous.
            add_virtual_set: "cart/add.js"
          };
          const endpoint = endpoints[this.action] ?? endpoints["add"];
          if (this.action === "set_virtual_set") {
            await this.setVirtualSetQuantity(formData, sectionsParam, targets);
            return;
          }
          const response = await fetch(
            (window.Shopify?.routes?.root || "/") + endpoint,
            config
          );
          if (!response.ok) {
            throw await this.readCartError(
              response,
              this.action === "change" && this.itemKey ? [this.itemKey] : namedLineKeys(formData)
            );
          }
          const data = await response.json();
          hideCartLimitError();
          this.quantitySnapshot = null;
          const statusAnnouncement = this.buildCartMutationAnnouncement();
          await renderSections(targets, { sections: data.sections });
          if (statusAnnouncement) {
            announceCartStatus(statusAnnouncement);
          }
          this.dispatchEvent(
            new CustomEvent("cart:add-success", {
              bubbles: true,
              detail: { data, action: this.action }
            })
          );
          if (this.isCart) {
            this.renderSampleSection();
            await this.rerenderCartRecommendSections();
          }
        } catch (error) {
          const removal = this.isLineRemoval();
          const removalAnnouncement = removal ? this.buildCartMutationAnnouncement() : null;
          this.restoreQuantitySnapshot();
          console.error(error.message);
          if (this.isCart) await this.resyncCartPage(targets);
          if (!(error instanceof CartRequestError)) return;
          if (removal && this.isCart && !this.isLineShown(this.itemKey)) {
            if (removalAnnouncement) announceCartStatus(removalAnnouncement);
            return;
          }
          this.showCartError(error);
        }
      };
    }
    /**
     * Resolves the element's children and attributes, on demand.
     *
     * This used to run in the constructor, which is the one place it cannot: a
     * custom element constructor executes at `createElement` / at the opening tag,
     * **before any child or attribute exists**. The component only ever worked
     * because its definition happened to arrive *after* the subtree was complete,
     * so the upgrade replayed the constructor on a finished element — an accident
     * of load order, not a guarantee. The day an entry point imported this module
     * eagerly, the definition landed first and every field below came out null:
     * no submit listener, and quick-buy fell back to a native POST that navigated
     * to /cart instead of adding over AJAX.
     *
     * `connectedCallback` is no better on its own — for server-rendered HTML it
     * fires on the opening tag, also before the children. So the reads happen
     * here, called from the delegated handlers at interaction time, when the
     * subtree is complete whichever way it was built.
     *
     * Idempotent and cheap; re-resolving picks up a subtree the theme editor or a
     * section re-render swapped underneath us.
     */
    readDom() {
      this.form = this.querySelector(this.SELECTORS.form);
      this.countCartItems = this.dataset.countCartItems || null;
      this.formId = this.form?.id || null;
      this.btnSubmit = this.querySelector(this.SELECTORS.submitButton);
      this.btnSubmitAlreadyInfos = document.querySelector(
        `button[form="${this.formId}"]`
      );
      this.type = this.dataset.type || null;
      this.isCart = this.dataset.isCart || (document.body.classList.contains("body--cart") ? "true" : null);
      this.itemKey = this.dataset.itemKey || null;
      this.action = this.dataset.action || "add";
      this.errorMessages = {
        error_product_gift_cart: this.dataset.errorProductGiftCart || ""
      };
      this.samplesSectionId = this.getSamplesSectionId();
      this.sectionsRenderSamples = this.samplesSectionId ? [
        {
          id: this.samplesSectionId,
          selector: [
            this.SELECTORS.samplesRoot,
            this.SELECTORS.packagingRoot
          ]
        }
      ] : [];
      this.sectionsRender = [
        { id: "header", selector: [this.SELECTORS.headerCartLink] },
        { id: "popup-add-to-cart", selector: [this.SELECTORS.popupAtcContainer] }
      ];
    }
    getSamplesSectionId() {
      const sectionChild = document.querySelector(this.SELECTORS.samplesSection);
      return closestSectionId(sectionChild);
    }
    getCartSummarySectionId() {
      return closestSectionId(
        document.querySelector(this.SELECTORS.cartSummarySection)
      ) ?? closestSectionId(document.querySelector(this.SELECTORS.cartSummary));
    }
    // Page panier éclatée en plusieurs sections empilées. Les ids sont résolus au
    // moment du submit (et non dans le constructeur) : le wrapper cart-summary
    // peut être absent ou remplacé entre deux mutations du panier, et l'id réel
    // dépend de templates/cart.json (l'éditeur de thème peut le suffixer).
    getCartPageTargets() {
      const cartSummarySectionId = this.getCartSummarySectionId();
      return [
        { id: "header", selector: [this.SELECTORS.headerCartLink] },
        { id: "popup-add-to-cart", selector: [this.SELECTORS.popupAtcContainer] },
        {
          id: "main-cart",
          selector: [this.SELECTORS.cartItems, this.SELECTORS.engravingPanelCart]
        },
        // Outer swap (pas de `selector`) : le contenu de cart-summary est gated
        // par `cart.item_count`, un inner swap ne saurait pas passer de vide à
        // non-vide (et inversement).
        ...cartSummarySectionId ? [{ id: cartSummarySectionId }] : []
      ];
    }
    /**
     * Ajoute la ligne cadeau de CE formulaire aux cibles de re-rendu.
     *
     * Un produit ouvre droit à un cadeau, et le Liquid tranche au rendu — mais
     * après un ajout, seuls le header et le popup reviennent : le formulaire
     * resté à l'écran garderait ses inputs cadeau et en servirait un second au
     * clic suivant. On redemande donc au serveur la section qui le porte, et on
     * n'en réinjecte que le conteneur `[data-gift-line]` : re-rendre la section
     * entière écraserait la variante choisie et la quantité saisie.
     *
     * La section est résolue depuis le DOM plutôt que codée en dur, parce que le
     * formulaire vit dans une douzaine de sections différentes (PDP, cross-sell,
     * barre collante, cartes produit…). Une carte rendue côté client — l'îlot
     * Algolia — n'a pas de section porteuse : `closestSectionId` répond `null` et
     * rien n'est ajouté, l'îlot ayant sa propre lecture du panier.
     */
    withGiftLineTarget(targets) {
      if (!this.form?.querySelector(this.SELECTORS.giftLine)) return targets;
      const id = closestSectionId(this);
      if (!id) return targets;
      const existing = targets.find((target) => target.id === id);
      if (!existing) {
        return [...targets, { id, selector: [this.SELECTORS.giftLine] }];
      }
      if (!existing.selector) return targets;
      const selectors = Array.isArray(existing.selector) ? existing.selector : [existing.selector];
      if (selectors.includes(this.SELECTORS.giftLine)) return targets;
      return targets.map(
        (target) => target === existing ? { ...target, selector: [...selectors, this.SELECTORS.giftLine] } : target
      );
    }
    /**
     * Every listener is delegated on the host, not on `this.form`.
     *
     * `submit`, `change`, `click` and `focusin` all bubble, so binding on the
     * element itself works whether the children were parsed from HTML (they do
     * not exist yet at this point) or built by Preact. Binding on `this.form`
     * required the form to already exist, which is precisely what could not be
     * relied on — see `readDom()`.
     */
    connectedCallback() {
      if (this.hasConnected) return;
      this.hasConnected = true;
      setTimeout(() => {
        this.readDom();
        this.initNotifyMe();
        this.checkNotifyMeHash();
      }, 0);
      this.addEventListener("submit", async (e) => {
        this.readDom();
        if (!this.form) return;
        e.preventDefault();
        if (this.btnSubmit) this.btnSubmit.setAttribute("disabled", "true");
        if (this.btnSubmitAlreadyInfos)
          this.btnSubmitAlreadyInfos.setAttribute("disabled", "true");
        const loader = document.getElementById(this.SELECTORS.loaderId);
        if (loader) loader.setAttribute("aria-hidden", "false");
        await this.submitForm();
        if (loader) loader.setAttribute("aria-hidden", "true");
        if (this.btnSubmit) this.btnSubmit.removeAttribute("disabled");
        if (this.btnSubmitAlreadyInfos)
          this.btnSubmitAlreadyInfos.removeAttribute("disabled");
      });
      this.addEventListener("focusin", (e) => {
        this.readDom();
        if (this.action !== "update") return;
        const target = e.target;
        if (target.name?.startsWith("updates[")) this.captureQuantitySnapshot();
      });
      this.addEventListener("change", (e) => {
        const target = e.target;
        if (target.name?.includes("updates[")) {
          this.readDom();
          this.form?.requestSubmit();
        }
      });
      this.addEventListener("click", (e) => {
        const button = e.target.closest(
          this.SELECTORS.qtyButton
        );
        if (!button) return;
        this.readDom();
        if (!this.form) return;
        e.preventDefault();
        const step = parseInt(button.getAttribute("data-qty-step") || "0", 10);
        const inputs = Array.from(
          this.form.querySelectorAll(
            this.SELECTORS.updatesInput
          )
        );
        const stepped = inputs.filter(
          (el) => !el.matches(this.SELECTORS.qtyFixedInput)
        );
        const fixed = inputs.filter(
          (el) => el.matches(this.SELECTORS.qtyFixedInput)
        );
        let blockedByLimit = false;
        this.captureQuantitySnapshot();
        stepped.forEach((el) => {
          const currentVal = parseInt(el.value || "0", 10);
          const maxAttr = el.getAttribute("max");
          const maxQuantity = maxAttr ? parseInt(maxAttr, 10) : Number.NaN;
          const nextVal = currentVal + step;
          if (step > 0 && Number.isFinite(maxQuantity) && nextVal > maxQuantity) {
            blockedByLimit = true;
            return;
          }
          el.value = Math.max(0, nextVal).toString();
        });
        if (blockedByLimit) {
          this.quantitySnapshot = null;
          showCartLimitError();
          return;
        }
        const parentRemains = stepped.some(
          (el) => parseInt(el.value || "0", 10) > 0
        );
        fixed.forEach((el) => {
          el.value = parentRemains ? "1" : "0";
        });
        this.form.requestSubmit();
      });
    }
    /**
     * If the product is unavailable, the form renders an `<a data-notify-me-button>` link
     * instead of a submit button. This method polls for the third-party notify-me widget
     * and proxies clicks from our button to that widget.
     */
    initNotifyMe() {
      const notifyMeBtn = this.querySelector(this.SELECTORS.notifyMeButton);
      if (!notifyMeBtn) return;
      const href = notifyMeBtn.getAttribute("href") || "";
      if (href && !href.includes("#notify-me")) {
        notifyMeBtn.setAttribute("href", `${href}#notify-me`);
      }
      const bindNotifyWidget = (retries = 20, interval = 300) => {
        const widget = document.querySelector(
          this.SELECTORS.notifyWidget
        );
        if (widget) {
          widget.style.display = "none";
          notifyMeBtn.addEventListener("click", (event) => {
            event.preventDefault();
            widget.click();
          });
        } else if (retries > 0) {
          setTimeout(() => bindNotifyWidget(retries - 1, interval), interval);
        }
      };
      bindNotifyWidget();
    }
    /**
     * When landing on a product page with `#notify-me` in the URL (e.g. from a
     * collection card), auto-open the third-party notify-me widget.
     */
    checkNotifyMeHash() {
      if (window.location.hash !== "#notify-me") return;
      const autoOpenNotifyWidget = (retries = 20, interval = 300) => {
        const widget = document.querySelector(
          this.SELECTORS.notifyWidget
        );
        if (widget) {
          widget.click();
          history.replaceState(
            null,
            "",
            window.location.pathname + window.location.search
          );
        } else if (retries > 0) {
          setTimeout(() => autoOpenNotifyWidget(retries - 1, interval), interval);
        }
      };
      autoOpenNotifyWidget();
    }
    // Re-render la section `cart-samples` via l'Ajax Section Rendering API
    // (`?section_id=`) puis swap les blocs samples + packaging. Reload complet en
    // cas d'erreur.
    async renderSampleSection() {
      try {
        for (const section of this.sectionsRenderSamples) {
          await renderSection(section);
        }
      } catch (error) {
        console.error("[CartSamples] section render error:", error);
        window.location.reload();
      }
    }
    /**
     * Puts the cart page back in line with the cart after a failed mutation.
     *
     * The page can show a cart that has moved on — a line removed from another
     * tab, a page Safari brought back from its back/forward cache. Its inputs
     * then name line keys the cart no longer has, and `cart/update.js` refuses
     * the whole payload with a 422. Left on screen, those inputs were sent again
     * by every retry, which failed the same way. Same targets as a successful
     * mutation, fetched instead of read from the response.
     *
     * The recommendations are left alone: an Algolia round-trip and a carousel
     * back at its start, for no gain. A failed fetch keeps the page as it is —
     * no reload, unlike `renderSampleSection`: offline, that would trade the
     * cart for the browser's error page.
     */
    async resyncCartPage(targets) {
      try {
        await renderSections(targets);
        for (const section of this.sectionsRenderSamples) {
          await renderSection(section);
        }
      } catch (error) {
        console.error("[Cart] resync error:", error);
      }
    }
    /** Whether this submit takes its line out of the cart: the ✕, or `−` to 0. */
    isLineRemoval() {
      if (this.action === "remove") return true;
      return this.action === "update" && this.readAnnouncedQuantity() === 0;
    }
    /** Whether the cart page shows the line of this key. True without a key. */
    isLineShown(key) {
      if (!key) return true;
      return Boolean(
        document.querySelector(
          `${this.SELECTORS.cartItems} [data-line-key="${CSS.escape(key)}"]`
        )
      );
    }
    /**
     * Whether the refused request named a line the cart no longer has: the page
     * was behind the cart, and Shopify refused the whole payload for it — in the
     * shop's language, so the key tells, not the wording. Every line but the
     * samples shows its key, gift lines included, and no form of this element
     * names a sample. Read once the page is back in line with the cart: a failed
     * resync leaves every line shown.
     */
    isStale(error) {
      if (!this.isCart) return false;
      return error.lineKeys.some((key) => !this.isLineShown(key));
    }
    /**
     * Pose le nombre de coffrets voulu : on vide la ligne, puis on la repose.
     *
     * Aucun endpoint de l'Ajax Cart API ne sait retrancher sur une ligne
     * fusionnée. Elle rapporte toujours `quantity: 1`, donc tout ce qu'on lui
     * écrit est consommé comme facteur : depuis n coffrets on n'atteint que n×k
     * ou n+m, et `n−1` est hors du domaine. Vérifié levier par levier en
     * boutique, y compris les clés de `item_components`, que Liquid rend mais que
     * `updates` refuse en 422.
     *
     * Le formulaire porte les deux moitiés côte à côte — le `updates[…] = 0` qui
     * vide la ligne, et les `items[…]` qui la reposent à la cible. On les sépare
     * ici parce qu'elles ne partent pas au même endpoint.
     *
     * L'ordre n'est pas négociable : reposer avant de vider ferait fusionner le
     * nouvel envoi avec l'ancien, et doublerait le coffret. La contrepartie est
     * assumée — si le second appel échoue, le coffret est déjà sorti du panier —
     * et n'a pas d'alternative tant que la Cart Transform fixe la quantité à 1.
     *
     * Seule la réponse du réajout porte les sections : c'est l'état final. Rendre
     * celles de la suppression ferait clignoter un panier sans le coffret.
     */
    async setVirtualSetQuantity(formData, sectionsParam, targets) {
      const removals = new FormData();
      const additions = new FormData();
      for (const [key, value] of formData.entries()) {
        if (key.startsWith("updates[")) {
          removals.append(key, value);
        } else if (key.startsWith("items[")) {
          additions.append(key, value);
        }
      }
      if (![...additions.keys()].length) {
        throw new Error("[VirtualSet] aucun items[\u2026] \xE0 reposer");
      }
      additions.set("sections", sectionsParam);
      const order = this.readCartOrder();
      const root = window.Shopify?.routes?.root || "/";
      const headers = { "X-Requested-With": "XMLHttpRequest" };
      if ([...removals.keys()].length) {
        const removed = await fetch(`${root}cart/update.js`, {
          method: "POST",
          headers,
          body: removals
        });
        if (!removed.ok) {
          throw await this.readCartError(removed, namedLineKeys(removals));
        }
      }
      const added = await fetch(`${root}cart/add.js`, {
        method: "POST",
        headers,
        body: additions
      });
      if (!added.ok) throw await this.readCartError(added);
      const data = await added.json();
      hideCartLimitError();
      this.quantitySnapshot = null;
      const statusAnnouncement = this.buildCartMutationAnnouncement();
      await renderSections(targets, { sections: data.sections });
      this.restoreCartOrder(order);
      if (statusAnnouncement) {
        announceCartStatus(statusAnnouncement);
      }
      this.dispatchEvent(
        new CustomEvent("cart:add-success", {
          bubbles: true,
          detail: { data, action: this.action }
        })
      );
      if (this.isCart) {
        this.renderSampleSection();
        await this.rerenderCartRecommendSections();
      }
    }
    /** Les clés de ligne des cartes du panier, dans l'ordre où elles s'affichent. */
    readCartOrder() {
      return [
        ...document.querySelectorAll(this.SELECTORS.cartLine)
      ].flatMap((card) => card.dataset.lineKey ? [card.dataset.lineKey] : []);
    }
    /**
     * Remet les cartes du panier dans l'ordre relevé avant l'opération.
     *
     * Second filet, et non doublon de l'épinglage que fait `main-cart` : celui-ci
     * fixe la position de la FAMILLE — les coffrets en tête, l'emballage cadeau
     * en queue — mais laisse les coffrets entre eux dans l'ordre de `cart.items`.
     * Or descendre la quantité de l'un impose de vider sa ligne pour la reposer,
     * ce qui l'envoie en fin de tableau : avec deux coffrets au panier, agir sur
     * le premier le ferait passer derrière le second.
     *
     * Rejouer l'ordre relevé au clic répare ce cas-là, que l'épinglage ne couvre
     * pas. Réordonner et non figer : personne n'est assigné à un rang, et les
     * cartes absentes du relevé — une ligne apparue entre-temps — restent après,
     * dans leur ordre courant.
     *
     * Ne survit pas à un rechargement, où l'ordre de `cart.items` reprend la
     * main. Le stabiliser demanderait de mémoriser l'ordre côté serveur.
     *
     * La clé de ligne survit au vidage-réajout : vérifié en boutique, elle est
     * identique avant et après, ce qui est ce qui rend l'appariement possible.
     */
    restoreCartOrder(order) {
      if (order.length < 2) return;
      const cards = [
        ...document.querySelectorAll(this.SELECTORS.cartLine)
      ];
      const parent = cards[0]?.parentElement;
      if (!parent) return;
      const byKey = new Map(
        cards.filter((card) => card.parentElement === parent && card.dataset.lineKey).map((card) => [card.dataset.lineKey, card])
      );
      for (const key of order) {
        const card = byKey.get(key);
        if (card) {
          parent.appendChild(card);
          byKey.delete(key);
        }
      }
      for (const card of byKey.values()) parent.appendChild(card);
    }
    /**
     * Reads a failed Cart API answer. Shown by `submitForm`, once the cart page
     * is back in line with the cart: by then the error may have nothing left to
     * report. `lineKeys`: the cart lines the request named.
     */
    async readCartError(response, lineKeys = []) {
      const errorData = await response.json().catch(() => ({}));
      const text = errorData.description || errorData.message;
      return new CartRequestError(
        response.status,
        !text || TECHNICAL_ERROR_PATTERN.test(text),
        lineKeys,
        text || `Erreur ${response.status}`
      );
    }
    /** The banner of a failed Cart API answer — never Shopify's technical wording. */
    showCartError(error) {
      const rawMessage = error.message;
      if (isCartQuantityLimitError(error.status, rawMessage) || STOCK_LIMIT_PATTERN.test(rawMessage)) {
        showCartLimitError();
        return;
      }
      const fallback = error.technical || this.isStale(error) ? this.dataset.errorMessage || DEFAULT_CART_ERROR : rawMessage;
      showCartLimitError(this.errorMessages[rawMessage] || fallback);
    }
    captureQuantitySnapshot() {
      if (!this.form || this.action !== "update") return;
      this.quantitySnapshot = /* @__PURE__ */ new Map();
      this.form.querySelectorAll(this.SELECTORS.updatesInput).forEach((input) => {
        this.quantitySnapshot.set(input.name, input.value);
      });
    }
    restoreQuantitySnapshot() {
      if (!this.form || !this.quantitySnapshot) return;
      this.form.querySelectorAll(this.SELECTORS.updatesInput).forEach((input) => {
        const saved = this.quantitySnapshot.get(input.name);
        if (saved !== void 0) input.value = saved;
      });
      this.quantitySnapshot = null;
    }
    clearCartError() {
      hideCartLimitError();
    }
    /**
     * Builds a screen-reader message for a successful cart mutation, or null when
     * another surface (ATC popup) already announces the result.
     */
    buildCartMutationAnnouncement() {
      const title = this.dataset.productTitle?.trim() || "Item";
      if (this.action === "remove") {
        const template = this.dataset.itemRemovedTemplate || "__TITLE__ removed from bag";
        return fillCartStatusTemplate(template, { title });
      }
      if (this.action === "update" || this.action === "set_virtual_set" || this.action === "add_virtual_set" && this.isCart) {
        const quantity = this.readAnnouncedQuantity();
        if (quantity === 0) {
          const removedTemplate = this.dataset.itemRemovedTemplate || "__TITLE__ removed from bag";
          return fillCartStatusTemplate(removedTemplate, { title });
        }
        if (quantity !== null) {
          const template = this.dataset.quantityUpdatedTemplate || "__TITLE__ quantity updated to __QUANTITY__";
          return fillCartStatusTemplate(template, { title, quantity });
        }
      }
      if ((this.action === "add" || this.action === "add_virtual_set") && this.isCart) {
        const template = this.dataset.itemAddedTemplate || "__TITLE__ was added to bag";
        return fillCartStatusTemplate(template, { title });
      }
      return null;
    }
    /**
     * Resolves the quantity to announce after a cart stepper mutation.
     */
    readAnnouncedQuantity() {
      if (!this.form) return null;
      if (this.action === "set_virtual_set") {
        const quantityInput = this.form.querySelector(
          'input[name^="items["][name$="[quantity]"]'
        );
        if (!quantityInput) return null;
        const value2 = parseInt(quantityInput.value, 10);
        return Number.isFinite(value2) ? value2 : null;
      }
      if (this.action === "add_virtual_set") {
        const lineRoot = this.closest("[data-line-key]");
        const displayInput = lineRoot?.querySelector(
          `${this.SELECTORS.updatesInput}:not(${this.SELECTORS.qtyFixedInput})`
        );
        if (!displayInput) return null;
        const current = parseInt(displayInput.value, 10);
        if (!Number.isFinite(current)) return null;
        return current + 1;
      }
      const updatesInput = this.form.querySelector(
        `${this.SELECTORS.updatesInput}:not(${this.SELECTORS.qtyFixedInput})`
      );
      if (!updatesInput) return null;
      const value = parseInt(updatesInput.value, 10);
      return Number.isFinite(value) ? value : null;
    }
    fetchConfig(type = "json") {
      return {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/${type}`
        }
      };
    }
    // Outer swap des sections de recommandations : on collecte les ids des
    // wrappers `#shopify-section-…` autour de chaque `[data-cart-recommend-root]`
    // puis on remplace chaque wrapper par sa version fraîche.
    async rerenderCartRecommendSections() {
      const roots = document.querySelectorAll(this.SELECTORS.cartRecommendRoot);
      const sectionIds = collectSectionIds(roots);
      if (sectionIds.length === 0) return;
      await renderSections(sectionIds.map((id) => ({ id })));
    }
    disconnectedCallback() {
    }
  };
  if (!customElements.get("c-product-form")) {
    customElements.define("c-product-form", CProductForm);
    window.addEventListener("pageshow", (event) => {
      if (event.persisted && document.body.classList.contains("body--cart")) {
        window.location.reload();
      }
    });
    const [navigation] = performance.getEntriesByType(
      "navigation"
    );
    if (navigation?.type === "back_forward" && !(navigation.transferSize > 0) && document.body.classList.contains("body--cart")) {
      window.location.reload();
    }
  }
  initAlgoliaInsights();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["related-products-v2"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/related-products-v2/related-products-v2.ts — do not edit directly.
// src/snippets/related-products-v2/related-products-v2.ts
"use strict";
(() => {
  // src/shared/utils/section-render.ts
  var SECTION_PREFIX = "shopify-section-";
  function buildUrl(base, params) {
    const url = new URL(base ?? window.location.pathname, window.location.origin);
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.set(key, value);
    }
    return url.toString();
  }
  function withQuery(params, query) {
    if (!query) return params;
    const extra = Object.fromEntries(
      Object.entries(query).map(([k, v]) => [k, String(v)])
    );
    return { ...extra, ...params };
  }
  async function fetchSections(ids, options = {}) {
    const url = buildUrl(
      options.url,
      withQuery({ sections: ids.join(",") }, options.query)
    );
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) throw new Error(`Sections fetch ${response.status}`);
    return response.json();
  }
  function swapInner(html, selector) {
    const selectors = Array.isArray(selector) ? selector : [selector];
    const doc = new DOMParser().parseFromString(html, "text/html");
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((element) => {
        const source = element.dataset.id ? doc.querySelector(`${sel}[data-id="${element.dataset.id}"]`) : doc.querySelector(sel);
        if (source) element.innerHTML = source.innerHTML;
      });
    });
  }
  function swapSection(id, html) {
    const live = document.getElementById(`${SECTION_PREFIX}${id}`);
    if (!live) return;
    const doc = new DOMParser().parseFromString(html, "text/html");
    const next = doc.getElementById(`${SECTION_PREFIX}${id}`) || doc.body.firstElementChild;
    if (next instanceof HTMLElement) {
      live.replaceWith(next);
    } else {
      live.hidden = true;
    }
  }
  async function renderSections(targets, options = {}) {
    if (targets.length === 0) return;
    const map = options.sections ?? await fetchSections(
      targets.map((t) => t.id),
      options
    );
    for (const target of targets) {
      const html = map[target.id];
      if (typeof html !== "string") continue;
      if (target.selector) {
        swapInner(html, target.selector);
      } else {
        swapSection(target.id, html);
      }
    }
  }

  // src/snippets/related-products-v2/related-products-v2.ts
  var EMBLA_OPTIONS = {
    loop: false,
    dragFree: true,
    align: "start",
    watchDrag: true,
    containScroll: "trimSnaps"
  };
  var OVERFLOW_EPSILON_PX = 1;
  var ARROW_BREAKPOINTS = [
    { minWidth: 1440, maxVisibleItems: 5 },
    { minWidth: 1024, maxVisibleItems: 3 },
    { minWidth: 0, maxVisibleItems: Number.POSITIVE_INFINITY }
  ];
  function getMaxVisibleItems(windowWidthPx) {
    for (const breakpoint of ARROW_BREAKPOINTS) {
      if (windowWidthPx >= breakpoint.minWidth) {
        return breakpoint.maxVisibleItems;
      }
    }
    return Number.POSITIVE_INFINITY;
  }
  function getEmblaFactory() {
    if (typeof EmblaCarousel === "function") return EmblaCarousel;
    const fromWindow = window.EmblaCarousel;
    return typeof fromWindow === "function" ? fromWindow : null;
  }
  var RelatedProductsV2 = class extends HTMLElement {
    constructor() {
      super();
      this.relatedProducts = [];
      this.viewportNode = null;
      this.containerNode = null;
      this.emblaApi = null;
      this.sectionsRender = [];
      this.prevButton = null;
      this.nextButton = null;
      this.prevContainer = null;
      this.nextContainer = null;
      this.resizeObserver = null;
      this.lastMeasureKey = "";
      this.emblaRetryTimeoutId = 0;
      this.onPrevClick = () => {
        if (!this.getArrowState().canPrev) return;
        if (this.emblaApi?.canScrollPrev()) {
          this.emblaApi.scrollPrev();
          return;
        }
        this.ensureEmblaScroll("prev");
      };
      this.onNextClick = () => {
        if (!this.getArrowState().canNext) return;
        if (this.emblaApi?.canScrollNext()) {
          this.emblaApi.scrollNext();
          return;
        }
        this.ensureEmblaScroll("next");
      };
      this.onWindowResize = () => {
        this.syncCarousel();
      };
      this.updateButtonStates = () => {
        const { canPrev, canNext } = this.getArrowState();
        this.prevContainer?.toggleAttribute("data-disabled", !canPrev);
        this.nextContainer?.toggleAttribute("data-disabled", !canNext);
      };
      this.syncCarousel = () => {
        const state = this.measureCarouselState();
        if (!state) return;
        const {
          overflowing,
          showArrow,
          width,
          slidesWidth,
          slideCount,
          maxVisibleItems
        } = state;
        this.toggleAttribute("data-overflow", overflowing);
        this.toggleAttribute("data-arrows", showArrow);
        if (!overflowing) {
          this.destroyEmbla();
          this.lastMeasureKey = "";
          this.updateButtonStates();
          return;
        }
        const measureKey = `${width}:${slidesWidth}:${maxVisibleItems}`;
        if (!this.emblaApi) {
          this.createEmbla();
          this.lastMeasureKey = measureKey;
          this.reInitEmblaAfterLayout();
        } else if (measureKey !== this.lastMeasureKey) {
          this.lastMeasureKey = measureKey;
          this.emblaApi.reInit({ ...EMBLA_OPTIONS });
          this.updateButtonStates();
        } else {
          this.updateButtonStates();
        }
      };
      this.relatedProducts = [
        ...this.querySelectorAll("[data-related-product]")
      ];
      this.viewportNode = this.querySelector(".embla__viewport");
      this.containerNode = this.querySelector(".embla__container");
      this.prevButton = this.querySelector(".embla__prev");
      this.nextButton = this.querySelector(".embla__next");
      this.prevContainer = this.querySelector(".container_embla__prev");
      this.nextContainer = this.querySelector(".container_embla__next");
      this.sectionsRender = [
        {
          id: "main-product-v2",
          selector: [
            "[data-render-gallery-main-product]",
            "[data-render-related-product]",
            "[data-render-buy-main-product]",
            "[data-render-tuncat-description]",
            "[data-render-product-title]",
            "[data-render-reassurance-main-product]"
          ]
        },
        {
          id: "engraving-panel",
          selector: ["[data-render-engraving-panel]"]
        }
      ];
    }
    /**
     * Arrow visibility/clickability: Embla canScroll* when it has a scroll
     * range; otherwise geometry so arrows stay visible when showArrow is true.
     */
    getArrowState() {
      if (!this.hasAttribute("data-arrows")) {
        return { canPrev: false, canNext: false };
      }
      if (this.emblaApi) {
        const canPrev = this.emblaApi.canScrollPrev();
        const canNext = this.emblaApi.canScrollNext();
        if (canPrev || canNext) {
          return { canPrev, canNext };
        }
      }
      if (!this.viewportNode || !this.containerNode) {
        return { canPrev: false, canNext: true };
      }
      const viewportRect = this.viewportNode.getBoundingClientRect();
      const containerRect = this.containerNode.getBoundingClientRect();
      return {
        canPrev: containerRect.left < viewportRect.left - OVERFLOW_EPSILON_PX,
        canNext: containerRect.right > viewportRect.right + OVERFLOW_EPSILON_PX
      };
    }
    /** Remeasure Embla then scroll — fixes stale zero scroll-range. */
    ensureEmblaScroll(direction) {
      if (!this.emblaApi) {
        this.createEmbla();
      }
      if (!this.emblaApi) return;
      this.emblaApi.reInit({ ...EMBLA_OPTIONS });
      if (direction === "prev" && this.emblaApi.canScrollPrev()) {
        this.emblaApi.scrollPrev();
      }
      if (direction === "next" && this.emblaApi.canScrollNext()) {
        this.emblaApi.scrollNext();
      }
      this.updateButtonStates();
    }
    measureCarouselState() {
      if (!this.viewportNode || !this.containerNode) return null;
      const width = this.viewportNode.clientWidth;
      if (width <= 0) return null;
      const slides = this.containerNode.querySelectorAll(".embla__slide");
      const slideCount = slides.length;
      let slidesWidth = 0;
      for (const slide of slides) {
        slidesWidth += slide.offsetWidth;
      }
      const maxVisibleItems = getMaxVisibleItems(window.innerWidth);
      const enoughItems = slideCount > maxVisibleItems;
      const overflowing = slidesWidth > width + OVERFLOW_EPSILON_PX;
      const showArrow = enoughItems && overflowing;
      return {
        overflowing,
        showArrow,
        width,
        slidesWidth,
        slideCount,
        maxVisibleItems
      };
    }
    /** Flush layout then reInit so Embla sees real overflow and can scroll. */
    reInitEmblaAfterLayout() {
      if (!this.emblaApi) return;
      requestAnimationFrame(() => {
        if (!this.emblaApi || !this.hasAttribute("data-overflow")) return;
        this.emblaApi.reInit({ ...EMBLA_OPTIONS });
        this.updateButtonStates();
      });
    }
    createEmbla() {
      if (!this.viewportNode || this.emblaApi) return;
      const factory = getEmblaFactory();
      if (!factory) {
        window.clearTimeout(this.emblaRetryTimeoutId);
        this.emblaRetryTimeoutId = window.setTimeout(() => {
          this.syncCarousel();
        }, 100);
        return;
      }
      if (this.containerNode) {
        this.containerNode.style.transform = "";
        this.containerNode.style.marginInline = "";
        this.containerNode.style.width = "";
      }
      this.emblaApi = factory(this.viewportNode, { ...EMBLA_OPTIONS });
      this.prevButton?.addEventListener("click", this.onPrevClick);
      this.nextButton?.addEventListener("click", this.onNextClick);
      this.prevContainer?.addEventListener("click", this.onPrevClick);
      this.nextContainer?.addEventListener("click", this.onNextClick);
      this.emblaApi.on("select", this.updateButtonStates).on("scroll", this.updateButtonStates).on("reInit", this.updateButtonStates);
    }
    destroyEmbla() {
      window.clearTimeout(this.emblaRetryTimeoutId);
      if (this.emblaApi) {
        this.prevButton?.removeEventListener("click", this.onPrevClick);
        this.nextButton?.removeEventListener("click", this.onNextClick);
        this.prevContainer?.removeEventListener("click", this.onPrevClick);
        this.nextContainer?.removeEventListener("click", this.onNextClick);
        this.emblaApi.destroy();
        this.emblaApi = null;
      }
      if (this.containerNode) {
        this.containerNode.style.transform = "";
      }
    }
    connectedCallback() {
      this.syncCarousel();
      if (this.viewportNode) {
        this.resizeObserver = new ResizeObserver(() => {
          this.syncCarousel();
        });
        this.resizeObserver.observe(this.viewportNode);
      }
      window.addEventListener("resize", this.onWindowResize);
      window.addEventListener("load", this.onWindowResize);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.syncCarousel());
      });
      if (this.dataset.disabled === "true") return;
      this.querySelectorAll("[data-related-product]").forEach(
        (el) => {
          el.addEventListener("click", async (e) => {
            e.preventDefault();
            const url = new URL(el.href);
            history.pushState("", "", url.href);
            this.setLoading(true);
            try {
              await renderSections(this.sectionsRender, { url });
            } catch (error) {
              console.error("[RelatedProductsV2] section render failed:", error);
              window.location.reload();
              return;
            } finally {
              this.setLoading(false);
            }
          });
        }
      );
    }
    setLoading(loading) {
      document.getElementById("full-page-loader")?.setAttribute("aria-hidden", loading ? "false" : "true");
    }
    disconnectedCallback() {
      window.removeEventListener("resize", this.onWindowResize);
      window.removeEventListener("load", this.onWindowResize);
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      this.destroyEmbla();
    }
  };
  if (!window.customElements.get("c-related-products-v2")) {
    window.customElements.define("c-related-products-v2", RelatedProductsV2);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["set-to-compose-form"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/set-to-compose-form/set-to-compose-form.ts — do not edit directly.
// src/snippets/set-to-compose-form/set-to-compose-form.ts
"use strict";
(() => {
  // src/snippets/set-to-compose-form/set-to-compose-form.ts
  var COMPOSE_QUANTITY_CHANGE_EVENT = "set-to-compose:quantity-change";
  function clampToNonNegativeInteger(value) {
    const floored = Math.floor(value);
    return floored < 0 ? 0 : floored;
  }
  function getBundleSize() {
    const root = document.querySelector("c-set-to-compose-product");
    if (!root) return 0;
    return Number(root.dataset.bundleSize ?? 0);
  }
  function getAllowDuplicates() {
    const root = document.querySelector("c-set-to-compose-product");
    if (!root) return true;
    return root.dataset.allowDuplicates === "true";
  }
  function getTotalSelectedQuantity() {
    const inputs = document.querySelectorAll(
      'c-set-to-compose-form input[name="quantity"]'
    );
    let total = 0;
    for (const input of inputs) {
      total += clampToNonNegativeInteger(Number(input.value));
    }
    return total;
  }
  function syncAllIncrementDisabled() {
    const bundleSize = getBundleSize();
    if (bundleSize <= 0) return;
    const totalSelected = getTotalSelectedQuantity();
    const shouldDisableBundle = totalSelected >= bundleSize;
    const allowDuplicates = getAllowDuplicates();
    const forms = document.querySelectorAll("c-set-to-compose-form");
    for (const form of forms) {
      const incrementButton = form.querySelector(
        "button.set-to-compose-form__increment"
      );
      if (!incrementButton) continue;
      const quantityInput = form.querySelector(
        'input[name="quantity"]'
      );
      const quantity = quantityInput ? clampToNonNegativeInteger(Number(quantityInput.value)) : 0;
      const maxAttr = quantityInput?.getAttribute("max") ?? "";
      const shouldDisableStock = quantity >= Number(maxAttr);
      const shouldDisableDuplicateRule = !allowDuplicates && quantity >= 1;
      const shouldDisable = shouldDisableBundle || shouldDisableDuplicateRule || shouldDisableStock;
      incrementButton.toggleAttribute("disabled", shouldDisable);
    }
  }
  var SetToComposeForm = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.quantityInput = null;
      this.decrementButton = null;
      this.incrementButton = null;
      this.quantityValue = null;
      this.incrementQuantity = () => {
        if (!this.quantityInput) return;
        const currentQty = clampToNonNegativeInteger(
          Number(this.quantityInput.value)
        );
        const maxQuantity = this.getMaxQuantity();
        if (Number.isFinite(maxQuantity) && currentQty >= maxQuantity) {
          syncAllIncrementDisabled();
          return;
        }
        const allowDuplicates = getAllowDuplicates();
        if (!allowDuplicates && currentQty >= 1) {
          syncAllIncrementDisabled();
          return;
        }
        const bundleSize = getBundleSize();
        if (bundleSize > 0) {
          const totalSelected = getTotalSelectedQuantity();
          if (totalSelected >= bundleSize) {
            syncAllIncrementDisabled();
            return;
          }
        }
        const next = clampToNonNegativeInteger(
          Number(this.quantityInput.value) + 1
        );
        this.quantityInput.value = next.toString();
        this.syncUIFromInput();
        this.emitQuantityChange(next);
        syncAllIncrementDisabled();
      };
      this.decrementQuantity = () => {
        if (!this.quantityInput) return;
        const next = clampToNonNegativeInteger(
          Number(this.quantityInput.value) - 1
        );
        this.quantityInput.value = next.toString();
        this.syncUIFromInput();
        this.emitQuantityChange(next);
        syncAllIncrementDisabled();
      };
    }
    connectedCallback() {
      this.quantityInput = this.querySelector(
        'input[name="quantity"]'
      );
      this.quantityValue = this.querySelector(
        ".set-to-compose-form__quantity-value"
      );
      this.decrementButton = this.querySelector(
        "button.set-to-compose-form__decrement"
      );
      this.incrementButton = this.querySelector(
        "button.set-to-compose-form__increment"
      );
      this.syncUIFromInput();
      syncAllIncrementDisabled();
      this.decrementButton?.addEventListener("click", this.decrementQuantity);
      this.incrementButton?.addEventListener("click", this.incrementQuantity);
    }
    disconnectedCallback() {
      this.decrementButton?.removeEventListener("click", this.decrementQuantity);
      this.incrementButton?.removeEventListener("click", this.incrementQuantity);
    }
    getItemFromDataset() {
      const variantId = this.dataset.composeVariantId ?? "";
      const title = this.dataset.composeTitle ?? "";
      const imageUrl = this.dataset.composeImage ?? "";
      const priceCents = Number(this.dataset.composePrice ?? 0);
      if (variantId.length === 0 || title.length === 0 || imageUrl.length === 0)
        return null;
      return { variantId, title, imageUrl, priceCents };
    }
    emitQuantityChange(quantity) {
      const item = this.getItemFromDataset();
      if (!item) return;
      const detail = { item, quantity };
      document.dispatchEvent(
        new CustomEvent(
          COMPOSE_QUANTITY_CHANGE_EVENT,
          { detail }
        )
      );
    }
    syncUIFromInput() {
      if (!this.quantityInput || !this.quantityValue) return;
      const qty = clampToNonNegativeInteger(Number(this.quantityInput.value));
      this.quantityInput.value = qty.toString();
      this.quantityValue.textContent = this.quantityInput.value;
      if (qty < 1) {
        this.decrementButton?.setAttribute("disabled", "true");
      } else {
        this.decrementButton?.removeAttribute("disabled");
      }
    }
    getMaxQuantity() {
      const maxAttr = this.quantityInput?.getAttribute("max") ?? "";
      const parsed = Number(maxAttr);
      return parsed;
    }
  };
  if (!window.customElements.get("c-set-to-compose-form")) {
    window.customElements.define("c-set-to-compose-form", SetToComposeForm);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-composition-bar"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/sticky-composition-bar/sticky-composition-bar.ts — do not edit directly.
// src/snippets/sticky-composition-bar/sticky-composition-bar.ts
"use strict";
(() => {
  // src/shared/utils/section-render.ts
  var SECTION_PREFIX = "shopify-section-";
  function buildUrl(base, params) {
    const url = new URL(base ?? window.location.pathname, window.location.origin);
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.set(key, value);
    }
    return url.toString();
  }
  function withQuery(params, query) {
    if (!query) return params;
    const extra = Object.fromEntries(
      Object.entries(query).map(([k, v]) => [k, String(v)])
    );
    return { ...extra, ...params };
  }
  async function fetchSections(ids, options = {}) {
    const url = buildUrl(
      options.url,
      withQuery({ sections: ids.join(",") }, options.query)
    );
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) throw new Error(`Sections fetch ${response.status}`);
    return response.json();
  }
  function bundledSectionsParams(ids, sectionsUrl) {
    const params = { sections: ids.join(",") };
    if (sectionsUrl) params.sections_url = sectionsUrl;
    return params;
  }
  function swapInner(html, selector) {
    const selectors = Array.isArray(selector) ? selector : [selector];
    const doc = new DOMParser().parseFromString(html, "text/html");
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((element) => {
        const source = element.dataset.id ? doc.querySelector(`${sel}[data-id="${element.dataset.id}"]`) : doc.querySelector(sel);
        if (source) element.innerHTML = source.innerHTML;
      });
    });
  }
  function swapSection(id, html) {
    const live = document.getElementById(`${SECTION_PREFIX}${id}`);
    if (!live) return;
    const doc = new DOMParser().parseFromString(html, "text/html");
    const next = doc.getElementById(`${SECTION_PREFIX}${id}`) || doc.body.firstElementChild;
    if (next instanceof HTMLElement) {
      live.replaceWith(next);
    } else {
      live.hidden = true;
    }
  }
  async function renderSections(targets, options = {}) {
    if (targets.length === 0) return;
    const map = options.sections ?? await fetchSections(
      targets.map((t) => t.id),
      options
    );
    for (const target of targets) {
      const html = map[target.id];
      if (typeof html !== "string") continue;
      if (target.selector) {
        swapInner(html, target.selector);
      } else {
        swapSection(target.id, html);
      }
    }
  }

  // src/snippets/sticky-composition-bar/sticky-composition-bar.ts
  var COMPOSE_QUANTITY_CHANGE_EVENT = "set-to-compose:quantity-change";
  var SECTIONS_RENDER = [
    { id: "header", selector: [".header__action-link--cart"] },
    { id: "popup-add-to-cart", selector: ["[data-popup-atc-container]"] }
  ];
  function clampToNonNegativeInteger(value) {
    if (!Number.isFinite(value)) return 0;
    const floored = Math.floor(value);
    return floored < 0 ? 0 : floored;
  }
  function setImg(img, url, alt) {
    if (url.length === 0) {
      img.removeAttribute("src");
      img.alt = "";
      return;
    }
    img.src = url;
    img.alt = alt;
  }
  var _StickyCompositionBar = class _StickyCompositionBar extends HTMLElement {
    constructor() {
      super(...arguments);
      this.header = this.querySelector(
        ".sticky-composition-bar_header"
      );
      this.content = this.querySelector(
        ".sticky-composition-bar_content"
      );
      this.selectedCountEl = this.querySelector(
        "[data-sticky-selected-count]"
      );
      this.priceEl = this.querySelector(
        "[data-sticky-price]"
      );
      this.slotEls = Array.from(
        this.querySelectorAll("[data-sticky-slot]")
      );
      this.removeButtonsSelector = "button.sticky-composition-bar_content_item_button--remove";
      this.selectionByVariantId = /* @__PURE__ */ new Map();
      this.errorMessage = document.querySelector(
        "[data-set-to-compose-error-message]"
      );
      this.closedHeight = this.header?.clientHeight ?? 0;
      this.openHeight = (this.content?.clientHeight ?? 0) + (this.header?.clientHeight ?? 0);
      this.stickyForm = null;
      this.handleHeaderClick = () => {
        if (this.classList.contains("open")) {
          this.classList.remove("open");
        } else {
          this.classList.add("open");
        }
      };
      /** Closes the bar when a click lands on non-interactive area outside the component. */
      this.handleOutsideClick = (event) => {
        if (!this.classList.contains("open")) return;
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (this.contains(target)) return;
        const isInteractive = target.closest(_StickyCompositionBar.INTERACTIVE_SELECTOR) !== null;
        if (isInteractive) return;
        this.classList.remove("open");
      };
      this.handleQuantityChange = (event) => {
        if (!(event instanceof CustomEvent)) return;
        const detail = event.detail;
        if (!detail || typeof detail.quantity !== "number") return;
        if (!detail.item || typeof detail.item.variantId !== "string" || typeof detail.item.priceCents !== "number")
          return;
        const qty = clampToNonNegativeInteger(detail.quantity);
        const key = detail.item.variantId;
        if (qty === 0) {
          this.selectionByVariantId.delete(key);
        } else {
          const previous = this.selectionByVariantId.get(key);
          this.selectionByVariantId.set(key, {
            item: detail.item,
            quantity: qty,
            // Preserve the original insertion ordering; only update the order
            // when switching from 0 to > 0.
            updatedAt: previous ? previous.updatedAt : Date.now()
          });
        }
        if (this.buildFlatItems().length === this.slotEls.length) {
          this.handleHeaderClick();
        }
        this.render();
      };
      this.handleRemoveButtonClick = (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const removeButton = target.closest(
          this.removeButtonsSelector
        );
        if (!removeButton) return;
        const slotEl = removeButton.closest("[data-sticky-slot]");
        if (!slotEl) return;
        const variantId = slotEl.dataset.composeVariantId ?? "";
        if (variantId.length === 0) return;
        const formEl = document.querySelector(
          `c-set-to-compose-form[data-compose-variant-id="${CSS.escape(variantId)}"]`
        );
        if (!formEl) return;
        const quantityInput = formEl.querySelector(
          'input[name="quantity"]'
        );
        const decrementButton = formEl.querySelector(
          "button.set-to-compose-form__decrement"
        );
        if (!quantityInput || !decrementButton) return;
        const currentQty = clampToNonNegativeInteger(Number(quantityInput.value));
        if (currentQty <= 0) return;
        decrementButton.click();
      };
      this.handleStickySubmit = async (event) => {
        try {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          const requiredCount = this.slotEls.length;
          const bundleVariantId = this.getBundleVariantId();
          if (requiredCount <= 0 || bundleVariantId <= 0) return;
          const selectedCount = this.buildFlatItems().length;
          if (selectedCount !== requiredCount) return;
          const pricingMode = this.getPricingMode();
          const componentEntries = Array.from(this.selectionByVariantId.values());
          const computedSum = componentEntries.reduce(
            (acc, entry) => acc + entry.quantity,
            0
          );
          if (computedSum !== requiredCount) return;
          if (componentEntries.length <= 0) return;
          if (pricingMode === "fixed") {
            const components = componentEntries.map((entry) => {
              const variantIdNumber = Number(entry.item.variantId);
              if (!Number.isFinite(variantIdNumber) || variantIdNumber <= 0) {
                return null;
              }
              return {
                variantId: `gid://shopify/ProductVariant/${variantIdNumber}`,
                qty: entry.quantity
              };
            }).filter((c) => c !== null);
            if (components.length !== componentEntries.length) return;
            const body2 = {
              items: [
                {
                  id: bundleVariantId,
                  quantity: 1,
                  properties: {
                    _components: JSON.stringify(components),
                    _bundle_pricing: "fixed"
                  }
                }
              ]
            };
            await this.submitBundlePayload(body2);
            return;
          }
          const bundleId = this.generateBundleId();
          const items = [
            {
              id: bundleVariantId,
              quantity: 1,
              properties: {
                _bundle_id: bundleId,
                _bundle_role: "parent"
              }
            },
            ...componentEntries.map((entry) => {
              const variantIdNumber = Number(entry.item.variantId);
              if (!Number.isFinite(variantIdNumber) || variantIdNumber <= 0) {
                return null;
              }
              return {
                id: variantIdNumber,
                quantity: entry.quantity,
                properties: {
                  _bundle_id: bundleId,
                  _bundle_role: "child"
                }
              };
            }).filter(
              (c) => c !== null
            )
          ];
          if (items.length <= 1) return;
          const body = { items };
          await this.submitBundlePayload(body);
        } catch (error) {
          console.error("[StickyCompositionBar] handleStickySubmit failed", error);
        }
      };
    }
    syncCardSelectionIcons() {
      const icons = Array.from(
        document.querySelectorAll("[data-compose-check-variant-id]")
      );
      for (const iconWrapper of icons) {
        const variantId = iconWrapper.dataset.composeCheckVariantId ?? "";
        const isSelected = this.selectionByVariantId.has(variantId);
        iconWrapper.classList.toggle("is-selected", isSelected);
      }
    }
    getPricingMode() {
      const mode = this.dataset.pricingMode ?? "fixed";
      return mode.toLowerCase();
    }
    getBundleVariantId() {
      const raw = this.dataset.bundleVariantId;
      if (!raw) return 0;
      const parsed = Number(raw);
      if (!Number.isFinite(parsed) || parsed <= 0) return 0;
      return parsed;
    }
    generateBundleId() {
      const cryptoObj = window.crypto;
      if (cryptoObj && typeof cryptoObj.randomUUID === "function") {
        return cryptoObj.randomUUID();
      }
      const randomPart = Math.random().toString(16).slice(2);
      return `bundle_${Date.now()}_${randomPart}`;
    }
    getSubmitButton() {
      const form = document.querySelector(
        'form[id*="sticky-composition-bar-form"]'
      );
      if (!form) return null;
      return form.querySelector("[data-product-form-submit]");
    }
    connectedCallback() {
      this.style.setProperty("--closed-height", `${this.closedHeight}px`);
      this.style.setProperty("--open-height", `${this.openHeight}px`);
      this.header?.addEventListener("click", this.handleHeaderClick);
      document.addEventListener(
        COMPOSE_QUANTITY_CHANGE_EVENT,
        this.handleQuantityChange
      );
      this.content?.addEventListener("click", this.handleRemoveButtonClick);
      document.addEventListener("click", this.handleOutsideClick);
      this.stickyForm = document.querySelector(
        'form[id*="sticky-composition-bar-form"]'
      );
      this.stickyForm?.addEventListener("submit", this.handleStickySubmit, true);
      this.render();
    }
    disconnectedCallback() {
      this.header?.removeEventListener("click", this.handleHeaderClick);
      document.removeEventListener(
        COMPOSE_QUANTITY_CHANGE_EVENT,
        this.handleQuantityChange
      );
      this.content?.removeEventListener("click", this.handleRemoveButtonClick);
      document.removeEventListener("click", this.handleOutsideClick);
      this.stickyForm?.removeEventListener(
        "submit",
        this.handleStickySubmit,
        true
      );
    }
    async submitBundlePayload(body) {
      try {
        const payload = {
          ...body,
          ...bundledSectionsParams(["header", "popup-add-to-cart"])
        };
        const res = await fetch(
          `${window.Shopify?.routes?.root ?? "/"}cart/add.js`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/javascript",
              "X-Requested-With": "XMLHttpRequest"
            },
            body: JSON.stringify(payload)
          }
        );
        let data = null;
        let rawText = null;
        try {
          data = await res.json();
        } catch {
          try {
            rawText = await res.text();
          } catch {
            rawText = null;
          }
        }
        this.classList.remove("open");
        if (!res.ok) {
          window.scrollTo(0, 0);
          if (this.errorMessage && this.errorMessage.classList.contains("hidden")) {
            this.errorMessage.classList.remove("hidden");
          }
          console.error("Bundle add request failed", {
            status: res.status,
            data,
            rawText,
            requestBody: payload
          });
          return;
        }
        if (data && typeof data === "object" && data !== null) {
          const record = data;
          const statusValue = record["status"];
          if (typeof statusValue === "number" && statusValue !== 200) {
            console.error("Cart add error:", data);
            return;
          }
        }
        const sections = data && typeof data === "object" && data !== null && "sections" in data ? data.sections : null;
        await renderSections(SECTIONS_RENDER, { sections });
        document.dispatchEvent(
          new CustomEvent("cart:add-success", {
            bubbles: true,
            detail: { data, action: "add" }
          })
        );
      } catch (error) {
        console.error("Request failed:", error);
      }
    }
    buildFlatItems() {
      const entries = Array.from(this.selectionByVariantId.values()).sort(
        (a, b) => a.updatedAt - b.updatedAt
      );
      const flat = [];
      for (const entry of entries) {
        for (let i = 0; i < entry.quantity; i += 1) {
          flat.push(entry.item);
        }
      }
      return flat;
    }
    renderSelectedCount(count) {
      if (!this.selectedCountEl) return;
      this.selectedCountEl.textContent = count.toString();
    }
    renderSlots(items) {
      const max = this.slotEls.length;
      const clamped = items.slice(0, max);
      for (let i = 0; i < max; i += 1) {
        const slotEl = this.slotEls[i];
        const img = slotEl.querySelector("img");
        const title = slotEl.querySelectorAll(
          ".sticky-composition-bar_content_item_title-text"
        );
        const item = clamped[i];
        if (!img || !title) continue;
        if (!item) {
          setImg(img, "", "");
          title.forEach((t) => t.textContent = "");
          slotEl.classList.remove("has-content");
          delete slotEl.dataset.composeVariantId;
          continue;
        }
        setImg(img, item.imageUrl, item.title);
        title.forEach((t) => t.textContent = item.title);
        slotEl.classList.add("has-content");
        slotEl.dataset.composeVariantId = item.variantId;
      }
      this.openHeight = (this.content?.clientHeight ?? 0) + (this.header?.clientHeight ?? 0);
      this.style.setProperty("--open-height", `${this.openHeight}px`);
    }
    render() {
      const flat = this.buildFlatItems();
      this.renderSelectedCount(flat.length);
      this.renderSlots(flat);
      this.syncSubmitDisabled(flat.length);
      this.syncDynamicPrice(flat);
      this.syncCardSelectionIcons();
    }
    syncSubmitDisabled(selectedCount) {
      const submitButton = this.getSubmitButton();
      if (!submitButton) return;
      const requiredCount = this.slotEls.length;
      const isEnabled = selectedCount === requiredCount && requiredCount > 0;
      submitButton.toggleAttribute("disabled", !isEnabled);
    }
    syncDynamicPrice(items) {
      if (!this.priceEl) return;
      if (this.getPricingMode() !== "dynamic") return;
      const totalCents = items.reduce((acc, item) => acc + item.priceCents, 0);
      this.priceEl.textContent = (totalCents / 100).toString();
    }
  };
  _StickyCompositionBar.INTERACTIVE_SELECTOR = "a, button, input";
  var StickyCompositionBar = _StickyCompositionBar;
  if (!window.customElements.get("c-sticky-composition-bar")) {
    window.customElements.define("c-sticky-composition-bar", StickyCompositionBar);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["story-list"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/snippets/story-list/story-list.ts — do not edit directly.
// src/snippets/story-list/story-list.ts
"use strict";
(() => {
  // src/snippets/story-list/story-list.ts
  var STORY_DESKTOP_QUERY = "(min-width: 1024px)";
  var REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";
  var VISIBILITY_RATIO = 0.25;
  var VISIBILITY_HEIGHT_RATIO = 0.5;
  var THRESHOLDS = Array.from({ length: 21 }, (_, i) => i / 20);
  var HOLD_DELAY = 220;
  var MOVE_TOLERANCE = 10;
  var TAP_PREV_ZONE = 0.3;
  var TAP_NEXT_ZONE = 0.7;
  var SOUND_EVENT = "story-list:sound";
  var STALL_TIMEOUT = 8e3;
  function cleanLabel(value) {
    return value && !value.includes("Translation missing") ? value : null;
  }
  var StoryList = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.current = 0;
      this.count = 0;
      this.regime = "timed";
      this.autoLoop = false;
      /** Pause explicite : un aller-retour hors du viewport ne doit pas relancer. */
      this.userPaused = false;
      this.holdPaused = false;
      /**
       * Focus sur un lien de carte. Sans cette pause, le segment se masque sous le
       * focus, qui retombe sur `<body>` : l'utilisateur au clavier est éjecté en
       * haut de page au milieu de sa lecture.
       */
      this.focusPaused = false;
      /** `play()` refusé par le navigateur — sinon la barre avancerait sans image. */
      this.playBlocked = false;
      this.inView = false;
      /** Onglet en arrière-plan : une animation CSS, elle, continuerait d'avancer. */
      this.tabHidden = document.hidden;
      this.finished = false;
      /** Source de vérité du son : `video.muted` est réécrit à chaque montage. */
      this.muted = true;
      this.stage = null;
      this.activeVideo = null;
      this.observer = null;
      this.desktopQuery = null;
      this.listeners = null;
      /** Recréé à chaque segment : les écouteurs média meurent avec leur segment. */
      this.segmentListeners = null;
      this.holdTimer = null;
      // ── Horloge du régime vidéo ───────────────────────────────────────────────
      this.frameHandle = null;
      this.lastFrameAt = 0;
      this.lastVideoTime = -1;
      this.stalledFor = 0;
      /** Segments consécutifs sautés faute de média jouable. */
      this.failures = 0;
      this.tickProgress = (now) => {
        this.frameHandle = null;
        const video = this.activeVideo;
        if (!video) return;
        const elapsed = now - this.lastFrameAt;
        this.lastFrameAt = now;
        if (video.paused) {
          this.stalledFor = 0;
        } else if (video.currentTime === this.lastVideoTime) {
          this.stalledFor += elapsed;
          if (this.stalledFor >= STALL_TIMEOUT) {
            this.skipSegment();
            return;
          }
        } else {
          this.lastVideoTime = video.currentTime;
          this.stalledFor = 0;
          this.failures = 0;
        }
        if (video.duration && Number.isFinite(video.duration)) {
          const progress = Math.min(video.currentTime / video.duration, 1);
          this.setProp("--story-progress", progress.toFixed(4));
        }
        this.frameHandle = window.requestAnimationFrame(this.tickProgress);
      };
      this.handleMediaEnded = () => {
        if (this.regime !== "media") return;
        this.failures = 0;
        this.handleSegmentEnd();
      };
      this.handleMediaError = () => {
        if (this.regime !== "media") return;
        this.skipSegment();
      };
      this.handleAnimationEnd = (event) => {
        if (this.regime !== "timed") return;
        if (event.animationName !== "story-fill") return;
        const bar = event.target?.closest(
          "[data-story-bar]"
        );
        if (!bar || bar.dataset.storyBar !== String(this.current)) return;
        this.failures = 0;
        this.handleSegmentEnd();
      };
      this.handleForeignSound = (event) => {
        const { source } = event.detail ?? {};
        if (source === this) return;
        this.setMuted(true);
      };
      // ── Viewport et breakpoint ────────────────────────────────────────────────
      this.handleVisibility = (entries) => {
        const entry = entries[entries.length - 1];
        if (!entry) return;
        const tallEnough = entry.intersectionRect.height >= window.innerHeight * VISIBILITY_HEIGHT_RATIO;
        const visible = entry.isIntersecting && (entry.intersectionRatio >= VISIBILITY_RATIO || tallEnough);
        if (visible === this.inView) return;
        this.inView = visible;
        this.tuneBuffering(this.current);
        this.syncPlayback();
        this.syncControls();
      };
      this.handleFocusIn = (event) => {
        const inCards = event.target?.closest(
          ".story-list__cards"
        );
        if (!inCards || this.focusPaused) return;
        this.focusPaused = true;
        this.syncPlayback();
        this.syncControls();
      };
      this.handleFocusOut = (event) => {
        if (!this.focusPaused) return;
        const to = event.relatedTarget;
        if (to?.closest(".story-list__cards")) return;
        this.focusPaused = false;
        this.syncPlayback();
        this.syncControls();
      };
      this.handleTabVisibility = () => {
        if (document.hidden === this.tabHidden) return;
        this.tabHidden = document.hidden;
        this.syncPlayback();
        this.syncControls();
      };
      this.handleBreakpoint = () => {
        if (this.finished) return;
        if (this.regime !== "media") return;
        const segment = this.segmentAt(this.current);
        const video = segment ? this.visibleVideoOf(segment) : null;
        if (!video || video === this.activeVideo) return;
        const previous = this.activeVideo;
        const at = previous?.currentTime ?? 0;
        previous?.pause();
        this.segmentListeners?.abort();
        this.segmentListeners = new AbortController();
        this.attachVideo(video, this.segmentListeners.signal);
        if (Number.isFinite(video.duration) && video.duration > 0) {
          video.currentTime = Math.min(at, video.duration);
        }
        this.lastVideoTime = -1;
        this.stalledFor = 0;
        this.syncPlayback();
      };
    }
    connectedCallback() {
      if (this.listeners) return;
      this.stage = this.querySelector("[data-story-stage]");
      this.count = this.querySelectorAll("[data-story-slot]").length;
      if (!this.stage || this.count === 0) return;
      this.autoLoop = this.dataset.autoLoop === "true";
      this.tabHidden = document.hidden;
      this.listeners = new AbortController();
      const { signal } = this.listeners;
      if (window.matchMedia(REDUCED_MOTION_QUERY).matches) this.userPaused = true;
      this.bindControls(signal);
      this.bindSurface(signal);
      this.bindKeyboard(signal);
      this.addEventListener("animationend", this.handleAnimationEnd, { signal });
      this.desktopQuery = window.matchMedia(STORY_DESKTOP_QUERY);
      this.desktopQuery.addEventListener("change", this.handleBreakpoint, {
        signal
      });
      document.addEventListener("visibilitychange", this.handleTabVisibility, {
        signal
      });
      this.addEventListener("focusin", this.handleFocusIn, { signal });
      this.addEventListener("focusout", this.handleFocusOut, { signal });
      document.addEventListener(SOUND_EVENT, this.handleForeignSound, { signal });
      this.observer = new IntersectionObserver(this.handleVisibility, {
        threshold: THRESHOLDS
      });
      this.observer.observe(this);
      this.activate(0);
      this.syncMuteControls();
      this.nameInstances();
    }
    /**
     * Appelé par CHAQUE instance et appliqué à TOUTES : la première se connecte
     * alors que la seconde n'est pas encore analysée, donc aucune ne peut se
     * nommer seule. Idempotent, la dernière connexion fixe l'état.
     */
    nameInstances() {
      const all = document.querySelectorAll("c-story-list");
      all.forEach((host, index) => {
        const base = cleanLabel(host.dataset.labelStory);
        if (!base) return;
        this.setLabel(host, all.length > 1 ? `${base} ${index + 1}` : base);
      });
    }
    disconnectedCallback() {
      this.listeners?.abort();
      this.listeners = null;
      this.segmentListeners?.abort();
      this.segmentListeners = null;
      this.observer?.disconnect();
      this.observer = null;
      this.desktopQuery = null;
      this.clearHoldTimer();
      this.stopProgressLoop();
    }
    // ── Écritures DOM idempotentes ────────────────────────────────────────────
    // Un setAttribute redondant compte comme une mutation et invalide le style.
    setHidden(el, hidden) {
      if (!el || el.hasAttribute("hidden") === hidden) return;
      if (hidden) el.setAttribute("hidden", "");
      else el.removeAttribute("hidden");
    }
    setLabel(el, label) {
      if (!el || !label || el.getAttribute("aria-label") === label) return;
      el.setAttribute("aria-label", label);
    }
    setProp(name, value) {
      if (this.style.getPropertyValue(name) === value) return;
      this.style.setProperty(name, value);
    }
    // ── Intention de lecture ──────────────────────────────────────────────────
    /**
     * L'intention, pas l'état instantané : les `pause`/`play` transitoires du
     * buffer feraient clignoter les contrôles pour rien.
     */
    get isPlayIntended() {
      return this.inView && !this.tabHidden && !this.userPaused && !this.holdPaused && !this.focusPaused && !this.playBlocked && !this.finished;
    }
    get isDesktop() {
      return this.desktopQuery ? this.desktopQuery.matches : window.matchMedia(STORY_DESKTOP_QUERY).matches;
    }
    /** Un module à un seul visuel boucle d'office : un replay n'y aurait aucun sens. */
    get loops() {
      return this.autoLoop || this.count === 1;
    }
    // ── Cycle d'un segment ────────────────────────────────────────────────────
    segmentAt(index) {
      return this.querySelector(`[data-story-slot="${index}"]`);
    }
    /**
     * On interroge la mise en page plutôt que de refaire le calcul du breakpoint
     * en JS : un seul juge du seuil, rien à resynchroniser.
     */
    visibleVideoOf(segment) {
      const variants = [
        ...segment.querySelectorAll(".story-list__variant")
      ];
      const shown = variants.find((v) => v.offsetParent !== null || v.offsetWidth > 0) ?? variants[0];
      return shown?.querySelector("video") ?? null;
    }
    activate(index) {
      if (!this.stage) return;
      this.segmentListeners?.abort();
      this.segmentListeners = new AbortController();
      const { signal } = this.segmentListeners;
      this.current = index;
      this.activeVideo = null;
      this.playBlocked = false;
      this.stopProgressLoop();
      const segment = this.segmentAt(index);
      if (!segment) return;
      this.querySelectorAll("[data-story-slot]").forEach((el) => {
        this.setHidden(el, el !== segment);
      });
      this.regime = segment.dataset.kind === "video" ? "media" : "timed";
      if (this.dataset.storyRegime !== this.regime) {
        this.dataset.storyRegime = this.regime;
      }
      this.setProp("--story-fg-desktop", segment.dataset.fgDesktop || "#ffffff");
      this.setProp(
        "--story-fg-subtle-desktop",
        segment.dataset.fgSubtleDesktop || "#c8c8c8"
      );
      this.setProp("--story-fg-mobile", segment.dataset.fgMobile || "#ffffff");
      this.setProp(
        "--story-fg-subtle-mobile",
        segment.dataset.fgSubtleMobile || "#c8c8c8"
      );
      if (this.regime === "media") {
        const video = this.visibleVideoOf(segment);
        if (!video) {
          this.skipSegment();
          return;
        }
        this.attachVideo(video, signal);
      } else {
        this.setProp("--story-duration", `${segment.dataset.duration}s`);
      }
      this.resetBars();
      this.announce();
      this.tuneBuffering(index);
      this.syncControls();
      this.syncMuteControls();
      this.syncPlayback();
    }
    attachVideo(video, signal) {
      this.activeVideo = video;
      video.loop = false;
      video.playsInline = true;
      video.muted = this.muted;
      video.preload = "auto";
      video.addEventListener("ended", this.handleMediaEnded, { signal });
      video.addEventListener("error", this.handleMediaError, { signal });
      if (video.networkState === video.NETWORK_EMPTY) video.load();
    }
    /** Le changement de segment est purement visuel : sans annonce, il n'existe pas. */
    announce() {
      const status = this.querySelector("[data-story-status]");
      if (!status) return;
      const template = cleanLabel(this.dataset.labelPosition);
      const index = String(this.current + 1);
      const text = template ? template.replace("__INDEX__", index) : `${index} / ${this.count}`;
      if (status.textContent === text) return;
      status.textContent = text;
    }
    /** Reprend le segment en scène sans le remonter : `activate()` rejouerait le média. */
    restart() {
      this.lastVideoTime = -1;
      this.stalledFor = 0;
      if (this.activeVideo) this.activeVideo.currentTime = 0;
      this.resetBars();
      this.syncControls();
      this.syncPlayback();
    }
    goTo(index) {
      const next = Math.min(Math.max(index, 0), this.count - 1);
      const wasFinished = this.finished;
      this.finished = false;
      if (next === this.current && !wasFinished && this.stage?.firstElementChild) {
        this.restart();
        return;
      }
      this.activate(next);
    }
    next() {
      if (this.current >= this.count - 1) return;
      this.goTo(this.current + 1);
    }
    prev() {
      this.goTo(this.current - 1);
    }
    handleSegmentEnd() {
      if (this.current < this.count - 1) {
        this.next();
        return;
      }
      if (this.loops) {
        this.goTo(0);
        return;
      }
      this.finish();
    }
    /**
     * Un média injouable enchaîne comme s'il s'était terminé. Le compteur garde le
     * cas limite : en boucle et sans aucun média jouable, on tournerait sans fin.
     */
    skipSegment() {
      this.failures += 1;
      if (this.failures >= this.count) {
        this.finish();
        return;
      }
      this.handleSegmentEnd();
    }
    finish() {
      this.finished = true;
      this.setProp("--story-progress", "1");
      this.querySelectorAll("[data-story-bar]").forEach((bar) => {
        bar.removeAttribute("data-story-active");
        const fill = this.fillOf(bar);
        if (fill) fill.style.transform = "scaleX(1)";
      });
      this.syncPlayback();
      this.syncControls();
    }
    replay() {
      this.goTo(0);
    }
    // ── Barres de progression ─────────────────────────────────────────────────
    fillOf(bar) {
      return bar.querySelector(".story-bar__fill");
    }
    resetBars() {
      this.setProp("--story-progress", "0");
      this.querySelectorAll("[data-story-bar]").forEach((bar) => {
        const index = Number(bar.dataset.storyBar);
        const fill = this.fillOf(bar);
        if (!fill) return;
        if (index === this.current) {
          bar.setAttribute("data-story-active", "");
          fill.style.transform = "";
          fill.style.animation = "none";
          void fill.offsetWidth;
          fill.style.animation = "";
          return;
        }
        bar.removeAttribute("data-story-active");
        const done = index < this.current;
        fill.style.animation = "none";
        fill.style.transform = done ? "scaleX(1)" : "scaleX(0)";
      });
    }
    /**
     * `timeupdate` n'émet que ~4 fois par seconde, d'où des à-coups de 250 ms face
     * au régime image. Surtout pas de transition CSS pour lisser : elle ferait
     * traîner la barre et mentirait sur le temps restant.
     */
    startProgressLoop() {
      if (this.frameHandle !== null) return;
      this.lastFrameAt = performance.now();
      this.lastVideoTime = -1;
      this.stalledFor = 0;
      this.frameHandle = window.requestAnimationFrame(this.tickProgress);
    }
    stopProgressLoop() {
      if (this.frameHandle === null) return;
      window.cancelAnimationFrame(this.frameHandle);
      this.frameHandle = null;
    }
    // ── Réconciliation ────────────────────────────────────────────────────────
    /** Unique point d'écriture de l'état de lecture. */
    syncPlayback() {
      const playing = this.isPlayIntended;
      this.setProp("--story-play-state", playing ? "running" : "paused");
      const video = this.activeVideo;
      if (playing && this.regime === "media" && video) this.startProgressLoop();
      else this.stopProgressLoop();
      if (!video) return;
      if (playing && video.paused) {
        const played = video.play();
        if (played && typeof played.catch === "function") {
          played.catch((error) => {
            if (error?.name !== "NotAllowedError") return;
            this.playBlocked = true;
            this.syncPlayback();
            this.syncControls();
          });
        }
        return;
      }
      if (!playing && !video.paused) video.pause();
    }
    syncControls() {
      const done = this.finished && !this.loops;
      const paused = !done && !this.isPlayIntended;
      this.setHidden(this.querySelector("[data-icon-play]"), !paused);
      this.setHidden(this.querySelector("[data-icon-pause]"), done || paused);
      this.setHidden(this.querySelector("[data-icon-restart]"), !done);
      let label = this.dataset.labelPause;
      if (done) label = this.dataset.labelReplay;
      else if (paused) label = this.dataset.labelPlay;
      this.setLabel(this.querySelector("[data-play-btn]"), cleanLabel(label));
      this.querySelector("[data-story-prev]")?.toggleAttribute(
        "disabled",
        this.current === 0
      );
      this.querySelector("[data-story-next]")?.toggleAttribute(
        "disabled",
        this.current === this.count - 1
      );
    }
    syncMuteControls() {
      this.setHidden(this.querySelector("[data-icon-muted]"), !this.muted);
      this.setHidden(this.querySelector("[data-icon-unmuted]"), this.muted);
      this.setLabel(
        this.querySelector("[data-mute-btn]"),
        cleanLabel(
          this.muted ? this.dataset.labelUnmute : this.dataset.labelMute
        )
      );
    }
    // ── Commandes ─────────────────────────────────────────────────────────────
    togglePlay() {
      if (this.finished) {
        this.replay();
        return;
      }
      this.userPaused = !this.userPaused;
      this.playBlocked = false;
      this.syncPlayback();
      this.syncControls();
    }
    /** Unique point d'écriture du son. */
    setMuted(muted) {
      if (this.muted === muted) return;
      this.muted = muted;
      this.querySelectorAll("video").forEach((video) => {
        video.muted = muted;
      });
      this.syncMuteControls();
    }
    toggleMute() {
      const muted = !this.muted;
      this.setMuted(muted);
      if (!muted) {
        document.dispatchEvent(
          new CustomEvent(SOUND_EVENT, { detail: { source: this } })
        );
      }
    }
    // ── Chargement ────────────────────────────────────────────────────────────
    /**
     * Répartit l'effort réseau : l'active se télécharge, la suivante s'ouvre, les
     * autres se taisent — sinon dix vidéos négocient leur connexion ensemble.
     */
    tuneBuffering(index) {
      this.querySelectorAll("[data-story-slot]").forEach(
        (segment) => {
          const rank = Number(segment.dataset.storySlot);
          const shown = this.visibleVideoOf(segment);
          segment.querySelectorAll("video").forEach((video) => {
            const wanted = video !== shown ? "none" : rank === index ? this.inView ? "auto" : "metadata" : rank === index + 1 ? this.inView ? "metadata" : "none" : "none";
            if (video === shown && wanted !== "none" && video.dataset.poster) {
              video.poster = video.dataset.poster;
              delete video.dataset.poster;
            }
            if (video.preload !== wanted) video.preload = wanted;
            if (video.muted !== this.muted) video.muted = this.muted;
            if (video !== this.activeVideo && !video.paused) video.pause();
          });
        }
      );
    }
    // ── Écouteurs ─────────────────────────────────────────────────────────────
    bindControls(signal) {
      const on = (selector, handler) => {
        this.querySelector(selector)?.addEventListener("click", handler, {
          signal
        });
      };
      on("[data-play-btn]", () => this.togglePlay());
      on("[data-mute-btn]", () => this.toggleMute());
      on("[data-story-prev]", () => this.prev());
      on("[data-story-next]", () => this.next());
    }
    clearHoldTimer() {
      if (this.holdTimer === null) return;
      window.clearTimeout(this.holdTimer);
      this.holdTimer = null;
    }
    /**
     * Une seule surface pour trois gestes : maintien = pause, tap = navigation
     * (mobile) ou lecture, et au-delà du seuil de déplacement, défilement.
     */
    bindSurface(signal) {
      const surface = this.querySelector("[data-story-surface]");
      if (!surface) return;
      let startX = 0;
      let startY = 0;
      let moved = false;
      let held = false;
      surface.addEventListener(
        "pointerdown",
        (event) => {
          if (!event.isPrimary) return;
          startX = event.clientX;
          startY = event.clientY;
          moved = false;
          held = false;
          surface.setPointerCapture(event.pointerId);
          this.clearHoldTimer();
          if (event.pointerType === "mouse") return;
          this.holdTimer = window.setTimeout(() => {
            held = true;
            this.holdPaused = true;
            this.syncPlayback();
            this.syncControls();
          }, HOLD_DELAY);
        },
        { signal }
      );
      surface.addEventListener(
        "pointermove",
        (event) => {
          if (moved) return;
          const distance = Math.hypot(
            event.clientX - startX,
            event.clientY - startY
          );
          if (distance <= MOVE_TOLERANCE) return;
          moved = true;
          this.clearHoldTimer();
        },
        { signal }
      );
      const release = (event, navigate) => {
        this.clearHoldTimer();
        if (surface.hasPointerCapture(event.pointerId)) {
          surface.releasePointerCapture(event.pointerId);
        }
        if (held) {
          held = false;
          this.holdPaused = false;
          this.syncPlayback();
          this.syncControls();
          return;
        }
        if (!navigate || moved) return;
        this.handleTap(event, surface);
      };
      surface.addEventListener(
        "pointerup",
        (event) => release(event, true),
        { signal }
      );
      surface.addEventListener(
        "pointercancel",
        (event) => release(event, false),
        { signal }
      );
    }
    handleTap(event, surface) {
      if (this.isDesktop || this.count < 2) {
        this.togglePlay();
        return;
      }
      const rect = surface.getBoundingClientRect();
      if (rect.width === 0) return;
      const ratio = (event.clientX - rect.left) / rect.width;
      if (ratio < TAP_PREV_ZONE) this.prev();
      else if (ratio > TAP_NEXT_ZONE) this.next();
      else this.togglePlay();
    }
    bindKeyboard(signal) {
      this.addEventListener(
        "keydown",
        (event) => {
          if (event.key === "ArrowLeft") {
            event.preventDefault();
            this.prev();
          } else if (event.key === "ArrowRight") {
            event.preventDefault();
            this.next();
          }
        },
        { signal }
      );
    }
  };
  if (!window.customElements.get("c-story-list")) {
    window.customElements.define("c-story-list", StoryList);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
